webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "67IX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32b1d271","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("67IX")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b54d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tGyY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - 116",
  "shortTitle": "OR 116",
  "description": "",
  "width": 727,
  "height": 900,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "https://olympicreview.touchlines.com/116/"
  }, {
    "code": "FR",
    "text": "French",
    "href": "https://revueolympique.touchlines.com/116/"
  }, {
    "code": "JP",
    "text": "Japan",
    "href": "https://olympicreview.touchlines.com/tokyo2020/"
  }],
  "basePath": "/tokyo2020",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://olympicreview.touchlines.com/tokyo2020/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 1-title\" style=\"top:4px;left:0px\" src=\"/tokyo2020/static/_content/1-title-1.png\">\n        <img class=\"halfScale 1-title\" style=\"top:156px;left:258px\" src=\"/tokyo2020/static/_content/1-title-2.png\">\n        <img class=\"halfScale 1-title\" style=\"top:163px;left:538px\" src=\"/tokyo2020/static/_content/1-title-3.png\">\n        \n        <img class=\"halfScale 1-sub\" style=\"top:239px;left:170px\" src=\"/tokyo2020/static/_content/1-sub-1.png\">\n        <img class=\"halfScale 1-sub\" style=\"top:292px;left:185px\" src=\"/tokyo2020/static/_content/1-sub-2.png\">\n\n        <img class=\"halfScale 1-logo\" \" style=\"top:840px;left:15px\" src=\"/tokyo2020/static/_content/1-logo-1.png\">\n        <div class=\"addContentLink\" style=\"top: 869px;left: 635px;height: 16px;width: 78px;\">\n          <a href=\"http://www.olympic.org/ja\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:60},{opacity:1, y:0, ease: Power2.easeOut}, 0.1, 1)\n          .staggerFromTo(cOf(\"1-sub\"), 0.6, {opacity:0, x:80},{opacity:1, x:0, ease: Power2.easeOut}, 0.1, \"-=0.3\")\n          .fromTo(cOf(\"1-logo\"), 0.6, {opacity:0, y:80},{opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "| オリ ン ピ ッ ク ・ ム ー プ メン ト 定 期 刊行 物 © REVIEW オリ ン ピ ッ クレ ビュ ー #StrongerTogether  東京 2020 オ リン ピッ ク 競 技 大 A ID 年 を 乗り 越え 、 スポ ー ツ を 通し て 世界 に 団結 を も た らし ます 選手 た ち が 、 オ リン ピッ ク 腕 技 大 会 の 延期 に 際 し 、 直 面 し た 数 々 の 試練 の 道のり を レポ ー ト  月 23 日 か ら 8 月 8 日 まで の 期間 、 東 京 で 注目 し た い 競技 お よび 会 場 の ガイ ド  建 期 か ら 得 た 教 証 、 そ し て 前 向き な 解決 策 を 生み 出す オリ ン ピ ッ ク ・ ム ー ブ メ ント の 取り 組み を ご 紹介  の の ! olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 4-title\" style=\"top:115px;left:44px\" src=\"/tokyo2020/static/_content/4-title-1.png\">\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7)\" style=\"top: 369px; left: 48px; height: 102px; width: 112px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8)\" style=\"top: 719px; left: 48px; height: 105px; width: 142px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(18)\" style=\"top: 388px; left: 215px; height: 125px; width: 142px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(20)\" style=\"top: 732px; left: 215px; height: 130px; width: 155px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(40)\" style=\"top: 342px; left: 386px; height: 118px; width: 215px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(60)\" style=\"top: 707px; left: 386px; height: 95px; width: 205px;\"></div>\n        ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.6, {opacity:0, y:60},{opacity:1, y:0, ease: Power2.easeOut}, 0.1, 1)\n          .staggerFromTo(cOf(\"4-sub\"), 0.6, {opacity:0, x:80},{opacity:1, x:0, ease: Power2.easeOut}, 0.1, \"-=0.3\")\n          .fromTo(cOf(\"4-logo\"), 0.6, {opacity:0, y:80},{opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "4 Contents CONTENTS オリ ン ピ ッ ク ・ ム ー ブ メ ント 定期 刊行 物 2021 年 6 月 ご あい さ つ トー マス ・ バ ッ ハ IOC 会 長 オリ ン ピ ッ ク ・ ハ イライト オリ ン ピ ッ ク ・ ム ー ブ メ ント に まつ わる 最新 の ニュ ー ス と トピ ッ ク 18 五輪 の 先 を 目指 し て 東京 2020 ス ポー ツ デ ィ レ クタ ー の 小谷 実 可 子 が 、 今 夏 の 競技 大 会 の 先 に 目 を 向け ます 20 カバ ー ス トー リー : 東京 まで の 長い 道のり 競技 も 国 も 異な る 6 人 の アス リー ト が 、 2020 年 東京 オリ ン ピ ッ ク 競 技 大 会 に 向け た 道のり に つい て 語り ます 40 東京 2020 プ レビ ュー 「 オ リン ピッ クレ ビュ ー」 が 、 主 催 者 に よる 安心 安全 な 大 会 に 向け た 取り 組み を 掘り 下げ 、 競技 と 会 場 に 関す る 包括 的 な ガイ ド を お 届け し ます 60 レン ズ を 通し て これ まで の 12 か 月 間 に 成 し 遂げ た 目覚 まし い 進展 を 写真 で 振り 返り ます"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(66)\" style=\"top: 331px; left: 51px; height: 128px; width: 290px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(74)\" style=\"top: 686px; left: 48px; height: 135px; width: 142px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(78)\" style=\"top: 767px; left: 215px; height: 100px; width: 135px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(80)\" style=\"top: 539px; left: 378px; height: 108px; width: 135px;\"></div>\n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(82)\" style=\"top: 750px; left: 380px; height: 111px; width: 136px;\"></div>\n\n      <a class=\"addContentLink\" href=\"https://www.olympics.com/ioc\" target=\"_blank\" style=\"top: 547px; left: 533px; height: 8px; width: 113px;\"></a>\n      <a class=\"addContentLink\" href=\"mailto:olympicreview@olympic.org\" target=\"_blank\" style=\"top:556px;left:533px;height:8px;width:111px;\"></a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(addContentLinks, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "Olympic Review 5 Issue 116 66 東京 2020 オ リン ピッ ク 競 技 大 会 の 延期 新型 コロ ナウ イル ス 感 染 症 の 世界 的 な 感染 拡大 の 洞 中 に 2020 東 京 オリ ン ピ ッ ク 競 技 大 会 の 日 程 を 変更 する と いう 未 押 有 の 課題 に 直面 する 中 、 IOC と その 関係 者 は 一 致 団結 し 、 将 来 の た め に も 強力 な 基盤 を 築く べく 、 多く の 前 向き な 解決 策 を 生み 出し て きま し た 74 私 が 参加 し た 競技 大 会 アメ リカ 人 競泳 選手 で あり 、 ま た TV キャ スタ ー の ドナ ・ デ バ ロ ナ 氏 が 自身 の 人 生 を 変え た オリ ン ピ ッ ク 体験 に つい て 語り ます 78 オリ ン ピ ッ ク ・ ス タデ ィ ー ズ IOC オ リン ピッ ク ・ ス タデ ィ ー ズ ・ セン ター に よる ブッ クレ ビュ ー 80 計 報 ご 逝 示さ れ た オリ ン ピ ア ン お よび オリ ン ピ ッ ク ・ ム ー ブ メ ント に 携わっ た 方 々 を 振り 返り ます 82 ファ スト ファ クト 環境 に 配慮 し た 上 で 東京 2020 を 開催 する た め の 基本 事項 と デー タ を ご 紹介 し ます International Olympic Committee 理事 会 会 長 : ト ー マ ス ・ パ ッ パ 副 会 長 : アニ タ ・ デ フラ ン ツ 、 隔 再 清 、 ジョ ン ・ コ ー ツ AC、 セ ル ・ ミ ャ ン ・ ウ ン デニ ス ・ オ ズ ワ ル ド 、 ネ ナド ・ ラ ロビ ッ チ 、 カー ステ ィ ・ コ ベン トリ ー、 イ ー ヴ ォ ・ フ ェ リ アー ニニ 、 ファ イサ ル ・ ア ル ・ フ セイ ン 王 子 殿下 、 ナ ワ ル ・ エ ル ムー タワ キル 、 ミカ エラ ・ コ ジャ ンコ ジャ ウォ ルス キ 、 ジェ ラル ド ・ ウ ェ ル ト ヘ イン OLYMPIC REVIEW コー ポレ ー ト ・ コ ミュ ニケ ーション & 広報 担当 ディ レク ター: ク リス チャ ン ・ ク ラウ エ 編集 長 : キ ャ サリ ン ・ マ ン フラ ンス 語 版 : ル シー ル ・ ト ン ネ ー レ スペ イン 語 版 ドロ レス ・ ブ ラス ケス 日 本 語 版 :TranslateMedia 制作 会 社 :Touchline 制作 : マ イケ ル ・ ス トー ンマ ぴ 、 グリ ン ・ ウ ィ ル ムシ ャ ー ス ト 、 ジョン ・ マ レー、 サム ・ プ ライ ス 、 コ ナー・ ケ トリ ー デザ イン : ジ ョ ン ・ ポ ボー ル ・ イ エッ トン 、 リズ ・ ラ ン キ ン 、 アナ ・ パ ー メ スタ ー、 シェイ マ ・ ラ ジャ ー ニ 写真 編集 : ジェ イソ ン ・ ダ ッ チ 翻訳 ス ・ エ チャ ー ド 、 ヘクター・ ロ ペ ス ・ コ ン セ イロ 、 TranslateMedia 校正 : エ レナ ・ ウ レー ニャ 、 ミシェル ・ サ ン ニ レイ モン ド 、 TranslateMedia ISSN: 0377-192X Printed in the UK 写真 表紙 写真 :Getty Images 本 文 : IOC、IOC/Greg Martin、 Tokyo 2020、 Getty Images、 Shutterstock、Alamy お 問い 合わ せ 郵送 物 の 宛先 Olympic Review, IOC Corporate Communications & Public Affairs Department, Maison Olympique, 1007 Lausanne, Switzerland ウェ ブサ イト : www.olympics.com/ioc メー ル :olympicreview@olympic.org 電話 +41 (0)21 621 6111 「 オ リン ピッ クレ ビュ ー」 に は 持続 可能 な され て いる 森林 か ら 調 達 され た PEF( 紙 が 使用 され て いま す 。 「 オ リン ピッ クレ ビュ ー」 は 国際 オリ ン ピ ッ ク 委 員 会 に よっ て 出版 され て いま す 。「 オ リン ピッ クレ ビュ ー」 に 記載 の 内 容 に 関し まし て は 、 必ずしも 国際 オリ ン ピッ ク 委 員 会 の 見 解 と 一 致す る も の で は あり ませ ん 。 IOC コー ポレ ー ト ・ コ ミュ ニケ ーション & 広報 担当 部 の 許可 な く 、 本誌 の 記載 内 容 を 転載 する こと を 回 く 禁 じ ま す 。 「 オ リン ピッ クレ ビュ ー」 の 発行 回 数 が 変更 され る こと を お 知ら せい た し ます 。 次 回 は 、2021 年 12 月 に 北京 2022 オリ ン ピ ッ ク 冬 季 競 技 大 会 の プレ ビュ ー 号 を 発行 予定 で す 。 次 号 を 皆様 に お 届け する こと を 楽し み に し て お り ま す 。 「 オ リン ピッ クレ ビュ ー」 編 集 部 : ロ ビン ・E・ ミ ッ チ ェ ル 、 ニ コー ル ・ ホ ベル ツ 、 載 さ れ て いる 情報 は すべ て 出 孤 時 の も の で す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Behind you for what's ahead"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 7-title\" style=\"top:351px;left:43px\" src=\"/tokyo2020/static/_content/7-title-1.png\">\n\n        <img class=\"halfScale 7-img\" style=\"top:95px;left:44px\" src=\"/tokyo2020/static/_content/7-img-1.png\">\n        <img class=\"halfScale 7-img\" style=\"top:517px;left:44px\" src=\"/tokyo2020/static/_content/7-img-2.png\">\n        <div class=\"abs\" style=\"top: 785px; left: 485px; height: 38px; width: 130px;background:white\"></div>\n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:788px;left:488px;height:35px;width:132px\">\n          <img class=\"halfScale\" src=\"/tokyo2020/static/_content/7-sig.png\">\n        </div>\n        <!-- <img id=\"7-ctr\" style=\"top:390px;left:328px;cursor:pointer;\" onclick=\"pg7show();\" src=\"/tokyo2020/static/_content/clicktoread.png\">\n          \n        <div id=\"pg7read\" class=\"d-hidden\" style=\"z-index:1;\">\n          <img id=\"pg7close\" onclick=\"pg7readclose();\" src=\"/tokyo2020/static/_content/x-button.png\">\n        </div> \n      .fromTo(idOf(\"7-ctr\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\") -->\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax();\n          pg7Anim.staggerFromTo(cOf(\"7-title\"), 0.8, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power4.easeOut}, 0.4, 1)\n          .staggerFromTo(cOf(\"7-img\"), 0.8, {opacity:0, y:60}, {opacity:1, y:0, ease: Power4.easeOut}, 0.4, \"-=0.2\")\n          .fromTo(idOf(\"7-sig\"), 0.6, {width:\"0px\"}, {width:\"123px\", ease: Power2.easeOut}, \"-=0.4\")\n          \n        }\n\n        function pg7show() {\n          var k =  document.getElementById(\"pg7read\")\n          k.className = \"readOverlay visible\"\n        }\n  \n        function pg7readclose() {\n          var k =  document.getElementById(\"pg7read\")\n          k.className = \"d-hidden\"\n        }\n  \n        function onPageLeave() {\n          pg7readclose();\n          pg7Anim.stop();\n        }\n        ",
    "searchText": " Olympic Review Issue 116 7 FOREWORD BY THOMAS BACH トー マス ・ バ ッ ハ 10C 会 長 か ら の ご あい さ つ 期 され た 東京 2020 オ リン ピッ ク 競 技 上 会 の 開催 に 向け て 着 々 と 準備 が 整 う 中 、 まず は 、 安全 安心 な 大 会 を 開催 する た め に あら ゆる 対策 を 講じ て くだ さっ て いる 寛大 な ホス ト の 皆様 と 日 本 の 皆様 に 対し て 、 感謝 の 気持 ち を 表し た いと 思い ます 。 彼 ら の 絶大 な る 力量 と 困難 に 打ち 勝つ 強い 意志 が ある か ら こ そ 、 大 会 に 向け て 世界 が 一 丸 と な り 、 団結 する こと が で きる の で す 。 この 真 の 意味 で の 歴史 的 偉業 は 私 た ちの 心から の 感謝 、 尊敬 、 称賛 に 値する も の で す 。 延期 され た 競技 大 会 を 開催 する と いう 前 例 の 0 は 、 国際 オリ ン ピ ッ 委員 会 ((OC)、 国 際 競 技 運 盟 (IF) 、 国 内 オリ ン ピ ビ レッ ク = ョ ム (NOC) 、 私 た ちの パー トナ ー、 そし て 言う まで も な く 選 手 た ち が 構 成す る オリ ン ピ ッ ク ・ ム ー ブ メ ント に よる 総合 的 な 共同 努力 の 証 で も あり ます 。 この 1 年 で 何ら か の 教訓 を 得 ら れ た と すれ ば 、 そ れ は 私 た ち が 一 丸 と な れ ば 必ず 強く な れる 、 と いう こと で す 。 歴史 上 初め て 競技 大 会 が 延期 され て か ら の 1 年 間 、 オ リン ピッ ク ・ ム ー ブ メ ント に お いて 過去 の 栄光 に 甘んじ る 人 は 誰 も いま せん で し た 。 決 定 が 下さ れる と 同時 に 、 すべ て の 関係 者 が 1 年 後 の 開 催 の 再編 成 に 対し て 献 身 的 に 、 揺るぎない 覚悟 を 持っ て 取り 組み まし た 。 そ の 後 新た な 開催 日 程 が 決定 し 、 すべ て の 競技 会 場 と 選手 村 の 確保 に 向け て 大 変 な 支 力 が 注 が れ ま し た 。 パー トナ ー の 皆様 は 私 た ち を 見 守り 、 絶え 間 な く 支 えて くれ ま し た 。 その 一 方 で 、 選手 た ち は ト レー ニン グ 日 程 を 調整 し 、 制約 の 中 で も 創意 工夫 し て 準備 を 整 えま し た 。 中 に は 第 一 線 で 活躍 する 医療 従事 者 と 協力 し て 、 一緒 に パン デミ ッ ク と 戦う た め 、 医 療 訓練 を 受け た 人 さえ いま し た 。 東京 2020 オ リン ピッ ク 競 技 大 会 に 向け て 全 身 全 霊 の 努力 が 重ね られ て いた 中 、 IOC お よび オリ ン ピ ッ ク ・ ム ー ブ メ ント 関係 者 に よる 、 その 他 の すべ て の アク ティ ビ テ ィ も 同時 進行 し て いま し た 。 選 手 た ち を フィ ー ル ド 内 外 で 支援 する こと を 目的 と し た プロ グラ ム が 実施 され 、 いつ も 以上 の 力 が 注 が れ ま し た 。 同時 に 、 NOC に よる (難民 選手 を 含む ) 選手 へ の 支援 継続 を 援助 する た め オリ ン ピ ッ ク ・ ソ リ ダ リ ティ の 資金 が 増額 され ま し た 。IF も また 、IOC か ら さ ら な る 支援 を 得る こ と が で きま し た 。 そし て 、 時 代 の 流れ に 合わ せ て 、 IOC の デジ タル 戦略 が 実 を 結び 始め 、 オリ ン ピ ッ ク が 開催 され て いな い に も か か わら すず 、 視聴 者 の 織 得 が 促進 され まし た 。 最後 に 、2020 年 に お ける 重要 な 功績 は 、[OC が 2014 年 に 採択 し た 戦略 的 改革 案 で ある オ リン ピッ ク ・ ア ジェ ンダ 2020 が 完結 し た こと で す 。 昨年 12 月 、 IOC 執 行 委員 会 は オリ ン ピ ッ ク ・ アジ ェ ン ダ 2020 で 出さ れ た 40 の 提言 の うち 88% が 達成 され た と 結論 付け まし た 。 そし て 今 年 3 月 、 第 137 次 IOC 総会 は 再び バー チャ ル で 開催 され 、 ク ロー ジン グレ ポ ボート を 満場 一 致 で 承 認 し まし た 。 同 総会 で は 、[OC メ ン バ ー が 2025 年 に 向け た 15 の 提言 か ら 成 る ロー ド マ ッ ズ オリ ン ピ ッ ク ・ ア ジェ ンダ 2020+5 を 採択 し 、 将来 を 見 据え る 確固 た る 基礎 を 築き まし た 。 これ ら の 成果 は 、 オ リン ピッ ク ・ ム ー ブ メ ント 全 体 が 示し た 連帯 感 な し に は 、 達成 し えま せん で し た 。 そ し て 今 、 私 た ち は 過 去 の どの 大 会 と も 異な る 東京 2020 オ リン ピッ ク 競 技 大 会 を 目前 に 控 えて いま す 。 この 大 会 は 、 団結 し て 立ち 上 が る こ EC 偉業 を 達成 で きる と いう 力強い 象徴 と な る こと で し ょ う 。 Faster, higher, stronger - together. (共に より 速く 、 より 高く 、 そ し て より 強く ) IOC 会 長 トー マス ・ バ ッ ハ"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 8-title\" style=\"top:93px;left:73px\" src=\"/tokyo2020/static/_content/8-title-1.png\">\n        <img class=\"halfScale 8-title\" style=\"top:189px;left:431px\" src=\"/tokyo2020/static/_content/8-title-2.png\">\n        <img class=\"halfScale 8-title\" style=\"top:755px;left:142px\" src=\"/tokyo2020/static/_content/8-quote-1.png\">\n\n        <a href=\"https://iocnewsroom.com/video/thomas-bach-re-elected-international-olympic-committee-president-for-second-term/\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:514px;top:787px; overflow:visible; \" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.staggerFromTo(cOf(\"8-title\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n        }\n      ",
    "searchText": "オリ ン ピ ッ ク ・ ハ イラ イト OLYMPIC HIGHLIGHTS オリ ン ピ ッ ク ・ ム ー ブ メ ント に まつ わる 最新 の ニュ ー ス と トピ ッ ク を お 届け し ます 。 2020 に よっ て 、 私 た ち は オ リン ピッ ク ・ ム ー ブ メ ント を 根底 か ら 変 えた の で す 」 IOC ト ー マ ス ・ バ ッ ハ 会 長"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <!-- <div class=\"addContentLink\" style=\"top: 539px;left: 591px;height: 16px;width: 78px;\">\n          <a href=\"https://stillmedab.olympic.org/media/Document%20Library/OlympicOrg/IOC/What-We-Do/Olympic-agenda/Olympic-Agenda-2020-5-15-recommendations.pdf\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 553px;left: 481px;height: 16px;width: 39px;\">\n          <a href=\"https://stillmedab.olympic.org/media/Document%20Library/OlympicOrg/IOC/What-We-Do/Olympic-agenda/Olympic-Agenda-2020-5-15-recommendations.pdf\" target=\"_blank\"></a>\n        </div> -->\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": " Olympic Review Issue 116 9 年 の 3 月 、 オ ン ラ イン 形式 で 開催 され た 137 次 IOC 総 会 に て 国際 オリ ン ピ ッ ク 委 員 会 (IOC) トー マス ・ バ ッ ハ 会 長 が 再選 を 果たし 、 さら な る 4 年 間 の 任期 を 務め る こと と な り ま し た 。 モン トリ オー ル 1976 オ リン ピッ ク 競 技 大 会 で フェ ン シ ン グ の フル ー レ 団体 に 出場 し 、 金メダル を 獲得 し た 実績 を 持つ 67 歳 の バッ ハ 会 長 が 得票 し た の は 、 有 効 な 94 票 中 賛成 93 票 、 反 対 1 票 で し た 。 「 私 に 対し て 多大 な 信用 と 信頼 を 寄せ て いた だ き 、 心 の 底 か ら 皆 様 に 感謝 申し 上 げ ま す 。 私 た ち す べ て に 影 響 を 及ぼ し た 数 多く の 改革 や これ まで 下さ な けれ ば いけ な か っ た 難し い 決断 に 負 み ます と 、 この 結果 は 自 分 に と っ て ひと きわ 身 に 余る 光栄 で す 」 と 会 長 選 を 振 り 返 り バ ッ ハ 会 長 は 話し まし た 。「 私 が 感無量 で ある こと は 、 ご 想像 の と お り で す 。 同時 に 、 身 の 引 き 締まる 思い も 致し ます 。2013 年 に ブエノスアイレス で 皆様 が 私 を 会 長 と し て 初め て 選出 し て くだ さっ た と き 、 自 分 の 会 長 選 へ 向け て の スロ ー ガ ン 、『 多 様 性 の 中 で の 団 結 』 に 則っ て IOC を 指揮 し た い 、 そ し て すべ て の 皆様 、 お よび 関係 者 の た め の 会 長 に な り た い 旨 を 申し 上 げ まし た 。 この 覚悟 は 私 に と っ て 最後 と な る 2 期 目 に も 当て は まり ます 。 私 の 部 屋 の 扉 、 耳 、 そ し て 心 は 皆様 方 一 人 ひと り に 向け て 変わ る こと な く 常 に 開か れ て いま す 。 これ か ら の 4 年 間 、 引 き 続き 変わ ら ぬ ご 協力 、 ご 支 援 、 そ し て 友情 を 、 よる しく お 願い 申し 上 げ ま す 」 また 総会 で は 、 IOC お よび オリ ン ピ ッ ク ・ ム ー ブ メ ン ト の 2025 年 に 向け た 、 新た な 戦略 的 ロー ド マ ッ プ と な る オリ ン ピ ッ ク ・ ア ジェ ンダ 2020+5 が 満場 一 致 で 承認 され まし た 。15 の 提言 か ら 構成 され る この 新た な ロー ド マ ッ プ は 、 オリ ン ピ ッ ク ・ ア ジェ ンダ 2020 の 成果 を 踏ま え 、 IOC お よび オリ ン ピ ッ ク ・ ム ー ブ メ ント の 今後 5 年 間 の 活動 の 指針 と な る も の で す 。 これ ら の 提言 は 包括 的 か つ 協 調 的 な プロ セス を も っ て 構築 され 、 新 型 コ ロナ ウイ ルス 感染 症 収束 後 の 世界 で 、 確実 に 主流 と な る で ある ろう 傾向 に 基づい て い ます 。 課題 と な る キー ワー ド に は 連帯 、 デ ジタル 化 、 持 続 可 能 な 開発 、 信頼 性 、 経済 的 ・ 財 政 的 な レジ リエ ン ス が 含ま れ ま す 。 オリ ン ピ ッ ク ・ ア ジェ ンダ 2020+5 の 採択 に 先駆 け 、 IOC 総 会 は オリ ン ピ ッ ク ・ ア ジェ ンダ 2020 の 成果 に 賛辞 を 送り 、 |OC メ ン バ ー は その クロ ー ジ ング レポ ボー ト を 満場 一 致 で 承認 し まし た 。 「 過 去 数 年 に わた り 、 す べ て の オリ ン ピ ッ ク ・ ム ー ブ メ ント 関係 者 が オリ ン ピ ッ ク ・ ア ジェ ンダ 2020 の 実現 に 向け て 真 献 し て くだ さい まし た 」 と 、 バッハ 会 長 は 述 べ ま し た 。「 私 た ち は 、 オ リン ピッ ク ・ ア ジェ ンダ 2020 を も っ て 困難 を 機会 へ と 生ま れ 変わ ら せ ま し た 。 オ リ ン ピ ッ ク ・ ア ジェ ンダ 2020 に よっ て 、 私 た ち は オ リン ピッ ク ・ ム ー ブ メ ント を 根底 か ら 変え た の で す 」 4 月 21 日 、 IOC ア スリ ー ト 委員 会 (AC) は 、 競技 大 会 に お ける 選手 た ちの 意見 表明 に 関す る 一 連 の 提言 に 向け て 、 IOC 執 行 委員 会 (EB) か ら の 全面 的 な 支 持 を 受け まし た 。 提言 は 特に 、 ス ポー ツ お よび 競技 大 会 の 中 立 性 を 保護 する 枠組 み を 明記 し た オリ ン ピ ッ ク 憲 章 規 則 50 に 関連 し て いま す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 10-quote\" style=\"top:122px;left:99px\" src=\"/tokyo2020/static/_content/10-quote-1.png\">\n        <h1 id=\"10-no\" class=\"abs 10-no ohr\" style=\"left: 70px; top: 764px; font-size: 4.5em; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 3547, \"comma\": true }'></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim.staggerFromTo(cOf(\"10-quote\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"10-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"10-no\")[0]);}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop();\n          resetNumbers(\"10-no\");\n        }\n        ",
    "searchText": " オリ ン ピ ッ ク ・ ハ イラ イト QP 「 この 協議 は 私 た ち に と っ て きわ め て 重要 な プロ セス で あっ た と 同時 に 、 選手 た ちの コ ミュ ニテ ィ と の 継続 的 な 対話 の 一 部 と な り ま し た 。 IOC BB が 私 た ちの 提案 を 全面 的 に 支持 し て くだ さっ た こと を 喜ば し く 思 いま す 」 カー ステ ィ ・ コ ベン トリ ー 氏 これ ら の 提言 は 、2020 年 6 月 に IOC AC が 3500 人 以上 の 選手 を 対象 に 開始 し た 、 時 間 、 質 共 に 申し 分 の な い 協 議 プ ロ セ ス を 経て 生ま れ た も の で す 。 対象 選手 は 男女 同数 で 、185 の 国内 オリ ン ピ ッ ク 委 員 会 (NOC) と 41 種類 に 及ぶ オリ ン ピ ッ ク 全 競技 を 代表 し て いま す 。 協 議 は アス リー ト 委 員 会 大 陸連 合 お よび 世界 オリ ン ピ ア ンズ 協会 か ら の 支援 の 下 で 行わ れ ま し た 。 提言 は オリ ン ピ ッ ク 競 技 大 会 開催 期間 に お ける 選手 の 意見 表明 の 機会 の 増加 を 含ん で いま す が 、 表彰 台 、 競技 場 公式 セレ モニ ー で は 、 いか な る 抗 議 行動 や デモ ンス トレ ーション を も 禁じ て いま す 。 IOC AC 和 要員 長 の カー ステ ィ ・ コ ベン トリ ー 氏 (写真 ) は 次 の よう に 述べ まし た 。「 広 範囲 に 及ぶ この 取り 組み の 目的 は 、 選手 と し っ か り と 向き 合い 、 競技 大 会 お よび 競技 大 会 以外 の 時 間 に お いて 、 彼ら が 意見 表明 する 既存 の 、 また は 新た な 機会 に つい て 選手 の 意見 を 聞く こと で し た 。 私 た ち は 選 手 の 意見 を より 多く 取り 入れ 、 オ リンピック 大 会 の 価値 、 そ し て 競技 の 持つ 意義 を 支持 する さら な る 方 法 を 模索 し た いと 考え て いま す 。 この 協議 は 私 た ち に と っ て きわ め て 重要 な プロ セス で あっ た と 同時 に 、 選手 た ちの コミ ュ ニ ティ と の 継続 的 な 対話 の 一 部 と な り ま し た 。IOC EB が 私 た ちの 提案 を 全面 的 に 支持 し て くだ さっ た こと を 喜ば し く 思 いま す 」 この 会 議 中 、 IOC EB は オリ ン ピ ッ ク の モッ トー で ある Faster, Higher, Stronger (より 速く 、 より 高く 、 より 強く )」 の 後に ダッ シュ と 「Together ( 共 に )」 を 加え る と いう バッ ハ 会 長 の 提案 に つい て も 協議 を 行い まし た 。 この アイ デア は 元々 、 バッ ハ 会 長 が 137 次 IOC 総 会 で 提案 し た も の で あ り 、EB は これ を 支持 し まし た 。 そし て 現在 は 、 IOC メ ン バ ー が コメ ント を 求 め ら れ て いる と ころ で す 。IOC メ ン バ ー か ら の フィ ー ド バッ ク に よっ て は 、 オリ ン ピ ッ ク 憲 章 の 変更 に 関す る 提案 は 、 東京 で の 会 議 で 取り 上 げ ら れる こと に な り ま す 。 4 月 22 日 、IOC は 史上 初 と な る オリ ン ピ ッ ク ・ バ パーチ ャ ル シ リ ー ズ (OVS) を 立ち 上 げ る と いう 、 バー チャ ルス ボー ツ 分 野 へ の 画 期 的 な 参入 を 発表 し まし た 。IOC は 五 つの 国際 競技 連盟 (世界 野球 ソフ ト ボ ー ル 連 盟 、 国 際 自 転 車 競 技 連 合 、 国 際 ボ ー ト 連盟 、 ワー ルド セー リン グ 、 国際 自動 車 連盟 ) お よび ゲー ム ソ フ トメ ー カ ー と 提携 し 、 物理 的 お よび 非 物理 的 な e ス ポー ツ 向 け の 史上 初 の オリ ン ピ ッ クラ イセ ンス イベ ント と な る OVS を 開催 する こと に な り ま す 。2020 年 東京 オリ ン ピ ッ ク 競 技 大 会 の 開催 前 に 実施 され る OVS は 2021 年 5 月 13 日 に 開幕 し 、 6 月 23 日 まで 続き ま す 。OVS は 新た な オリ ン ピ ッ ク 大 会 の オー ディ エン ス を 幅広 く 取 り 込む た め に 世界 中 の バー チャ ルス ポー ツ 、e ス ポー ツ 、 ゲー ム の 愛好 者 の 参加 を 募る と 同時 に 、 オリ ン ピ ッ ク ・ ア ジェ ンダ 2020+5 の 提言 に 即 し た 物理 的 、 また 非 物理 的 な 形態 の スポ ー ツ の 発展 を 奨励 する も の で す 。 4 月 初旬 、 IOC は 、 新型 コロ ロナ ウイルス 感染 症 感染 拡大 か ら 回 復 する た め の 世 界 的 な 努力 を 支援 する に あたり 、 スポ ー ツ が 果たす きわ め て 重 要 な 役割 を 強調 する こと に より 、 発 展 と 平和 の た め の ス ポー ツ の 国際 デー (IDSDP) を 祝い まし た 。 「 ス ポー ツ は 、 今 まで 以上 に 人 中 心 の 包括 的 な 社会 の 構築 に 寄与 し ます 」 と 、 バッ ハ 会 長 は 述べ まし た 。「 こ の 危機 は 、 すべ て の 国 が 回 復 へ と 向 か う 努 力 を 重ね る 上 で 、 スポ ー ツ が 低 費用 で 楽し め 、 か つ 大 き な 影 響 力 を 持つ 、 非 常に 素晴らし い ツ ー ル で ある こと を より 一 層 明 確 に し まし た 」"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SAMSUNG WORLDWIDE PARTNER Galaxy $21| S21+ 5G Image simulated. Color availability may vary depending on country or carrier."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 12-quote\" style=\"top:573px;left:337px\" src=\"/tokyo2020/static/_content/12-quote-1.png\">\n        <!-- <div class=\"addContentLink\" style=\"top: 389px;left: 151px;height: 16px;width: 141px;\">\n          <a href=\"https://olympics.com/en/news/milano-cortina-2026-winter-olympic-games-emblem-revealed \" target=\"_blank\"></a>\n        </div> -->\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.staggerFromTo(cOf(\"12-quote\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n        ",
    "searchText": " 12 オリ ン ピ ッ ク ・ ハ イラ イト オリ ン ピ ッ ク 競 技 大 会 4 月 19 日 、IOC 調 整 委員 会 は ミラ ノア コル ティ ナ 2026 組 織 委 員 会 と 2 回 目 と な る オン ライ ン 会 議 を 開催 し まし た 。 新型 コロ ナウ イル ス 感 染 症 の 感染 拡大 に 伴う 困難 な 時 期 が 続い て いる に も か か わら ず 、 ミラ ノノ コル ティ ナ 2026 の 組織 委員 会 は 、 去年 の 9 月 に 実施 され た 調整 委員 会 会 議 か ら 、 大 幅 な 進展 を 遂げ る こと が で きま し た 。 会 議 の 後 、 サリ ・ エ ッ サ ヤ 調 整 委員 長 は 次 の よ うに コメ ント し まし た 。「2020 年 9 月 に 行っ た 最 後 の 会議 以 来 、 パン デミ ッ ク に も か か わら ず ミラ ノノ コル ティ ナ 2026 の 組織 委員 会 は 大 き な 進展 を 遂げ まし た 。 も っ と も 顕著 な 成果 は 、 87 万 1 千 に 上 る 投票 が な され た ミラ ノノ コル ティ ナ 2026 の 新しい エン ブレ ム の 選考 プロ セス で す 。 選 出さ れ た ロゴ 「 フ トゥ ー ラ 」 は 、 今 後 5 年 間 、 イ タリ ア に お いて きわ め て 有名 な シン ボル と な る こと で し ょ う 。 同時 に 、 いま まで 生ま れ た シン ボル の な か で も 、 特 に 愛さ れる も の に な る と 確信 し て いま す 」 今年 3 月 、 パリ 2024 の 理事 会 は 、 同 大 会 を 気 候 に ポジ ティ ブ な 影響 を 与え る 世界 初 の クラ イ メッ ト ・ ポ ジテ ィ ブ な も の に する と いう 、 気候 変動 へ の 戦略 を 承認 し まし た 。 この 決断 は 、 2024 年 以降 IOC を クラ イメ ッ ト ・ ポジ ティ ブ な 組織 に し 、 2030 年 以降 は すべ て の オリ ン ピ ッ ク 競 技 大 会 を クラ イメ ッ ト ・ ポ ジテ ィ ブ な も の に する と いう IOC の コミ ッ ト メ ント を 踏ま えて 下さ れ た も の で す 。 この 戦略 の 一 環 と し て 、 パリ 2024 は 気候 変動 の 枠組 み で ある パリ 協定 に 則っ て 二酸化 炭素 排 出 量 を 削減 し 、 残留 排出 量 以上 の オフ セッ ト を 実 施し 、 そ の 影響 力 を 活用 し て 長期 的 な 炭素 補償 プ ロジ ェクト を 策定 し ます 。 この 戦略 は 、 温室 効果 ガス の 排出 削減 、 気候 に ポジ ティ ブ な 頁 献 を 果 た す プ ロジ ェクト の 支援 、 長期 に わた る ポジ ティ ブ な 頁 献 を 最大 化す る こと を 目的 と し た 関係 者 の 動員 と いう 三 つ の 柱 か ら 構 成 さ れ て いま す 。 初 の クラ イメ ッ ト ・ ポ ジテ ィ ブ な 競技 大 会 の 開催 と いう コミ ッ ト メ ント に 則 し て いま す 「 新 型 コ ロナ ウイ ルス 感染 症 の 感染 拡大 に 伴う 困難 な 時 期 が 続い て いる に も か か わら ず 、 ミラ ノン コル ティ ナ 2026 の 組織 委員 会 は 、 去年 の 9 月 に 実施 され た 調整 委員 会 会 議 か ら 、 大 幅 な 進展 を 遂げ る こと が で きま し た 。 選出 され た ロゴ 『 フ トッ ー ラ 』 は 、 今 後 5 年 間 、 イタ リア に お いて きわ め て 有名 な シン ボル と な る こと で し ょ う 。 同時 に 、 い まま で 生ま れ た シン ボル の な か で も 、 特 に 愛さ れる も の に な る と 確信 し て いま す 」 サリ ・ エ ッ サ ヤ 氏"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 315px;left: 502px;height: 36px;width: 131px;\">\n          <a href=\"https://olympics.com/ioc/news/airbnb-launches-accommodation-grants-to-support-athlete-travel-costs\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": " Olympic Review Issue 116 13 国内 オリ ン ピ ッ ク 委 員 会 アメ リカ オリ ン ピ ッ ク ・ パ ラリ ン ピ ッ ク 委 員 会 (USOPC) fd, PF XU ARR EF O te Be OI ae と 収入 機会 を 強化 する こと に 取り 組む お 「 チ ー ム USA ア スリ ー ト ・ マ ー ケ ティ ング ・ プ ラッ ト フ ォ ー ム (AMP)」 の パイ ロッ ト プ ロ グラ ム を 立ち 上 げ ま し た 。 オ プ ト イ ン 形 式 の モバ イル フレ ンド リー な こ の プロ グラ ム は 、 選手 を アメ リカ 代表 チー ム の ス ポン サー や ライ セン ス 業 者 に 直接 結び つけ る 初 め て の 試み で す 。AMP は 選手 に 、 メデ ィ ア 露出 に よる マー ケティング と 収入 確保 の 機会 を 提供 し 、 東京 2020 オ リン ピッ ク 競 技 大 会 と 北京 2022 オリ ン ピ ッ ク 冬 季 競 技 大 会 の 間 の 、 前 例 の な い 6 か 月 間 に 、 選 手 の 発言 、 競技 、 そ し て 個人 の ブラ ン ディ ング を 広め て いく 予定 で す 。 ケニア の 国内 オリ ン ピ ッ ク 委 員 会 は 、 ナイ ロビ 郡 政 府 と 了解 覚書 (MoU) に 署名 を 済ま せ た 後 、 ル ア イ 地区 に オリ ンプ ・ ア フリ カ ・ セ ンタ ー を 設 立 する 計画 を 立て て いま す 。 ケニア の 国内 オリ ン ピッ ク 委 員 会 (NOC) 会 長 で IOC メン バー の ボー ル ・ テ ル ガ ト 氏 、 ナイ ロビ 知事 代理 の アン ・ カ ナ ヌ Rid. 同 セ ンタ ー の 建設 の た め 、 政府 が NOC に 対し て 無料 で 土地 を 提供 する 旨 を 記載 し た 了解 覚書 に 牙 名 を し まし た 。 セン ター に 向け て NOC は 運営 費 を 、 オリ ンプ ・ ア フリ カ は 設立 資金 を そ れ ぞ れ 負 担 する こと に な り ま す 。 リュ ー ジ ュ 競 技 の クリ ス - マ ズ ダ ー 選 手 を は じ め ア メリ カ 代 表 選手 は 、 USOPC が 立 ais AAS アス リー ト に Airbnb 旅行 クレ ジッ ト を 提供 去る 4 月 、 ワ ー ル ド ワ イ ド オリ ン ピ ッ ク パー トナ ー の Airbnb は 、 IOC と 提携 し 、 トッ プア スリ ー ト 、 オ リン ピア ン 、 パラ リン ピア ン に 対し て 宿泊 クレ ジッ ト を 提供 する 新た な イニ シア チ ブ の 立ち 上 げ を 発表 し まし た 。 アス リー ト 渡 航 費 助成 金 プロ グラ ム は 、 今 後 8 年 間 に わ た り 、 アス リー ト の スポ ー ツ キャ リア に 関連 する 渡航 に 伴う 宿泊 費 に 充て る こと が で きる 2 千 米 ドル 相当 の Airbnb クレジット を 1 年 に つき 最大 500 人 の アス リー ト に 対し て 提供 し ます 。 (上 ) Airbnb 共同 創始 者 の ジョ ー・ ゲ ビア 氏 と パッ ハ 会 長 世界 中 で 祝 わ れ た 「 プ レイ ・ ト ゥ ルー・ デ ィ イ 」 4 月 9 日 、 世 界 ア ンチ ・ ド ー ピ ング 機構 (WADA) が 掲げ る 2021「 プ レイ ・ ト ゥ ルー・ デイ 」 キャ ン ペ ー ン は 、 世 界 中 の 8700 万 人 に メッ セー ジ を 届け まし た 。「 あ な た に と っ て プレ イ ・ ト ゥ ルー は 何 を 意味 し ます か 」 と いう テー マ を 中 心 に 据え た キャ ン ペ ー ン で は 、 IOC、 選 手 、 国 内 お よび 地域 別 の アン チ ・ ドー ピン グ 組 織 、 国 際 競 技 運 盟 、 政 府 、 主要 な イベ ント 主催 者 、 そ し て 世界 的 な アン チ ・ ド ー ピ ング コミ ュ ニ ティ 関係 者 が ー 致 団結 し 、 プ レイ ・ ト ゥ ルー の メッ セー ジ を 改め て 祝福 し まし た 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 14 オリ ン ピ ッ ク ・ ハ イラ イト Atos が 日 本 各地 で バー チャ ル 探 検 を 開催 ワー ルド ワイ ド オ リン ピッ ク バ パー トナ ー の Atos は 、 4 月 6 日 、 新 型 コ ロナ ウイ ルス 感染 症 の 感染 拡大 期間 中 で も Atos 社員 が #StrongerTogether (共に 強く ) で いら れる よう に 、 新 た な パー チャ ルチャ レン ジ を 立ち 上 げ る と 共に 開発 と 平和 の た め の スポ ー ツ の 国際 デー (IDSDP) を 祝い まし た 。 グレ ー ト ・Atos・ グ ロー バル ・ エク スペ ディ ショ ン (GAGE) も また 、 2021km に わた る パー チャ ル 日 本 国内 旅行 チャ レン ジ の 参加 者 を 募る こと で 、 東 京 2020 大 会 に 向け た 熱気 を 高め て いき ます 。 ムン ョ | チャ レン ジ に する 10 チ ー ム の キャ プ テ ン の 一 人 、 エ ス 出身 の パイ アス ロン 選手 レジ ー ナ ・ オ ジャ 国際 競技 加盟 4 月 22 日 、 ワー ルド アス レティ ックス お よび ベ オ グラ ー ド 2022 世 界 室内 陸上 競技 選手 権 大 会 の 主催 者 は 、2021 年 の アー ス デ イ を 記念 し 、 気候 変 動 に 関す る 国際 連合 枠組 条約 (UNFCCC) の ス ボー ツ を 通じ た 気 侯 へ の 取り 組み の 枠組 み に 調印 し まし た 。 こ の 枠組 み へ の 調印 は 、 持 続 可能 な 開発 戦略 に 対す る ワー ルド アス レティ ックス の コミ ッ ト メン ト 、 すなわち 、 2020 年 4 月 に 発表 され た 10 年 間 の ロー ド マ ッ プ を より 一 層 強 調 す る も の で す 。 そ の 中 に は 2030 年 まで に その すべ て の 運営 と イベ ン ト に わた っ て カー ボン ニュ ー ト ラル を 実現 する と い うっ 目標 が 含ま れ て いま す 。 また 、2021 年 アー ス デ イ に 当たり 、 国際 バイ ア スロ ン 連 合 (IBU) は 、 気 侯 変 動 に 配慮 し た 行動 を 伴う 、 積極 的 な ライ フス タイ ル と の つなが り を 目指 す 、 第 1 回 バイ アス ロン 気候 チャ レン ジ の 実施 を 発 表し まし た 。 ファン た ち は (すべ て バイ アス ロン の ス ター 選手 が リー ダー を 務め る ) 10 の 異な る チー ム に 参加 し 、 フィ ッ ト ネ ス ア プリ を 介し て 身体 的 な ア クティ ビ テ ィ を トラ ッ キ ング し 、 自分 が 進ん だ 距離 や 消費 カロ リー は 再 森林 化 プ ロジ ェクト に お ける 植樹 と し て 変換 され ます 。 この チャ レン ジ は 、 気候 、 スポ ー ツ 、 人 、 会 場 お よび イベ ント 、 そし て コミ ュ ニ ケー ショ ン お よび 認知 度 と いう 、 五 つ の 異な る 分 野 に お ける 持続 可能 な 開発 の ニー ズ を 提起 する こと を 確約 する 、 IBU の 持続 可能 な 開発 戦略 2020 一 2030 の 一 環 と し て 立ち 上 げ ら れ ま し た 。 気候 面 で の 目標 は 、 2030 年 まで に パリ 協定 が 掲げ る 目標 に 即 し て 、 二酸化 炭素 の 排出 削減 、 そ し て スポ ー ツ を カー ボン ニュ ー ト ラル に する こと で す 。 国際 バス ケッ ト ボ ー ル 連盟 (FIBA) は 、 FIBA プ レー ヤー ズ メ ンタ ー シ ッ ププ ログ ラム を 正式 に 発足 し た こと を 発表 し まし た 。FIBA は 、 プレ ー ヤ ー ズ ・ コ ミッ ショ ン の 指揮 の 下 、 コー ト 上 に と ど ま ら ま 、 コー ト 外 で も 選手 に サポ ー ト を 提供 し た いと 考え て いま す 。 その 主 な 目的 は 、 一 つの 国内 連盟 に つき 、 その 国 に お ける すべ て の 若い トッ ププ レー ヤー の サポ ボー ト を 支援 する プレ ー ヤ ー・ メ ンタ ー を 少な く と も 1 人 育成 する こと で す 。FIBA は 、 すべ て の プレ ー ヤ ー が 自己 最高 の し ベル で 競争 し 、 健康 と ウェ ルビ ー イ ング を 高め 、 有意 義 な 教育 機会 を 得る こと を 目指 し て いま する 国際 テニ ス 連 盟 ([TF) は 全 メ ディ ア と ソー シャ ル メデ ィ ア に わた っ て スポ ー ツ に お ける ジェ ンダ ー 平 等 を 調査 する 、 史上 初 の 世界 的 リサ ー チ プロ ジェ クト の 結果 を 発表 し まし た 。 これ は 、 ITF に よる 、 す べ て の ジェ ンダ ー の 平等 を 目指 す 戦略 の 一 環 と し て 実施 され まし た 。 この 調査 報告 書 は 、 ITF が 主催 する グロ ー バ ルフ ォ ー ラ ム 、「Level the Playing Field (公平 な 機会 の 実現 )」 の 開催 中 に 討論 され まし た 。 女 性 指導 者 の 増加 、 女 性 スポ ー ツ の 観客 の 増加 と エン ゲー ジメント を も た らし 、 女性 スポ ー ツ と 女性 選手 の 報道 の あり 方 に 影響 を 与え る 方 法 に つい て 、 トッ プア スリ ー ト は シニア ビジ ネス リー ダー と 経験 、 動 機 、 専 門 知 識 を 共有 し まし た 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Worldwide IT Partner Leaving a legacy Matters As lead integrator, Atos migrated all critical IT systems to the cloud, orchestrating it all for future Olympic and Paralympic Games. #AtosMakeltHappen"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 16-quote\" style=\"top:425px;left:465px\" src=\"/tokyo2020/static/_content/16-quote-1.png\">\n        <h1 id=\"16-no\" class=\"abs 16-no ohr\" style=\"left: 537px; top: 118px; font-size: 4.5em; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 1900, \"comma\": true }'></h1>\n\n      <a class=\"addContentLink\" href=\"https://olympics.com/ioc\" target=\"_blank\" style=\"top: 298px; left: 379px; height: 14px; width: 88px;\"></a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.staggerFromTo(cOf(\"16-quote\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"16-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:addContentLinks,function(){animateNumber(cOf(\"16-no\")[0]);}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop();\n          resetNumbers(\"16-no\");\n          removeContentLinks()\n        }\n        ",
    "searchText": " オリ ン ピ ッ ク ・ ハ イラ イト ユー ス オ リ ン ピ ッ ク 大 会 江原 道 2024 ユ ー ス オリ ン ピ ッ ク 冬 季 競 技 大 会 (YOG) 組織 委員 会 は 、 競技 大 会 に 対す る 若者 か ら の 関心 を 喚起 する た め の プ ログ ラム を 立ち 上 げ る こと に より 、 大 会 の 企画 お よび プロ モー ショ ン に お いて 若者 が 重要 な 役割 を 果たす こと を 約束 し ま し た 。「 ユ ー ス サポ ー タ ー ズ 」 イ ニシ ア チ ブ に 参加 する た め に 選出 され た 30 人 の 若者 は 、 これ か ら の 1 年 間 、 デ ジタル コン テン ツ の 開発 、 コ ミュ ニケ ー ショ ン 、 その 他 の YOG 関連 の 活動 の 面 で 組織 委 員 会 (GYOGOC) と 緊密 に 連携 し 、 開催 国 は も ち る ん 、 そ れ 以 外 で の 若者 と の エン ゲー ジメント も 後 押し し ます 。 と の イニ シア チ ブ は 3 月 末 に 開催 され た 第 1 次 IOC 調 整 委員 会 会 議 に お いて 発表 され た も の で 、 GYOGOC が 掲げ る ビジ ョ ン と 結び つい て いま す 。 「 よ り 良 い 未来 を 共に 生み 出す べく 、 若者 た ち が ス ボー ツ を 通じ て 平和 的 な 共生 と 団結 を 祝福 する 」 と いう ビジ ョ ン は 、 第 4 回 冬 地 ユー ス オ リ ン ピ ッ ク 競技 大 会 に 向け た すべ て の GYOGOC の 活動 の 基礎 と な り ま す 。 ※ オリ ン ピ ッ ク ・ ム ー ブ メ ント に た 関す る すべ て の ニュ ー ス は 、 o ル mp7cs.Co7m/foc に て ご 覧 に か れ ま す 「 オ リン ピッ ク の 持続 的 な 開催 を Ei ei @UIPA 07. bs cae yg オリ ン ピ ッ ク 江 原 道 大 会 が 開か れ ま す 。 より 多く の 若い トッ プア スリ ー ト が 大 会 を 通し て 恩恵 を 授かる こと に な る で し ょ う 」 IOC ト ー マ ス ・ バ パッ ハ 会 長"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ALL FLAVORS WELCOME 18 五輪 の 先 を 目指 し て "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 18-title\" style=\"top:132px;left:44px\" src=\"/tokyo2020/static/_content/18-title-1.png\">\n        <img class=\"halfScale 18-title\" style=\"top:265px;left:44px\" src=\"/tokyo2020/static/_content/18-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.staggerFromTo(cOf(\"18-title\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n        }\n        ",
    "searchText": " 五輪 の 先 を 目指 し て THESE GAMES WILL MAKE us PROUD 今夏 の 競技 大 会 は 特別 な 存在 な る だ ろう と 確信 し て いる 、 東京 2020 ス ポー ツ デ ィ レ クタ ー の 小谷 実 可 子 氏 が 、 組 織 委員 会 内 部 、 お よび 日 本 社会 で の ジェ ンダ ー 平 等 を 推進 する 取り 組み に つい て 語り ます 。 自身 一 人 の オリ ン ピ ア ン と し て 、 2020 私 年 東京 オリ ン ピ ッ ク 競 技 大 会 を 目指 す 選手 た ち が 現 在 経験 し て いる こと 、 ま た は 通ら な けれ ば な ら な か っ た 道のり を 考え る と 、 多く の こと が 脳裏 に 思い 浮か び ま す 。 本 来 で あれ ば 、 彼ら の 多く が 去年 の 夏 に 身体 的 に ビー ク を 迎 えて いた は ず で し た が 、 競技 大 会 史上 初 の 延期 に より 、 調整 の や り 直 し を し な けれ ば な り ま せん で し た 。 選手 に と っ て それ は 、 モチ ベー ショ ン を 維持 する と いう 点 に お いて 大 変 だ っ た こと と 思い ます 。 中 に は 年 齢 や その 他 の 要因 に より 、 オリ ン ピ ッ ク 出場 の 夢 を 諦め ざる を 得 な か っ た 選手 も いま す 。 延期 に に っ て キャ リア か ら 逸 脱し て し まっ た 選 手 も い れ ば 、 逆 に 充実 で きた と 思う 人 も いま す 。 平 時 で あれ ば 、 選手 は 毎日 練習 が 続き 忙し いた め 一 度 立ち 止ま っ て 自分 と 向き 合う こと は 困難 で す 。 と こる が 、 1 年 の 猫 予 が 与え られ た た め 、 自 分 が 今 し て いる こと を 自問 する 余裕 が で きた 選手 も いま し た 。 また 基礎 体力 を 付け る こと に 、 その 時 間 を 充て た 人 も いた で し ょ う 。 こ の よう に 1 年 の 待 期 期 間 に は 、 多 少 の ポジ ティ ブ な 要素 も 生ま れ ま し た 。 今 大 会 で は 来 日 し て も 、 選手 村 と 競技 会 場 の 往復 し か で き な い こと に スト レス を 感じ る 選手 も いる で し ょ う 。 し か し 、 誰 も が 同じ 条件 の 下 に いま す 。 誰が 世界 一 な の か を 決め る の に 同じ スタ ー ト ライ ン に いる の で す 。 阿部 一 二 三 対 丸 山城 志郎 の 1 試合 限定 の 「 ワ ンマ ッ チ 」 方 式 で 行わ れ た 、 男子 柔道 66kg Kh 日 本 代表 内 定 選手 決定 戦 を 振り 返 れ ば 分 か る で し ょ う 。 会 場 に は 観客 も 、 派手 な 演出 も 一 切 あり ませ ん で し た 。 そこ に いた の は 、 精 一杯 の 努力 を 惜しま ず 全身 全霊 で 試合 に 臨ん だ た っ た 2 人 の 選手 だ け で し た 。 これ こそ が スポ ー ツ の 感動 その も の で し た 。 こ の こと を すべ て の 選手 の 念頭 に 置 いて も らい た いと 顧 っ て いま す 。 今年 の 夏 の 金 メ ダ は 、 過去 の オリ ン ピ ッ ク で 猿 得 さ れ た 金メダル と な ん ら 変 わり ませ ん 。 今 年 の 大 会 は 、 参加 する すべ て の 選手 に と っ て 特別 な 体験 と な る で し ょ う 。 私 は 東京 オリ ン ピ ッ ク ・ パ ラリ ン ピ ッ ク 競 技 大 会 組織 委員 会 (東京 2020) の スポ ー ツ ディ レク ター と いう 役割 に 加え て 、 東京 2020 組 織 委員 会 の 橋本 聖子 会 長 より 、 組織 委員 会 の ジェ ンダ ー 平 等 推進 チー ム の ヘッ ド に 任命 され まし た 。 橋 本 会 長 は 、 私 に 対し て すぐ に 二 つ の こと を 指示 し まし た 。 ー つ は 迅速 に 物事 を 進め る こと 、 も うー つ は 私 た ちの 活動 を きち ん と 発信 する と いう こと で す 。 ター に 向け て 私 が 取っ た 最初 の アク ショ ン は 組織 内 部 に 働き か ける も の で し た 。 メッ セー ジ を 発信 する 立場 に ある 以上 、 私 は 、 組織 委 員 会 の 一 員 と し て 、 まず この 問題 に 関し て 、 組織 内 で の 理解 を 促進 する こと が 必 ^ 要 不可 欠 だ と 感 じ た の で す 。 そこ で アン ケー ト 調 査 を 実施 し た と こ る 、 様 々 な 回 答 を 得る こと が で きま し た 。 そ の 結果 、 私 た ちの 組織 が ジェ ンダ ー 平 等 、 ダイ バー シテ ィ 、 イン クル ー ジ ョ ン に 対し て 抱い て いる 考え を 知る こと が で きま し た 。 この 調査 の 過程 で 、 彼ら は 東 京 2020 に 向け た 自分 た ちの 取り 組み を 再 認識 で きた の で は な いか と 思い ます 。「 再 び 誇 り を 感じ る こと が で きた 」 と いう 回 答 も いく つか あり まし た 。 会 開催 後 、 東 京 2020 組織 委員 会 は 解散 し 、 メ ン バ ー は 元 の 職場 に 復帰 し た り 、 新しい 場所 へ と an その と き 、 彼ら は きっ と ジェ ン ー に 対す る 新た な 意識 と 姿勢 を 備え 、 そこ か ら ルーフ メン Mae に 広がる だ る うと 思っ て いま す 。 ジェ ンダ ー 平 等 推進 チー ム の ヘッ ド に 就任 し て 以来 、 多 くの一 般 の 人 た ちか ら 私 た ち が 目 指す 活 動 に つい て の 賛 格 と 期待 を いた だ いて いま す 。 世 間 か ら の 注目 が 大 きい こと を 実感 し 、 自分 が ジェ ンダ ー 平 等 や ダイ バー シテ ィ & イ ンク ルー ジョ ン を 推進 する 活動 に 関わ れる こと を と て も 嬉し く 思 いま す 。 他 の 皆さん と 同じ よう に 一 人 の スポ ー ツ 選 手 で あり 、 妻 で あり 、 母 で ある 私 で す が 、 た また ま 東京 2020 の スポ ー ツ ディ レク ター を 務め る こと に な り 、 ジェ ンダ ー 平 等 の 推進 に 取り 組ん で いま す 。 私 が この 仕事 を 通し て 考え が 変化 し た よう に 、 ぎっ と 多く の 人 に も 大 会 を 通し て 変化 が も た ら さ れる こと で し ょ う 。  最後 に も し 自分 の 願い が 叶う と し た ら 、 あく ま で 夢 の 話 で す が 、 今 大 会 に 参加 し た すべ て の 人 に 大 会 を 実現 する の は 選手 だ け で ! リー り 、 ラン ニッ ア 間 に 至 る まで 、 舞台 裏 で 職務 を 超え て 努力 を 注ぐ 人 た ち が た くさ ん いま す 。 彼ら が メダ ル を も ら う こ と は な いか も し れ ま せん が 、 この 歴史 的 な 東京 2020 オ リン ピッ ク 競 技 大 会 に 携わっ た こと を 一 生 誇り に 思っ て いた だ きた いで す 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      <a class=\"addContentLink\" href=\"http://alizila.com/\" target=\"_blank\" style=\"top:871px;left:363px;height:14px;width:64px;\"></a>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "LET HOPE SHINE BRIGHTER TOGETHER As the official Cloud Services and E-Commerce Platform Services Partner, Alibaba Group is proud to support the Olympic Games. Alibaba Group is the world’s largest retail commerce company, building the infrastructure of commerce from marketplaces, logistics, to cloud. ! 1 For more information, visit Alibaba’s corporate news site Alizila.com. WORLDWIDE PARTNER"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 20-title\" style=\"top:201px;left:77px\" src=\"/tokyo2020/static/_content/20-title-1.png\">\n        <img class=\"halfScale 20-title\" style=\"top:347px;left:84px\" src=\"/tokyo2020/static/_content/20-title-2.png\">\n        <img class=\"halfScale 20-title\" style=\"top:492px;left:77px\" src=\"/tokyo2020/static/_content/20-title-3.png\">\n\n        <a href=\"https://www.youtube.com/watch?v=sHXcWvZr-9c\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px;height:50px;left:514px;top:693px;overflow:visible;\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.staggerFromTo(cOf(\"20-title\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          removeContentLinks()\n        }\n        ",
    "searchText": "20 東京 まで の 長い 道のり (②66 め THE LONG Road TO TOKYO 競技 も 国 も 異な る 6 人 の 選手 が 、 新 型 コ ロナ ウイ ルス 感染 症 の 葛 延 が も た らし た 困難 な 状況 を そ ど の よう に 対処 し た か 、 そ し て 東京 2020 オ リン ピッ ク 競 技 大 会 の 延期 に 際 し て 、 いか に し て 究極 の 目標 に 向かっ て トレ ー ニ ング を 行い 、 集 中 力 を 保っ て きた か に つい て 語り ます 。 文 : リア ・ ハ ー ヴ ィ ー"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "21 Olympic Review Issue 116"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 22-title\" style=\"top:219px;left:47px\" src=\"/tokyo2020/static/_content/22-title-1.png\">\n        <img class=\"halfScale 22-title\" style=\"top:423px;left:45px\" src=\"/tokyo2020/static/_content/22-sub-1.png\">\n        <img class=\"halfScalCe 22-img\" style=\"top:296px;left:142px\" src=\"/tokyo2020/static/_content/22-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.staggerFromTo(cOf(\"22-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"22-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg22Anim.stop();\n        }\n        ",
    "searchText": " 「 それ で も 金メダル の 魅力 は アデ リン ・ グ レイ アメ リカ 合衆国 、 レ スリ ング デリ ン ・ グ レイ が 生ま れ た の は 、 デン バー 州 コ ロラ ドス プリ ング ス に ある 一 流 の オリ ン ピ ッ クト レー ニン グセ ンタ ー か ら 、 わずか 1 時 間 の 場所 。16 歳 に な る 頃 に は レス リン グ に 身 も 心 も 夢中 に な り 、 アメ リカ 代表 チー ム の 先輩 女性 選手 と 一 緒 に トレ ー ニ ング を し て い まし た 。 17 歳 の 時 に は 、 初め て 世界 ジュ ニア 選手 権 で 優勝 を 収め まし た 。 その 後 、 パ ン ア メリ カン レス リン グ で 2 度 チ ャ ン ピ オ ン の 座 に 輝き 、 五 つの シニア 世界 タイ トル を 獲得 し た 唯一 の アメ リカ 人 と な り ま し た 。 30 歳 の 時 に 大 き な 期 待 を 背負 っ て 参加 し た リオ 2016 で は 75kg 級 の 種目 に 出場 し まし た が 、 準々 決勝 で わずか 1 点 と いう 僅差 で 惜敗 し まし た 。 東京 2020 が 間近 に 迫っ た 今 、 彼女 は 2 回 目 と な る オリ ン ピ ッ ク 競 技 大 会 で 重量 級 の レス リン グ タ イト ル を 獲得 する 初 の アメ リカ 人 女性 と な る と いう 、 た っ た 一 つの 目標 を 掲げ て いま す 。 アメ リカ が ロッ クダ ウン に 突入 し 、 グ レイ は 妹 の ジェ ネヴァ や チー ム メイ ト と 一 緒 に トレ ー ニ ング を 行っ て いた オリ ン ピ ッ クト レー ニン グセ ン ター か ら の 退去 を 強い られ 、 夫 と 妹 、 そ し て 友人 1 人 と 共同 生活 を 始め ま し た 。 同 じ く レス ラー で ある ジェ ネヴァ が トレ ー ニ ング パー トナ ー と な り 、 ト レー ニン グマ ッ ト の 代わ り に 芝生 や カー ペッ ト の 上 で 練習 し 、 草 染 みや 3 擦 に 悩ま され な が ら も 、 腹 筋 が 鍛え られ る くら い 笑 い に 満ち た 日 々 を 過 ご し まし た 。 夫 と 私 の 当初 の 家族 計画 で は 、 今頃 は 妊娠 期間 中 の は ず で し た 。 私 は オリ ン ピ ッ クト レー ニン グセ ン ター で 生活 し て お り 、 大 会 後 ま で そ こ に 滞在 する 予定 で し た 。 全国 的 な ロッ クダ ウン が 施行 され た 時 、 ト レー ニン グセ ンタ ー か ら 3 日 以内 に 退去 する よう に 言わ れ ま し た 。 その 時 点 で は 「 セ ンタ ー が 封鎖 され る か も し れ な い 」 と の こと で し た が 、 翌 日 に は 色 日 退去 を 求め られ まし た 。 当 5 の 5 人 9/ き 24 の ET ol Uae i 9 ば いい の か ? ど と で トレ ー ニ ング | すれ ば いい の か ? ど と で 寝れ ば い い の か 2?2」 と いっ た 考え で いっ ぱい で し た 。 それ は と て つも な く 不 安 な 時 間 で し た 。 短 期間 で は あり まし た が 、 私 た ち は ホ ー ム レス に な っ た の で す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.youtube.com/watch?v=uncfcHheQTM\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:44px;top:347px; overflow:visible; \" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "自宅 で トレ ー ニ ング を する こと に な り 、 いつ も 通り また は それ に 及ば な い パ フォ ー マ ン ス を 発 押す る の で に ミニミニ ルリ 2 る] に まま 要 か と いう こと と に 気づか され まし た 。 普段 な ら 充実 し た リソー ス や 一 流 の 設備 に 恵まれ て お り 、 最 大 限 の 力 を 発揮 する と と が で きた た め 、 同 じ 練 習 を 千 回 も 繰り 返す 必要 は あり ま せん で し た 。 この こと に より 、 自分 の トレ ー ニ ング は 科学 の 力 と 他人 の 努力 の 上 に 成り 立っ て いる こと に 気 づか され まし た 。 また 、 レ スリ ング を カー ペッ ト 上 で する こと が 極め て 難 し いこ と と も 学び まし た 。 その せい で 3 りら と ピス ム れ が 多く 生じ まし た 。 それ で も 金メダル の 的 力 は 色 宰 せ て いま せん 。 オリ ン ピ ッ ク の 勝者 と いう 功績 は 一 生 も の で す 。 長年 目 標 と し て きた 金メダル を 獲 得 で き た 脚 間 は 格別 の も の に な る で し よ ょ Prabal Sear es aN ALOBFCIM, REOKST は た また ま 運 に 恵まれ ませ ん で し た 。 た っ た 1 点差 で 敗れ て し まっ た の で す 。 日 本 は 女子 レスリング で トッ プ の 地位 に あり 、 今 競技 大 会 で も 手 強い 日 本 人 選手 と の 対戦 が 待っ て いま す が 、 幸 い に も 私 と 同じ 階級 の 日 本 人 女性 選手 (皆川 博 恵 ) と は 別 の 重量 グル ー プ と な り ま し た 。 2019 年 レス リン グ 世 界 選手 権 の 決勝 戦 で 対戦 し た の で 、 あえ て 分 け 戦 す る と し た ら 、 そ の 時 は 彼女 の 母 国 が 舞台 で す 。 彼女 が 決勝 戦 ま で 勝ち 進み 、 決勝 の 舞台 で 対戦 で き る こと を 願っ て いま す 。 相手 の ホー ム で 試合 に 出場 する こと に 対し て 多 少 緊 張 は し て いる も の の 、 日 本 で 彼 女 の よ うに 偉大 な ライ バル と 対戦 で きる こと に 胸 を 躍ら せ て いま す 。 私 た ち が 今 で も 復活 力 と 精神 カ を 備え て いる こと を 示し 、 この 時 期 を 乗り 越え る た め の 力 を 女性 た ち に 与え る こと が で きる の な ら 、 ぜひ 自分 自身 が 希望 の 象徴 と な る その 光 と な り た いで す 。 1 世界 チャ ン ピ オ ン に 5 回 輝い た 実績 を 持ち な が ら も 、 今回 が 初 の オリ ン ピ ッ ク メ ダ ル へ の 挑戦 と な る アデ リン ・ グ レイ 選手"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 24-title\" style=\"top:269px;left:45px\" src=\"/tokyo2020/static/_content/24-title-1.png\">\n        <img class=\"halfScale 24-title\" style=\"top:494px;left:45px\" src=\"/tokyo2020/static/_content/24-sub-1.png\">\n        <img class=\"halfScalCe 24-img\" style=\"top:365px;left:120px\" src=\"/tokyo2020/static/_content/24-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.staggerFromTo(cOf(\"24-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"24-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n        }\n        ",
    "searchText": "レン 東京 まで の 長い 道のり 「 若い 世 代 を イン スパ イア する こと が 私 の 最大 の 目標 で す 」 土井 レミ イ 杏 利 日 本 、 ハ ンド ボー ル ラン ス 人 の 父親 と 日 本 人 の 母親 を 持つ 土井 レミ イ 人 杏 利 が ハン ド ノ ボー ル を 始め た の は 、 小 学校 で の こと で し た 。 ハン ド ボ ー ル で は 国内 の トッ プク ラス に 君臨 する 日 本 体育 大 学 に 通っ た 後 、2012 年 に フラ ンス に 移住 し 、 同国 の トッ プリ ー グ に 属す る シャ ン ベ リ ・ サ ヴォ ワ ・ ハバ ハンドボール の セカ ンド チー ム の 選手 と な り ま し た 。 その 後 問 も な く ト ッ プ チー ム の 選手 へ と 昇格 を 果たし 、 プ ロ へ と 転向 し まし た 。 フラ ンス で 選手 と し て 6 シー ズン 活躍 し た 後に 日 本 に 帰国 し 、 代表 チー ム の 向上 に 貢献 し て いま す 。 現在 は 「 大 崎 電気 」 に 所 属し 、 日 本 ハン ド ボ ー ルリ ー グ で プレ ー す る と 共に 日 本 代表 チー ム の キャ プ テ ン を 務め て いま す 。 土井 に と っ て 東京 2020 は 初め て の オリ ン ピ ッ ク 競 技 大 会 で す 。 大 会 が 延期 され た 時 、 日 本 の 自宅 か ら SNS の TikTok で の 配信 を 始め 、 ハン ド ボ ー ル の 知名 度 ア ッ プ に 努め まし た 。 自宅 で 録画 し た 動画 を 通じ て ダン ス や お も て な し の 様子 を 紹介 し 、200 万 人 以上 の フォ ロワ ー を 獲得 し て いま す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " た ず ね られ し が た いで す 。 て も 、 な 』 | オリ > foci 自分 に と っ て すべ て 今回 が 初め H 本 で は ハン が まだ 低い の で 、 特別 な ボー ル の 自分 、 そ し て 7 が きっ か と な っ て 多く の 人 人 が ハン ド ボ ー ル し て くれ る こ 突き 詰め れ ば 人 々 9 Eus に | も 、 大 切な も の は あり ませ ん 。 し か し 同時 に 自分 は スポ ー ツ 選手 スポ ー ツ 選手 と じ て オリ ン ピ ッ ク 競 技 大 会 で 戦い た い の で す 。 新型 コロ ナウ イル ス 感 染 症 の パン デミ ッ ク の 最 中 で も 、「 競 技 大 会 は 必ず 開催 され る 。 自分 は そ こと で 全力 を 発揮 する 。 だ か ら 精 一 杯 トレ ー ニ ング に 励む べき だ 」 と 常 に 自分 に 言い 聞か せ 、 そう 信じ て ぎ トレ ー ニ ング を 行う こと を 祭儀 な く され まし 2EY 4 た コッ 自分 と し て は さら に 1 年 トレ ー ニ ン グ を する 余裕 が で きた と 感じ まし た し 、 故障 し て いた 部 分 も あり まし た の で 、 自 束 期 間 に 治療 に 専念 し 、 前 より も 力 を 付け る こと と が で きま し た 。 その 間 、 いつ も 前 向き な 雇 勢 を 保つ よう に 心がけ まし た 。 前 年 は 四 六 時 中 チー ム メ イト と 一 緒 に 過ごし で い た の で 、 むし る 1 人 で 過 ざ さす 時 間 を 楽し むこ と が で きま し た 。 時 に は と の よう な 時 間 が 必要 で す 日 本 の 男子 ハン ド ボ ー ル チー ム は 今 絶好 調 で す の で 、 競技 に 出場 する こと を 心から 楽し み に し て いま す 。 究極 の 目標 は 金メダル を 手 得 す る こと で す が 、 何より も 若い 世代 を イン スパ イア し 、 ハン ド ボ ー ル を 楽 し ん で も ら う こと を 目標 と し て いま す 。 自分 に と っ て は 、 勝つ こと その も の より も 身 を も っ て ファ イ テ ィ ン グ ス ピ リッ ト を 示す こと が 重要 だ と 思っ て いま す 。 日 本 で ハン ド ボ ー ル へ の 注目 度 と 露出 を さら に 高め た い の で す 。 パン デミ ッ ク の 期間 中 に TikTok 動画 を 製作 し まし た が 、 その 主 な 理 由 は ハン ド ボ ー ル の 知名 度 を 高め る こと で し た 。 パン デミ ッ ク 中 は 深 刻 な スト レス 状態 に あっ た の で 、 ス トレ ス か ら 自 分 を 解放 する こと は ぎ き わ め て 重要 で し た 。 ファ ン か ら 動 画 に 対す る 好意 的 な コメ ント を 多く 得 る こと が で きた こと は 大 き な 心 の 支え と な り ま し た 。 オリ ン ピ ッ ク 競 技 大 会 は 自分 の 夢 で す が 、 あく まで も 安全 に 開催 し て ほし いで す 。 それ が 何より も 重要 な こと だ か ら で す 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 26-title\" style=\"top:129px;left:52px\" src=\"/tokyo2020/static/_content/26-title-1.png\">\n        <img class=\"halfScale 26-title\" style=\"top:292px;left:45px\" src=\"/tokyo2020/static/_content/26-sub-1.png\">\n        <img class=\"halfScalCe 26-img\" style=\"top:161px;left:158px\" src=\"/tokyo2020/static/_content/26-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.staggerFromTo(cOf(\"26-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"26-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n        }\n        ",
    "searchText": " 26 東京 まで の 長い 道のり 「 私 た ちの 誰 も が ウェ イド ・ バ ン ニ ー キ ルク 南ア フリ カ 、 陸 上 競技 2017 年 、 2 度目 の 世界 400m タイ トル に 挑む ウェ イド ・ バ パン ニー キル ク 選 手 ェ イ ド ・ バ パン ニー キル ク は 、 南ア フリ カ の ケー プ タ wy) ウン に 住む せ ス ポー ツ 一 家 に 生ま れ ま し た 。 母親 の オデ ッ サ ・ シ ュ ワ ー ツ は 元 ス プリ ンタ ー で 、 従妹 の チェ スリ ン ・ コ ルビ も 、 リオ 2016 で 7 人 制 ラ グ ビ ー に 初出 場 し 、 銅 メダ ル を 獲得 し て いま す 。 2010 年 世界 陸上 競技 選手 権 大 会 で は 200m 走 を 21.02 秒 で 走り 、4 位 に 入賞 する と いう 、 初め て の 華々 し い 成績 を 残し まし た 。 後に 400m で も 頭角 を あら わし 始め 、 2015 年 に は 400m 世界 チャ ン ピ オ ン に まで 上 りつ め ま し た 。 リオ で は これ まで 獲得 し た メダ ル に 加え て 金メダル を 獲得 し 、1 年 後に は 400m で 世界 タイ トル を 、200m で は 銀メダル を 手 に し まし た 。 現在 400m の 世界 記録 お よび オリ ン ピ ッ ク 記 録 保持 者 で ある バン ニー キル ク は 、 2017 年 に は 100m、 200m、 300m、 400m で サブ 10、 サ ブ 20、 サブ 31、 サ ブ 44 秒 を 達成 し た 史上 唯一 の スプ リン ター と な り ま し た 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top: 13px;left:699px;height:76px;width:18px;\">\n        <a href=\"http://omegawatches.com/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": " TOKYO 2020 OFFICIAL TIMEKEEPER SEAMASTER DIVER 300M  As the Official Timekeeper of the Olympic Games, OMEGA is celebrating this summer's historic event with a new 42 mm timepiece in stainless steel. Built in the colours of Tokyo 2020, this exclusive Master Chronometer watch features a blue ceramic bezel, a white ceramic dial and the competition’s emblem transferred under the sapphire crystal on the caseback. ( ) OMEGA  omegawatches.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.youtube.com/watch?v=xG91krXuxyw\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:44px;top:150px; overflow:visible; \" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 私 は 南ア フリ カ の 指導 者 た ちの 指 従い 、 寄せ られ た 期待 に 応え る よう に 最善 を 尽く すし か な いと 考え て いま し た 。 多少 怖かっ た こと は 否め な い 事 実 で す 。 オリ ン ピッ ク 競 技 大 会 が 刻 一 刻 と 迫る 中 、 え ず 、「 ト レー ニン グ を する べき な の か 2? 競技 に 出場 する の か ?」 と 答え の な い 問 い を 自身 に 投げ か け 、 スト レス を 感じ て いま し た 。 望み 通 り の 理想 的 な トレ ー ニ ング を する こと は 叶い ませ ん 。 今 で も 希望 通 り の トレ ー ニ ング が で き な い こと も あり ます が 、 徐々 に 、 で も 確実 に 競 技 イ ベン ト が 普段 通り の 状況 に 戻 りつ つ あ る こと は 喜ば し いで す 。 オリ ン ピ ッ ク 競 技 大 会 が 延期 さ れ た こと を 受け 入れ て か ら は 、 雄 力 を 重ね 、 ト レー ニン グ を 行い 、 でき る 限り 強く な る こと に 専念 し よう と 心 に 決め まし た 。 今 と な っ て は トッ プア スリ ー ト に 返り 咲く と と が で きた の で 、 その よう な 姿勢 を 買い て よかっ た と 思い ます 。 シー ズン は 始 まっ た ば か り で す 。 この こと は 私 に と っ て 原動力 で あり 、 体 作り を 後 押 し し て くれ る 要素 で も あり ます 。 た と え 私 た ち が パ ン デ ミッ ク の 渦中 に ある うと も 、 向上 し 、 成長 す る 余地 は 必ず あり ます 。 私 た ち が 皆 健康 で 元気 な と と は 喜ば し いこ と で す 。 私 た ちの 誰 も が 今 で も 実 と て も 前 向き な こと で すし 、 か つ 感 謝 す べき こと と だ と 感じ て いま す 。 中 に は 愛す る 人 、 家族 、 友人 を 失っ た 人 た ち も い ます 。 私 た ち が 、 今 前 に 向かっ て 動け る の は 、 当たり 前 の こ と で は な い の で す 。 南ア フリ カ で は 完全 な ロッ クダ ウン が 施行 され まし た 。 何 か 月 も 自 宅 で 過ごさ な けれ ば な ら か っ た の で 、 言 うま で も な いこ と で す が 家 族 や 友人 に 会 えな く て 寂し い 思 い を し まし た 。 し か し な が ら 、 妻 と 有意 義 な 時 間 を 過ごす こと が で きま し た し 、 その 間 に ト レー ニン グ を 重ね て 、 ゆっ くり で は あり ます が 以前 の よう な 暮らし が 戻っ て きた と き の た 私 は オリ ン ピ ッ ク 競 技 大 会 を 目 指し て 全身 全土 で 取り 組ん で お り 、 競技 に 向け て 準備 万 端 の 健康 な 体 を 維持 し て いま す 。 私 た ち は 皆 、 常 に 目指 し て きた ゴー ル に 目 を 向け て いま す 。 オリ ン ピ ッ ク 競 技 大 会 は 、 選 手 た ちの 陸上 競技 の キャ リア に お ける 最大 の メイ ン イ ベン ト で す 。 才能 を 遺 翌 な く 発揮 し 、 母 国 を 代 表し 、 世界 の トッ プレ ベル の 選手 た ちと 戦う 貴重 な 機会 で す 。 今 まで に 経験 し た こと が な いよ うな 体力 の 限界 に 挑む こと に な り ま す が 、 こ れ を 機会 に 自分 の 前 に 立ち は だ か っ て きた いか な る 限界 や 壁 も 乗り 越 えた いと 思っ て いま す 。  1 と と 数 年 怪我 に 悩ま され 、 つ い 最 近 国 際 競 技 試 合 へ の 出場 を 再開 し た ば か り の バン ニー キル ク 選 手 2 全力 疾走 の スタ ー ト に 全集 中"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:266px;left:58px;height:17px;width:220px;\">\n        <a href=\"http://gettyimages.com/editorial-images/sport\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:290px;left:33px;height:12px;width:13px;\">\n        <a href=\"https://www.instagram.com/gettysport/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:290px;left:49px;height:12px;width:14px;\">\n        <a href=\"https://twitter.com/gettysport/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:820px;left:32px;height:12px;width:150px;\">\n        <a href=\"mailto:eugene.cariaga@gettyimages.com\" target=\"_blank\"></a>\n      </div>\n    ",
    "script": "\n        function onPageEnter() {\n          addContentLinks() \n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": " BACK ON TRACK For the latest sports coverage of all major competitions, including every medal of the upcoming Tokyo 2020 Olympic Games, visit gettyimages.com/editorial-images/sport For coverage and licensing queries please contact Eugene Cariaga: gettyi aa | ges eugene.cariaga@gettyimages.com 82385468, Clive Rose Offcial photographic agency of the IOC"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 30-title\" style=\"top:221px;left:46px\" src=\"/tokyo2020/static/_content/30-title-1.png\">\n        <img class=\"halfScale 30-title\" style=\"top:387px;left:45px\" src=\"/tokyo2020/static/_content/30-sub-1.png\">\n        <img class=\"halfScalCe 30-img\" style=\"top:257px;left:127px\" src=\"/tokyo2020/static/_content/30-img-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:219px;left:46px;height:70px;width:276px;\">\n          <a href=\"https://iocnewsroom.com/video/dutch-based-iranian-taekwondo-athlete-dina-langeroudi-selected-for-the-ioc-refugee-olympic-team-to-compete-in-tokyo-2020/\" target=\"_blank\"></a>\n        </div>\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.staggerFromTo(cOf(\"30-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"30-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg30Anim.stop();\n          removeContentLinks()\n        }\n        ",
    "searchText": " すべ て を 賭け て きま し た 」 ディ ナ ・ プ ー リ ョ ネス IOC 難民 選手 団 、 テ コン ドー  ーー イナ ・ プ ー リ ヨ ョ ネス の 両親 は 共に テコ ンド ー の グラ ンド マス ター で 、 彼女 に と っ て 初め て の コー チ で も あり まし た 。 幼少 期 に イラ ン の ラン ゲル ー ド に ある 実家 の 地下 の トレ ー ニ ング セン ター で 2 人 が トレ ー ニ ング する 様子 を 見 て いた こと か ら 、 自分 も 練習 を 始め まし た 。7 歳 の 時 に テコ ンド ー イ ラン 国内 児童 選手 権 で 金メダル を 獲得 し 、 そ の 後 8 年 に わた っ て イラ ン 代 表 チ ー ム の 選手 と し て 活躍 し まし た 。  と と ころ が 2014 年 、22 歳 の ブ プー リョ ネス は トレ ー ナ ー の ラミ ン ・ パ ディ ダー ル と 共に オラ ンダ を 目指 し て 長く 、 危険 な 旅 に 出 ま し た 。 そ し て テル アー ペル に ある 難民 収容 セン ター に て 難民 申請 を し た の で す 。 過去 7 年 に わた り 、 彼女 は オラ ンダ 中 の 五 つの 都市 と 太 つ の 異な る 難民 収容 セン ター を 転々 と し 、 困難 な 状況 に あり な が ら も テコ ンド ー の 練習 を 行い 、 BS を 実現 させ よう と 励ん で きま し た 。  彼女 は イラ ン 系 オラ ンダ 人 で 、 後に コー チ を 務め る こと に な る 師 、 マン ニ ・ ザ レイ と 出会い 、 彼 に 稽古 を つけ て も ら う た め に 、 バ ス で 1 時 間 か か る ハー グ ま で 通い まし た 。 こう し た 逆境 に あり な が ら 、29 歳 の 彼女 は 、 コ ー チ に 助け られ つつ 、 世界 の 舞台 で 活躍 し て きま し た 。 これ まで に 獲得 し た メダ ル は 、 ヨー ロッ パテ コン ドー 選手 権 で 獲得 し た 銀メダル を は じ め 、 際 試 合 で 35 個 以上 に 上 り ま す 。  オリ ン ピ ッ クソ リ ダ リ ティ 難民 選手 支援 プロ グラ ム と ワー ルド テコ ン ドー の 奨学 金 制度 が 資金 と サポ ー ト の 面 で 彼女 を 支え て お り 、 トレ ー ニ ング や 国際 試合 へ の 参加 を 実現 し て いま す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "  Olympic Review Issue 116 31 パン デミ ッ ク が 発生 し た 時 、 脳裏 を 様々 な 考え が 横切り まし た 。 夢 叶え る た め に すべ て を 賭け て きま し た し 、 先 の 見 えな い 人 生 に 大 き な 精 神 的 負担 も 感じ て きま し た 。 心 か ら 大 好き な 競 挟 、 そ し て オリ ン ピ ッ ク 競技 大 会 に 向け た 夢 な くし て 、 自分 の 将来 が どう な る の か 見 当 が つき ませ ん で し た 。 オラ ンダ で テコ ンド ー は 普及 し て お ら ず 、 著名 な 選手 と 一 緒 に トレ ー ニン グ す る こと も で きま せん 。 それ に も か か わら ず 、 ご くわ ず か な 資金 で や りく り し な が ら パ ー ト ナー な し で 6 年 間 ト レー ニン グ を 重ね 、 な ん と か 実績 を 残し て きま し た 。 私 の 場合 は 、 パ ン デ ミッ ク の 影 響 は 少な い 方 だ っ た と 言え る か も し れ ま せん 。 これ まで も チー ム の サ ポー ト な ど あ り ま せん で し た し 、 自 宅 で 家庭 用 の ジム 用 品 で 自分 一 人 で トレ ー ニ ング を し て きま し た 。 世 界 的 な ロッ クダ ウン は 私 より も 代 表 チ ー ム に 所 属す る 他 の 選手 た ち に と っ て 大 き な 衝 撃 だ っ た の で は IOC 難民 選手 団 初 の メダ リス ト に な る ー 夢 を 抱く ディ ナ ・ プ リョ ー ネ ス 選手 の ID で: 内 私 は 、 エ リー ト 選 手 が 経験 する こ 外 的 な 状況 の 中 で トレ ー ニ ング し て きま し た 。 過去 7 年 の 間 、 私 は 6 か 所 の 難民 収容 セン ター に 滞在 し まし た 。 雨 の 中 、 公 園 の 中 、 タ イル や 石 の 床 の 上 な ど で も トレ ー ニ ング を し まし た 。 私 は テコ ンド ー を 心 の 底 か ら 愛 し て いま すし 、 オリ ン ピ ッ ク 競 技 大 会 へ の 出場 資格 が 得 ら れ た ら 、 こ ん な に 嬉し いこ と は あり ませ ん 。 私 は IOC 難 民 選 手 団 の 一 員 で あり 、 その こと に 大 き な 誇 り を 持っ て い ます 。 チー ム を 代表 し て 、 すべ て の 難民 の た め に ベス ト を 尽く し た いと 思っ て いま す 。 メダ ル を 獲得 する こと は この 上 な い 偉 業 と な る で し ょ う 。 な ぜ な ら 、 Ed tale ORG LOLS eae eae は な く 、 大 変 な 努力 家 で ある こと を 世界 に 対し て 示せ る か ら で す 。 私 た ち は 、 一 般 の 人 々 に と っ て は 当たり 前 な こと が で き な い が 故に 、 人 一 倍 マカ を 強い られ て いま す 。 他 の 選手 は 家族 や 自国 の 支援 を 受け つつ 自 分 の 国 で 生活 する こと と が で きま す 。 cat Py に っ 得 > さ ョ を は じ め と する 、 あり と あら ゆる サ ポー ト を 利用 で きま す 。 私 た ち が 抱 えて いる 困難 は あま り に 大 きく 、 た だ 出場 資格 を 得 ら れる だ け で も 多 RO hoes eel a 内 私 に と っ て 、 オ リン ピッ ク 競 技 大 BUICHBI STL, CHECOB 力 と 進ん で きた 道 が 正しかっ た と いう 証 で す 。 私 は 毎日 、 日 に 2 回 か ら 3 回 必ず トレ ー ニ ング する と 自分 に 交 い まし た 。 決し て 簡単 な こと で は あり ませ ん が 、 そう 決め た こと を 誇り に 思っ て いま す 。 別 の 生き 方 を 選ぶ こと は 簡単 で し た 。 で も 、 私 は 夢 を 追い 求め る こと を 心 に 決め ま し た 。 力 の 限り を 尽く し て きま し た の で 、100% の 状態 で 競技 に 臨め る と 信じ て いま す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 32-title\" style=\"top:240px;left:44px\" src=\"/tokyo2020/static/_content/32-title-1.png\">\n        <img class=\"halfScale 32-title\" style=\"top:435px;left:45px\" src=\"/tokyo2020/static/_content/32-sub-1.png\">\n        <img class=\"halfScalCe 32-img\" style=\"top:314px;left:102px\" src=\"/tokyo2020/static/_content/32-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg32Anim = new TimelineMax();\n          pg32Anim.staggerFromTo(cOf(\"32-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"32-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg32Anim.stop();\n        }\n        ",
    "searchText": " 「 と て つも な く 大 き な プ レッ シャ ー を 感じ て いま す 」 シレ ング ペレ ンジ チェ コ 共 和 国 、 スポ ー ツ クラ イミ ング ミン グ を し て いま し た 。 彼 に と っ て 最初 の 挑戦 は 、 チェ コ 共 和 国 に 位置 する モラ ヴィ ア ・ カ ルス ト 洞 窟 郡 の つる つる し て 滑り や す い 岩 で の クラ イミ ング で し た 。 難関 の アセ ント を 制覇 し た こと は 最高 の 教 証 と な り 、 それ が 自分 の スキ ル 向 上 に つなが っ た と 彼 は 自認 し ます 。 実 ライ マー の 両親 を 持つ アダ ム ・ オ ンド ラ は 、 幼少 時 代 か ら クラ イ 際 、 そ れ が 功 を 奏し て これ まで に IFSC ク ライ ミン グ ワ ー ル ドカ ッ プ を 7 回 、 IFSC ク ライ ミン グ ・ 世 界 選手 権 で 5 回 優勝 し た 実績 を 誇っ て いま す 。 9 歳 に な る 頃 に は すでに クラ イミ ング に 夢中 に な っ て お り 、 両親 は 長い 週末 休暇 を 取っ て は 彼 を ヨー ロッ パ 中 の あら ゆる エキ サイ ティ ング な 険 し い 岩 山 に 運 れ て 行き まし た 。 プロ の クラ イマ ー に な る と いう 夢 は 、 プロ 契約 の スポ ン サ ー が 付い た 10 歳 の 時 に 実現 し まし た 。 そ の 後 、 ノ ルウ ェ ー の サイ レン ス で フリ ー ク ライ ミン グ に よる 初 登 を 含め 、 世界 で も っ と も 難 関 と され る 複数 の アセ ント を 成し遂げ まし た 。 2016 年 に スポ ー ツ クラ イミ ング が オリ ン ピ ッ ク プ ログ ラム の 競技 と し て 加わ っ た こと か ら 、 オ ンド ラ は 自分 に と っ て の 最大 の 挑戦 に 立ち 向かう 決心 を し まし た 。 複合 種目 で ある こと か ら 、 ボル ダリ ング と リー ドク ライ ミン グ で 培っ た ノウ ハウ だ け で は 不 十分 で 、 彼 は スピ ー ド クラ イミ ング も マス ター し まし た 。 オリ ン ピ ッ ク 競 技 大 会 は 自分 の 夢 で 、 それ が よう や く 実 現し つつ あ り ま す 。 私 の 出身 国 で ある チェ コ 共 和 国 は 小さ な 国 で す の で 、 メダ ル 獲 得 が 有望 な 選手 は それ ほど 多く な く 、 プ レッ シャ ー も 大 きい で す 。 競技 大 会 の 延期 が 発表 され た と き は むし る 自分 に と っ て 有利 に な る と 思い まし た し 、 モチ ベー ショ ン の 面 で 問題 を 抱え た こと は 一 度 も あ り ま せん で し た 。 延期 と な っ た か ら こそ 、 トレ ー ニ ング と 努力 を 重ね る こと と に 専念 で きる 時 間 的 余裕 が 生 まれ 、 と の 日 程 変 更 は メリ ッ ト に な る と 思い まし た 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.youtube.com/watch?v=DBFZPJKbb_g\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:414px;top:445px; overflow:visible; \" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#0e0e0e\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#0e0e0e\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1 2021 年 5 月 、、 ア メリ カ の ユタ で ま 開催 され た ワー ルド カッ プ ・ イ ベン ト に 還 出場 する アダ ム ・ オ ンド ラ 選 手 2 オン ドラ 選手 は 、 こ の 1 年 で 趣向 を i, 凝ら し た 練習 方 法 を 考案 し て きま し た | 競技 大 会 に 向け た 準備 は 2 年 前 に 始め まし た 。 あ まり 楽し いと 思 な い ス ピー ドク ライ ミン グ の トレ ー ニン グ を する こと は 、 数 か 月 に わ た っ て 取り 組ん で いる 大 き な 課 題 で す 。 子供 の ころ か ら リ ー ド クラ イ ミン グ と ボル ダリ ング の 練習 を 続 け て きま し た が 、 東京 2020 大 会 で は 複合 種 肌 な の で 、 ジム に 入り 浸 り に な っ て いま す 。 ス ピー ドク ライ ミ ング は 文字 通り ゼロ か ら 始 め た た め 、 一 定 の レベ ル に 到達 する こと は 容易 で あり ませ ん 。 クラ イミ ング で は 落下 の 恐怖 が つき まとい ます が 、 長年 の 経験 が あ る の で 、 その 点 は 問題 で は あり ませ ん 。 自分 は ( 高 所 で 起こ と りや すい ) め まい に 悩ま され る こと も な く 、 また 、 自分 の 耳 を 信頼 し て いま す 。 それ で も や は り 、 失敗 の 恐怖 は あ り ま す 。 失敗 を 避け る こと は で きず 、 対処 する 以外 あり ませ ん 。 これ まで 世界 中 で 競技 に 参加 し 、 数 多く の 重要 な ルー ト で クラ イミ ング を し て きま し た が 、 オ リン ピッ ク に 関し て は 、 と て つも な く 大 き な プ レッ シャ ー を 感じ て いま す 。 これ ほど の プレ ッ シャ ー を 感じ た こと は 今 まで 一 度 も な いと 思い ます 。 クラ イミ ング に お いて は 身体 的 能力 だ け で な く 、 ルー ト の 読み が 肝 心 で す 。 RCIA, RETR ATI KD H, も っ と も 簡単 な ルー ト を 探し 出す こと の 方 が 重要 に な り ま す 。 リー ド ルー ト 上 で ほん の わずか な 足 の 滑 り が 取り 返し の つか な い 結 果 に つ な が る 可能 性 を 知り な が ら 、 一 上 一 瞬 に 向け て 身体 的 、 そ し て 心理 的 な 側面 を 組み 合わ せ て いく こと は き わ め て 難し いこ と で す 。 た だ 、 腹 を 決 め て 突き 進む 、 そ し て 自分 の 自信 と 直感 に 頼る し か あり ませ ん 。 数 年 前 だ っ た ら 、 た と え オ リン ピッ ク 競 技 大 会 で さえ 、 自分 に と っ て 最大 の 誇り で ある ノル ウェ ー の サ イレ ンス の アセ ント に は 匹 英 し な い と 発言 し た で し ょ う 。 し か し 、 今回 の 延期 に よっ て 、 競技 大 会 の 価値 は よ り 高まっ た よう に 思い ます 。 自分 に と っ て 、 も の の 価値 は 、 そ の た め に どれ だ け の 努力 を 重ね た か が 基準 に な っ て いま す 。 今回 は 、 た っ た 一 つの クラ イミ ング 競技 に 向け て 、 A 分 の 想像 を 逢 か に 超え る ほど 精 一 杯 努力 し て きた と 自負 し て いま す 。 今 で は 、 これ まで し て きた どん な こ と より も 、 オリ ン ピ ッ ク 競 技 大 会 が 自分 に と っ て 重要 な こと だ と 思っ て いま す 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 34-title\" style=\"top:140px;left:42px\" src=\"/tokyo2020/static/_content/34-title-1.png\">\n        <img class=\"halfScale 34-title\" style=\"top:324px;left:46px\" src=\"/tokyo2020/static/_content/34-sub-1.png\">\n        <img class=\"halfScalCe 34-img\" style=\"top:203px;left:163px\" src=\"/tokyo2020/static/_content/34-img-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.staggerFromTo(cOf(\"34-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n          .fromTo(cOf(\"34-img\"), 0.6, {scale:0}, {scale:0.5, ease: Power2.easeOut}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n        }\n        ",
    "searchText": " 34 東京 まで の 長い 道のり 「 リ ー ダ ー シ ッ プ に 対す る 自分 の 認識 を 変え る 必要 が あり まし た 」 ロウ ィ ー・ ウ ェ ブ スタ ー オー スト ラリ ア 、 水球 1 2017 年 、 世 界 選手 権 に 出場 する ロウ ィ ・ ウ ェ ブ スタ ー 選 手 ( 左 ) 球 の オー スト ラリ ア 代 表 選 手 、 口 ウィ ー・ ウ ェ ブ 水 スタ ー が 、 初め て 水球 に 挑戦 し た の は 、 シド ニー 2000 オ リン ピッ ク 競 技 大 会 が 開催 され た 2000 年 の こと で し た 。 彼女 の 母国 の 代表 チー ム は 残す と ころ あと 1 秒 と いう と ころ る で アメ リカ 代表 チー ム を 下 し 、 金メダル を 獲得 。 その ] か 月 後 、 自 宅 の テー ブル に 着い た 彼女 は 両親 に 、 将来 オ リン ピッ ク 競 技 大 会 に 出場 する つも り だ と 宣言 し た の で し た 。 それ か ら 12 年 後 、 彼女 は ロン ドン 2012 オ リン ピッ ク 競 技 会 で 銅メダル を 獲得 し まし た 。 そし て 3 度目 と な る 競技 大 会 で キャ プ テ ン を 務め よう と し て いた 矢先 に 、 新型 コロ ナウ イル ス 感 染 症 が 工 延 し て し まっ た の で す 。 ウェ ブス ター は 、 その 後 の 7 か 月 間 、 チー ム か ら 離 れ 、 世界 で も ひと きわ 厳格 な ロッ ク ダウ ン が 施行 され て いた 都市 、 メル ボル ン で 過ごし まし た 。 規 制 が 緩和 され る と 、 チー ム の 面々 は 家族 か ら 離 れ て 、 バイ ロン ベイ 近く の 小さ な 町 で 一 緒 に トレ ー ニ ング し 、 生活 する こと を 決心 し まし た 。 海外 で の 競技 に 参加 し な いと いう 決断 を 下 し た 結果 、 彼ら の トレ ー ニ ング パー トナ ー は 20 歳 以下 の 男子 強化 チー ム し か いま せん で し た 。 東京 2020 の 大 舞台 に 立つ メン バー が 決定 し た 時 点 か ら 約 17 か 月 間 、 ウェ ブス ター が 率い る オー スト ラリ ア 代 表 チ ー ム は 、 海 外 遠 征 な し で 過ごし て きま し た 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " CHASE YOUR DREAM BRIDGESTONE Solutions for your journey"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 自分 を 表現 する 上 で 水球 は ベス ト の 方 法 で す 。 プー ル に いる 時 が 一 番 自 由 を 感じ ます 。 と に か く ト レー ニン グ が 好き で 仕方 が あり ませ ん 。 その 攻撃 的 な 側面 が た ま ら な い の 。 で す 。100% な り た い 自分 に な れる 、 AANCEREARCS. そん な ブー ル か ら 離 れ て いた こと 。 は 、 強 さ を 維持 する 点 に お いて 大 き な 試練 で し た 。 私 た ち が チ ー ム ス ボー ツ を プレ ー す る 理由 は 、 仲間 意 識 や トレ ー ニ ング セッ ショ ン で の 対 戦 が この 上 な く 好 きだ か ら で す 。 と こる が 、 新 型 コ ロナ の せい で 強い 孤  独 を 感じ る よう に な り ま し た 。 精神 的 に は と て も きつ か っ た で す が 、 強 い オ リン ピッ ク 精 神 に 支え られ 、 オ リン ピッ ク 競 技 大 会 で は 母国 を 代 表す る 機会 が ある こと を 励み に 過 ご し て いま し た 。 毎日 目覚 め る 度 に 目標 を 立て 、 目的 意識 を 持っ て その 日 を 過ごす よう に 心がけ て きま し た 。 リー ダー シッ プ に 対す る 自分 の 認識 を 根本 的 に 変え る 必要 が あり まし た 。 早い 段階 で 、 何 より も すべ て の メン バー の 健康 状態 を 確認 し 、 そ の 後 は チー ム メ イト の メン タル ヘル 区 2 ニニ に コミ > 友 まけ り ま し た 。 私 た ち は オ ン ラ イン で グ ルー プ ト レ ー ニ ング セッ ショ ン を 行 い 、 団結 心 を 養う よう に 努め まし た 。 当時 あっ た 時 間 を 自己 の 成長 や 、 競 1 国際 競技 試合 に 参加 する こと な く 、 17 か 月 近く を 過ごし た ウェ ブス ター 選手 2 東京 へ の 渡航 を 控え 、 搭 乗 券 を 手 に し た オー スト ラリ ア 女 子 水球 チー ム 気温 が 5 度 で 水温 が 9 度 の 日 に 水 泳 を し た こと も あり まし た 。 そし て 今 、 これ まで で 最高 の 健康 と 体力 を 備 えて いま す 。 私 た ち は 競 技 に 参加 し て いな か っ た た め 、 遠征 に 出かけ て 体力 の 限り を 尽く し 、 消耗 し て 帰っ て くる 必要 も あり ませ ん で し た 。 ま た 、 海外 試合 に 行か な か っ た こと か ら 、 時 差 ボ ケ に 悩む と と も あり ませ ん で し た 。 自分 の 体 に 集中 し て 本 格 的 な まとまっ た トレ ー ニ ング を 行い 、 戦略 を 練り 、 競合 相手 を 研究 し 、 彼 ら を 別 の 視点 か ら 見 る こと は 自分 に と っ て 有意 義 な 経験 で し た 。 選手 で ある 私 た ち は 常 ne 機 に 、 体 が 再び 完全 に 充電 され た か ら で す 。 思う が まま に 挑戦 で きる 。 大 好き な こと を する こと が で きる 。 こん な 状態 を 何より も 嬉し く 思 いま す 。 これ が 、 世 界 の ベス ト プ レ ー ヤ ー と し て 名 を 連ね る た め に 、 私 が 選ん だ 時 間 の 過ごし 方 で し た 。 私 た ち が 立 ち 向かわ な いと いけ な い 最 大 の 難関 は 、17 か 月 近く 海 外 で 試合 を する こと な し に 過ごし 、 まし て や 、 ブラ ンク 後 の 最初 の 競技 が オリ ン ピ ッ ク 競 技 大 会 で ある こ と で す 。 これ は ぎわ め て 大 き な ジ ャ ンプ を する こと に な り ま す が 、 私 た ち は そ れ を 受け 入れ まし た 。 これ ま で に ほか の 国 が 国際 試合 に 出場 し た 様子 を 見 て きま し た 。 オー スト ラ Gt た を 6 生 = ゴメ 3 ピア Seon SY ALE aNd Eee yet VET, UA 2016 Cid 好 。 の Eb 残し た 仕事 を 成 し"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "The official payment technology partner of Tokyo 2020 and proud worldwide sponsor of the Olypic and Paralympic Movement Milica Mandic Serbia, Taekwondo Kanoa Igarashi Japan, Surfing Proud to be On Team ViSa Teresa Perales Noah Lyles USA, Athletics Spain, Para swimming"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 38-title\" style=\"top:156px;left:48px\" src=\"/tokyo2020/static/_content/38-title-1.png\">\n        <img class=\"halfScale 38-title\" style=\"top:222px;left:46px\" src=\"/tokyo2020/static/_content/38-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.staggerFromTo(cOf(\"38-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n        }\n        ",
    "searchText": "東京 まで の 長い 道のり (②66 め チー ム の 裏方 で 支え る チー ム  選手 は コー チ 、 エ ー ジ ェ ン ト 、 科 学者 、 家 族 、 パ ー ト ナー か ら 成 る 強力 な チー ム に 支え られ て いま す 。 パン デミ ッ ク が 発生 し た 時 、 多く の 人 々 の 生活 が 様々 な 形 で 打撃 を 受け まし た 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 39-quote\" style=\"top:740px;left:44px\" src=\"/tokyo2020/static/_content/39-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.staggerFromTo(cOf(\"39-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop();\n        }\n        ",
    "searchText": " Olympic Review Issue 116 39 や エネ ヴァ ・ グ レイ は アデ リン の 家 か ら 2、 3 アノ 時 間 誰 れ た アメ リカ の ジョ ー ジ ア 州 に 住ん で いま し た 。 ある 日 、 姉 か ら 大 会 前 の 数 か 月 の み 、 コロ ラド で レス リン グ の トレ ー ニ ング パー トナ ー を 務め て 欲し いと いう 依頼 が 入り まし た 。 と ころ が パ ン デ ミッ ク に より 、 数 か 月 は 15 か 月 に 及び まし た 。 「 常 に 彼女 を 笑わ せよ う 、 笑顔 に させ よう 、 ある い は あり の まま の 自分 で いて いい の だ と 彼女 に 言い 聞か せ よう と 努め まし た 」 と ジェ ネヴァ は 話し ます 。「 ア デリ ン ・ グ レイ で いる 必要 は な い 、 た だ 私 の 姉 と し て 、 BO 力 を 抜い て リラ ックス し て ほし か っ た の で す 。 彼女 の 調 子 が 良く な いと き は 、 一 緒 に 笑っ た り 、 卓 起 し た り し て 、 彼女 の 精神 状態 が 良く な る よう に 努め まし た 。 姉 の 調 子 が 良い と き は 、 一 緒 に も う 少 し 頑張 る よう に し まし た 。 私 た ち は と て も 競争 心 が 強 い の で 、 お 互い に 挑戦 合っ た こと は と て も 楽し い 経験 で し た 」 南ア フリ カ 人 の スポ ー ツ エー ジェ ント で ある ピー ト ・ バン ジル は 、 世界 ジュ ニア 選手 権 で ウェ イド ・ バ ン ニ ー 「 ウェ イド の 総合 的 な 体 カ レベ ル を 維持 する こと は で きた も の の 、 彼 は すべ て の トレ ー ニ ング を 1 人 で 行っ て きた た め 、 気持 ち を 強く 持ち 、 精神 面 を さら に 鍛え る こと が 重要 で す 」 ピー ト ・ バ ンジ ル 氏 キル ク を 初め て 見 た 後 の 2011 年 以来 、 彼 の マネ ー ジャ ー を 務め て いま す 。 一 目 で 彼 が 何 か 特 別 な 素質 を 備え て いる こと が 見 て 取れ た と いい ます 。「 生 まれ な が ら の 才能 が ある こと は 明白 で し た 」 と 、 バン ジル は 当 時 を 振り 返り ます 。「 ウ ェ イ ド の 才能 を 育成 する 環境 を 整え 、 開花 させ る こと に 専念 し まし た 。 今 は 2017 年 の 怪我 に よる スラ ンプ を 乗り 越え て 東京 2020 大 会 を 迎え る べく 励ん で いま す が 、 これ を 達成 で きれ ば 彼 の キャ リア の 新しい 1 ペー ジ が 始ま る こと で し ょ う 。 (ロッ クダ ウン 期間 中 ) ウェ イド の 総合 的 な 体力 レ ベル を 維持 する こと は で きた も の の 、 彼 は すべ て の ト レー ニン グ を 1 人 で 行っ て きた た め 、 気 持ち を 強く 持ち 、 精神 面 を さら に 鍛え る こと が 重要 で す 」 ディ ナ ・ プ ー リ ョ ネス は 難民 申請 時 に イラ ン 系 オラ ン ダ 人 の テコ ンド ー の グラ ンド マス ター、 マン ニ ・ ザ レイ に 連絡 し まし た 。「 道 場 で の トレ ー ニ ング は も は や 不可 能 と な り ま し た が 、 幸 軍 な こと に ディ ナ は 自宅 に テコ ン ドー マッ ト と 人 型 ダ ミー を 持っ て いた た め 、 ト レー ニン グ を 続け る こと が で きま し た 」 と 、 ザ レイ は 言い ます 。 「 彼 女 の 自宅 で トレ ー ニ ング を 行っ た トレ ー ナ ー の ラ ミン ・ パ ディ ダー ル と 私 の 2 人 が ディ ナ を サポ ー ト し ま し た 。 そこ で 、 ス パー リン グ パ ー ト ナー が 必要 と な り ま し た 。 私 た ち は レ ベル の 高い スパ ー リ ング パー トナ ー を 探す と 同時 に 、 自宅 ジム に いた 彼女 に 外 の 空気 を 吸 わせ る た め 、 ク ロア チア の トレ ー ニ ング 場 に 行き まし た 。 すべ て が 不 確 定 だ っ た 時 期 に 集中 力 を 保つ こと が 一 番 大 変 で し た 。 彼女 が 懸命 に トレ ー ニ ング する 様 子 を 見 て きま し た が 、2021 年 3 月 に 開催 され た ソフ ィ ア ・ オ ー プ ン で 金メダル を 獲得 し た 時 は これ まで の 努 力 が 報 わ れ ま し た 。 この 大 会 は 彼女 に と っ て 1 年 ぶり の 大 会 で 、 世界 ラン ク が 決定 する トー ナメ ント に お い て 目覚 まし い パ フォ ー マ ン ス を 披露 し て くれ まし た 。 ディ ナ に と っ て 東京 は 夢 の 実現 を 意味 し ます 。 彼女 は 、 これ まで 私 が 担当 し た 選手 の 中 で 最大 の 努力 家 で す 。 彼女 の 夢 の 実 現に 一 役 買 えた こと を 心から 嬉し く 思 っ て いま す 」 日 本 男子 ハン ド ボ ー ル チー ム の アシ スタ ント コー チ 、 SAB (LESS) 学 は 11 月 に チー ム の トレ ー ニ ング キャ ンプ を 再開 し まし た が 、 新型 コロ ナウ イル ス 感 染 症 は ハン ド ボ ー ル 界 に も 深刻 な 打撃 を 与え まし た 。 「 私 た ち は 素晴らし い 競 合 相手 と の 練習 試合 を いく つも 中 止 せ ね ば な ら ず 、 外部 か ら 選 手 を 迎え る 構想 を 断念 し な く て は な り ま せん で し た 」 と 、 舎利 那 は 振り 返 り ま す 。「 あ ら ゆ る 計画 が こと ご と く 台 無し に な り ま し た 。 日 本 に ある ナシ ョ ナル トレ ー ニ ング セン ター で は で きる 限り 安全 な 環境 で 練習 を する よう に 心がけ ま し た 。 キャ ンプ は 厳格 な 規制 下 で 行わ れ 、 すべ て が 順 調 に 進ん だ こと を 喜ば し く 思 っ て いま す 。 果たし て パン デミ ッ ク が 選手 た ちの 身体 面 に 影響 を 及ぼ し た か 否 か を 知り た か っ た の で 、 体力 検 査 を し た と こる 、 結果 は 上 々 で し た 。 この 状況 に も か か わら すず 、 選手 全員 の コン ディ ショ ン は 良好 で し た 。 競技 大 会 の 延期 と コロ ナ 褐 に お ける 競技 に 不 確 定 な と ころ が あり まし た の で 、 選手 た ちの 精神 面 へ の 影 響 を 心配 し て いま し た 。 その た め 、 スポ ー ツ 精神 科 医 に よる 指導 の 下 、 精神 面 で の 鍛錬 を 継続 し て いま す 。 いつ も 通り に 良い 結果 を 出す こと が で きま し た の で 、 と の トレ ー ニ ング に は 満足 し て いま す 」 1 パン デミ ッ ク 中 、 デ ィ ナ ・ プ リョ ー ネ ス 選手 を は じ め 多く の 選手 が 、 周 囲 の サポ ー ト に 支え られ まし た 2 2020 年 、 あ ら ゆ る 予定 の 変更 を 強い られ た 日 本 男子 ハン ド ボ ー ル チー ム の コー チ た ち 3 ロッ クダ ウン 中 、 ジ ェ ネ ヴァ ・ グ レイ ( 左 ) は 姉 の アデ リン の トレ ー ニ ング パー トナ ー を 務め まし た 40 特集 記事 : 東京 2020 プレ ビュ ー (②69 め"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title\" style=\"top:215px;left:45px\" src=\"/tokyo2020/static/_content/40-title-1.png\">\n        <img class=\"halfScale 40-title\" style=\"top:501px;left:51px\" src=\"/tokyo2020/static/_content/40-sub-1.png\">\n        <img class=\"halfScale 40-title\" style=\"top:580px;left:51px\" src=\"/tokyo2020/static/_content/40-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n        }\n        ",
    "searchText": " A GAME LIKE NO OTHER   史上 類 の な い オ リン ピッ ク 競 技 大 会  2021 年 7 月 23 日 か ら 8 月 8 日 まで 開催 され る 東京 2020 オ リン ピッ ク 競 技 大 会 を 直前 に 控え て 、 未 曽 有 の 困難 に 直面 し な が ら も 世界 中 の 選手 た ち に 安全 安心 な 大 会 の 開催 を 提供 する た め に 、  主催 者 が どの よう に 取り 組ん で いる の か を  日 本 人 スポ ー ツ ライ ター 狩野 心太 郎 が 掘り 下げ ます 。  ] 今回 新た に 加わ っ た 競技 、 サ ー フ ィ ン は 、 東 京 か ら 東 へ he oe Seg a al LOE av"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      <svg onclick=\"Publish.openGallery(['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.jpg', '6.jpg', '7.jpg', '8.jpg', '9.jpg', '10.jpg'])\" class=\"abs pointer pulse animatedpulse\" style=\"left:481px;width:50px; top:783px; height:50px;\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\">\n          <g>\n            <path fill=\"#fff\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"/>\n            <path fill=\"#fff\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n              M123.685,63.134h-20.209v-5.966h20.209V63.134z\"/>\n          </g>\n          <g>\n            <path fill=\"#fff\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n              L154.856,78.867z\"/>\n          </g>\n        </svg>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 42-quote\" style=\"top:756px;left:262px\" src=\"/tokyo2020/static/_content/42-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.staggerFromTo(cOf(\"42-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n        }\n        ",
    "searchText": " 上 初め て と な る 東京 2020 オ リン ピッ ク 競 au 技 大 会 の 開催 延期 が 発表 され た 2020 年 3 月 24 日 。 あ の 春の 日 か ら 1 年 を 件 か に 超 える 月 日 が 過ぎ まし た 。 当時 、 世界 中 に 新型 コロ ナウ イル ス 感 染 症 が 感染 拡大 し 、 暗い 影 を 落と し て は いま し た が 、 それ は 誰 も 予想 で き な い くら い 広 人 範 に わた っ て 、 多大 な 影響 を 及ぼ ば し 続け る 結果 と な っ た の で す 。 と の よう な 状況 下 で オリ ン ピ ッ ク 競 技 大 会 を 計画 する こと は 、 困難 を 極め る 、 と 言っ て も まだ 控え め に 過ぎ る か も し れ ま せん 。7 回 の オリ ン ピ ッ ク 競 技 大 会 出場 実績 を 持ち 、 東 京 オ リン ピッ ク ・ パ ラリ ン ピ ッ ク 競 技 大 会 組織 委員 会 (東京 2020) 会 長 を 務め る 橋本 聖子 氏 の 言葉 以上 に 、 この 状況 を 端的 に 表現 する も の は な いで し ょ う 。 「 東 京 2020 大 会 は 、 これ まで と は 、 まっ た く 異 な る 大 会 と な り ま す 」 と 、 橋 本 会 長 は 本 誌 「 オ リン ピッ クレ ビュ ー」 に 語り まし た 。「 そ れ で も 、 アス リー ト が すべ て を 懸け 、 卓越 し た パフ ォ ー マ ンス を も っ て 人 人 々 の 心 を 動か す 、 その 本 質 は 変わ り ま せん 」 日 本 政府 、 東京 都庁 、 東京 2020 は 、 IOC お よび 国際 パラ リン ピッ ク 委 員 会 と 運 携 し て 、 安全 に 始ま り 、 安全 に 終わ る オリ ン ピ ッ ク 競 技 大 会 を 今年 の 夏 に 開 催す る 手段 と 方 法 を 考案 すべ く 、 全 精 力 を 傾け て いま す 。 この よう な 厳し い 状況 だ か ら こ そ 、 オリ ン ピ ッ ク 競 技 大 会 を 開催 する 価値 が あり 、 その 価値 が これ まで 以上 に 重要 に な っ て いる と 、 橋 本 会 長 は 話し ます 。 「 東 京 2020 大 会 を 開催 し 、 世界 に 対し て 、 スポ ー ツ を 通じ て 連帯 と 共生 の メッ セー ジ を 出し て いく 意義 が ある と 発信 する 必要 が ある の で す 」 橋本 聖子 会 長 「 コ ロナ で 世の中 が 分 断 さ れ て いる か ら こ そ 、 安 全 で 安心 な 環境 を 確保 し た 上 で 、 世界 規模 の クラ イシ ス 後 、 世界 で 初め て の グロ ー バ ルイ ベン ト と な る 東京 2020 大 会 を 開催 し 、 世界 に 対し て 、 スポ ー ツ を 通じ て 連帯 と 共生 の メッ セー ジ を 出し て いく 意義 が ある と 考え て いま す 」 と 、 アル ベー ルビ ル 1992 の 銅 メ ダ リ スト で あ る 橋本 会 長 は 言葉 を つなぎ まし た 。 「 困 難 な 状況 は 続き ます が 、 アス リー ト を 含む すべ て の 参加 者 と 大 会 を ホス ト す る 日 本 の 国民 双方 に と っ て 、 安全 最 優先 で 大 会 を 開催 する た め 、 コロ ナ 対策 に 万 全 を 期し て 参り ます 。 私 た ち は 大 会 主催 者 と し て 、 選手 と 関係 者 だ け で な く 、 日 本 の 人 々 た め に も 努力 し て 参り ます 」 トー マス ・ バ ッ ハ 1OC 会 長 も 橋本 会 長 と 同じ 思い を 抱い て いま す 。 バッ ハ 会 長 は 東京 が 開催 する だ け の 能 力 を 備え て いる こと に 全幅 の 信頼 を 寄せ 、 開 催 に 変わ ら ぬ 意気 込み を 見 せま し た 。2021 年 3 月 に 開催 され"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" style=\"top:93px;left:37px;height:289px;width:434px;\">\n      <a href=\"https://olympics.com/ioc/tokyo-2020-playbooks\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": " Issue 116 Olympic Review た 第 137 次 IOC 総 会 で 、 会 長 は 「 東 京 は 今 ま で 通り 、 どこ より も 万 全 を 期し た オリ ン ピ ッ ク 競 技 大 会 開催 都 市 で す 」 と 述べ まし た 。 「 だ か ら こ そ 、 東京 2020 オ リン ピッ ク 競 技 大 会 の 成 功 に 向け て 揺るが な い コ ミッ トメ ント を 示し て いる 日 本 政府 、 東 京都 庁 、 組織 委員 会 、 選手 、 国際 競技 連盟 、 国内 オリ ン ピ ッ ク 委 員 会 、 すべ て の オリ ン ピ ッ ク パ ー ト ナー プロ グラ ム の パー トナ ー の 皆様 、 放送 権 を 取得 し た 放送 局 に 対し て 感謝 の 気持 ち を 表し ます 。 関係 者 の 皆様 の 大 き な 決意 と ご 支援 の お か げ で 、 間 わ れ て いる の は 競技 大 会 を 開催 『 す る か 否 か 』 で は な く 、『 ど の よう に 』 行 うか と いう こと な の で プレ イブ ッ ク の 導入 プレ イブ ッ ク は 日 本 政府 、 東京 都庁 、 東 京 2020、 IOC お よび IPC が 共同 で 執筆 し た 、 関係 者 向け に 新 型 コ ロナ ウイ ルス 感染 症 対策 を 記載 し た 指針 と な る ハン ドブ ッ ク で す 。 その 内 容 は 科学 に 裏付け られ 、 世 界 保健 機構 と 世界 中 の 感染 病 の 専門 家 の 助 言 を 受け つつ 作成 され まし た 。 六 つ の 章 か ら 構 成 さ れる プレ イブ ッ ク の 初版 が 2 月 に 発行 され 、 その後 4 月 に 更新 、 そ し て 6 月 に 第 3 版 が 発行 され まし た 。 この プレ イブ ッ ク で は 、 感染 や 伝播 の リス ク を 最小 限 に 抑え る こと が で きる と され て いる 定期 的 な 検査 や ソー シャ ルディ スタ ンス の 取り 方 な ど 、 衛 生 面 や 移動 面 で の 対策 が 記載 され て いま す 。 対策 を 成功 させ る 上 で 、 橋本 会 長 と バッ ハ 会 長 は 、 関係 者 か ら の 協力 、 と り わ け プ レイ ブッ ク 厳 守 の 重 要 性 を 強調 し て いま す 。 橋本 会 長 の 言葉 を 借り れ ば 、 会 参加 者 は 「 ワ ンチ ー ム 」 の 一 員 だ と いう こと で す 。 「 大 会 の 成功 に 向け て は 、 参加 いた だ く 皆 さま の ご 協力 が 不可 欠 で す 」 と 、 東京 2020 の 会 長 で ある 棋 本 会 長 は 言い ます 。 「 日 本 滞在 中 に 遵守 すべ き ル ー ル (プレ イブ ッ ク ) を し っ か り 認 識 い た だ き 、 安 全 で 安心 な 大 会 の 開催 実現 の た め 、 一 人 ひと り が 責 献 する 気 持ち で 来 日 いた だ く こ と が 重要 だ と 考え て お り ま す 」 また 、 1OC 会 長 は こう 付け 加え まし た 。 「 大 会 開催 期間 中 の 運営 に 関す る さら な る 詳細 を あ ら か じ め 関 係 者 に 提供 する と 同時 に 、 私 た ち は あ り と あら ゆる 対策 を 組み 合わ せる こと に よっ て 、 で きる 限 り 安全 な 環境 を 整え 、 刻 一 刻 と 変化 する 世界 情勢 に 柔軟 に 対応 する 所 存 で す 。 大 会 開催 前 と その 最 中 に 選手 と 関係 者 に 対す る 検査 回 数 を 増やす こと は 、 そ の 重要 な 一 例 で す 。 また 、 世界 中 で 行わ れ て いる 予防 接種 の 数 が 増え て いる こ と も 心強い 限り で す 。 た だ し 、 こ れ ら の ツー ル は 、 す べ て の 人 が 一 丸 と な っ て 、 ガ イド ライ ン 順 守 に 取り 組ん で 初め て 成功 する の で す 。 だ か ら こ そ 、 この ルー ル に 違反 し た 人 は 、 東京 で 厳しく 対処 され る こと に な り ま す 。 これ は 、 今年 の 夏 に 自分 の 国 、 そ し て 街 に 私 た ち を 温か く 歓 迎 し て く だ さる 、 東京 と 日 本 の 皆様 に 対す る 私 た ちの コミ ッ ト メン ト で すず 世界 的 な パン デミ ッ ク の 渦中 に オリ ン ピ ッ ク 大 会 を 開催 する と いう 困難 な 偉業 を 成功 させ る こと 自体 が レガ シー と な る も の で す が 、 末永 く 語り 継が れる で ある ろう 東京 2020 の レガ シー は 、 誰 より も 繕 本 会 長 自 身 が 体現 し て いる と いえ る で し ょ う 。 元 ス ピー ドス ケー ト と 自転 車 競技 の トラ ッ ク レ ー ス 選手 で も ある 橋 本 会 長 は 、2021 年 2 月 に 日 本 東京 オ リン ピッ ク 競 技 大 会 ・ 東 京 パ ラリ ン ピ ッ ク 競 技 大 会 担 1 陸上 テス トイ ベン ト に て 。 男子 3000m 障 害 競技 で 水 塚 を 飛び 越え る 選手 。 2 プレ イブ ッ ク は 、 東 京 2020 に お ける 新型 コロ ナウ イル ス 感染 症 対策 を 記載 し た ハン ドブ ッ ク で 、 関係 者 向け の 指針 と な り ま す 。 3 テス トイ ベン ト で 競技 を 終え 、 マ スク を 受け 取る 日 本 人 の 新 体操 選手 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 特集 記事 : 東京 2020 プレ ビュ ー 当 大 臣 か ら 昇 格 し 、 東 京 2020 会 長 に 就任 し まし た 。 東京 1964 オ リン ピッ ク 競 技 大 会 の 開会 式 に 深く 感動 し た 父親 が 「 オ リン ピッ ク 聖 火 」 に ちな ん だ 名 前 を つけ た と いう 橋本 会 長 で す が 、 指導 者 すべ て が 女 性 で ある 東京 2020 で リー ダー シッ プ を 発揮 し て お り 、 こ れ は ジェ ンダ ー 平 等 が まだ 進ん で いな い 日 本 に お いて 非常 に 大 き な 意 味 を 持ち ます 。 橋本 会 長 の 脇 を 固め る の は 、 東京 オリ ン ピ ッ ク 競 技 大 会 ・ 東 京 パ ラリ ン ピ ッ ク 競 技 大 会 担当 大 臣 職 を 引き 継い だ 丸川 珠代 氏 、 橋 本 会 長 と 同じ く オ リン ピッ ク メ ダ リス ト (ソウ ル 1988 アー ティ ステ ィ ッ クス イミ ング ) で 東京 2020 の ジェ ンダ ー 平 等 推進 チー ム ヘ ッ ド の 小谷 実 可 子 ス ボー ツ デ ィ レ クタ ー、 そし て 東京 都 知事 の 小池 百合 子 氏 で す 。 オリ ン ピ ア ン と 政治 家 と いう 経歴 を 併せ 持つ 構 本 会 長 に つい て 、 パッ ハ 会 長 は 東京 2020 に 向け た 最 終 段 階 の 準備 を けん 引 す る 「 完 璧 な 人 選 」 と 表現 し ま し た 。 東京 1964 の レガ シー は 、 国立 代々 木 競技 場 や 日 本 武道 館 と いっ た 象徴 的 な 施設 、 全国 を 結ぶ 広域 の 公 共 交通 網 、1960 年 代 か ら 70 年 代 に か け て の 全国 的 な 高度 経済 成長 な ど 、 具 体 的 か つ 有 形 の も の で し た 。 1964 年 の 大 会 に 比べ る と 、 東京 2020 の レガ シー は 物理 的 に 目 に 見 え に く いか も し れ ま せん 。 し か し 、 オ リン ピッ ク 大 会 が 揚げ る 「 多 様 性 と イン クル ー ジ ョ ン 」 の 一 環 で ある ジェ ンダ ー 平 等 の 精神 な ど は 、 波及 効 果 を 伴っ て 日 本 に 永久 に 残る 可能 性 を 秘め て いま す 。 3 月 25 日 に 福島 県 の 」 ヴ ィ レ ッ ジ で スタ ー ト し た 今 競 技 大 会 聖火 リレー で は 、 復興 と いう オリ ン ピ ッ ク 大 会 の も うー つの テー マ が 掲げ られ まし た 。 日 本 が 2011 年 東日本 大 震 災 に よる 被害 の 後 処理 に 追わ れ る 中 、 長期 に わた っ て も っ と も 深刻 な 被害 に 苦し ん だ の が と この 地域 で す 。 オ リン ピッ ク 聖 火 リ レー は 47 の す べ て の 都 道 府 県 を 通過 し 、7 月 23 日 の オリ ン ピ ッ ク スタ ジア ム で の 開会 式 で 聖火 台 に 着火 され ます 。 オリ ン ピ ッ ク 大 会 の 中 心 的 存在 で ある 選手 、 そ し て 国内 競技 盟 お よび 国際 競技 連 早 に と っ て 、 新型 コ ロナ ウイ ルス 感染 症 が 世界 中 の 競技 試合 を 文字 通り 昌 紙 に 戻し て し まっ た 昨年 1 年 間 の 苦労 は 、「 困 難 」 や 「 難 局 」 と いう 言葉 で は 到底 言い 表せ ませ ん 。 初め て オリ ン ピ ッ ク 競 技 大 会 の 舞台 に 立つ 選手 で あれ 、 シ モー ネ ・ バ イル ズ 選 手 、 ケイティ ・ レ デッキ ー 選 手 、 テ ディ ・ リ ネー ル 選 手 の よ うな スタ ー 選 手 で あれ 、 今 大 会 に 向け て の 準備 期間 は 、 どの 選手 に と っ て も 経験 し た こと の な いも の で し た 。 東京 2020 を 取り 巻く 、 パ ン デ ミッ ク に よる 不 確 定 性 は 、 と り わ け 日 本 人 選手 に 苦難 を も た らし まし た 。 と いう の も 、 彼ら は 母国 で 開催 され る オリ ン ピ ッ ク 競 技 大 会 に 向け て 人 々 の 記憶 に 残る 華々 し い 結果 を 残 そ うと 、 長 年 に わた っ て 一 途 な 努力 を 重ね て きた か ら で す 。 し か し 、 桃田 費 斗 選手 や 長谷 川 唯 選手 を は じ め と する 各 選 手 は 、 東京 2020 が 人 々 を 勇気 づけ る も の に な る と いう 確信 を 胸 に 抱き な が ら 努 力 を 買 き まし た 。 空手 、 ス ケー ト ボ ー ド 、 ス ポー ツク ライ ミン グ 、 サー フィ ン 、 野球 プ / ソ フト ボー ル な ど 、 今回 初め て 採用 され た 競技 や 復活 を 果たし た 競技 も 、 同 じ よ うに 栄光 に 浴 す る で し ょ う 。 金 メ ダ リ スト の 呼び 声 の 高い 、 男子 バド ミン トン 世 界 1 位 の 桃田 選手 は 、「 東 京 2020 大 会 の コー ト 上 で は 感謝 の 気持 ち を 表現 し た いで す 」 と 述べ まし た 。 彼 は 2011 年 に 発生 し た 大 地震 と 津波 に よっ て メル ト ダ ウン が 発生 し た 原子 力 発 電 所 か ら わ ず か 数 km の 距離 に ある 高校 に 通っ て いま し た 。 「 震 災 か らち ょ うど 10 年 で すし 、 自分 が 活躍 する こ と で 、 福島 な ど 被 災 地 に 元気 、 勇 気 を 与え られ る 大 会 に で きれ ば いい な と 思い ます 」 また 、 これ まで の 15 か 月 間 に つ いて 、 桃田 選手 は 「 延 期 に な っ た こと で 辛かっ た と いう より は 、 前 向き に 捉え る こと が 出来 て いま し た 。 1 年 の 延期 は 、 改め て ] 2021 年 5 月 、 有 明 ア リー ナ で 開催 され た パレ ー ボ ー ル の テス トイ ベン ト で の ワン ショ ッ ト 。 2 青海 アー バン スポ ー ツ パー ク の 壁 を 登る 地元 の クラ イマ ー。 3 日 本 武道 の 心 の ふる さと 、 日 本 武道 館 。 こ こ で 柔道 と 空手 競技 が 開催 され ます 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 特集 記事 : 東京 2020 プレ ビュ ー 周囲 の 方 々 の サポ ー ト や 励ま し あっ て の 自分 で ある と いう こと を 、 再 確認 する 時 間 に な り ま し た 」 と 付け 加 えま し た 。 イタ リア の AC ミ ラン に 所 属す る サッ カー の 長谷 川 選手 は 、「 な で し こ ジ ャ パン 」 の メダ ル 獲 得 を 視野 に 入れ て 、 次 の よう に 語り まし た 。 「 い る ん な 人 に 見 に 来 て も ら え る と 思う の で 、 いい 結 果 、 いい 内 容 、 次 も 見 た いと 思っ て も ら え る プレ ー を し た いと 思っ て いま す 。 先日 新しく な っ た 国立 競技 場 で 、 初 め て 試合 を 行っ た の で す が 、 必 ず 決 勝 に 進出 を し て 、 も う 一 度 あ の 舞台 で プレ ー を し た いと 強く 思っ て いま す 。 コロ ナ 柚 で 、 世界 中 に 元気 が な いと 思う の で 、 ス ポー ツ を 通じ て 一 人 で も 多く の 方 に 元気 、 笑顔 、 勇気 を 与え る こと の で きる 大 会 に な れ ば と 思っ て いま すし 、 この 大 会 を 盛り 上 げ る 一 人 と し て 、 応援 し て くだ さる 皆 さん に 結果 で 恩返し を し て いき た いと 思っ て いま す 」 バッ ハ 会 長 は 、 オ リン ピッ ク 競 技 大 会 が エキ サ イ テ ィ ング な も の に な る と 確信 し 、 そ の 根拠 と し て 2020 年 9 月 以降 、 厳 格 を 極め た 感染 対策 の 下 、 4 万 人 以上 の スポ ー ツ 選手 が 参加 し た 270 以 上 の 大 規 模 な 競技 試合 を 国際 競技 運 盟 (IFs) が 開催 し て きた 実績 を 指摘 し ます 。 さら に 、 これ まで 合計 20 万 件 以 上 の 新型 コロ ナウ イル ス の 検査 が 実施 され て いる こ と も 注目 に 値する で し ょ う 。 「 こ れ ら の 試合 の うち 、 一 つと し て クラ スタ ー が 発生 し た 例 は あり ませ ん で し た 。 つま り 、 参加 者 全員 の 健 1 有名 な 東京 の レイ ン ボ ー ブ リ ッ ジ 前 に 設置 され た オリ ン ピ ッ クリ ング 。 2 母国 で の 金メダル 獲得 に 向け て 女子 サッ カー チー ム を けん 引 し た いと 意気 込む 長谷 川 唯 選手 。 康 を 守り つつ 、 海外 か ら 大 勢 の 選手 が 集結 し た 大 規 模 な 国際 競技 試合 を 開催 で きる と いう こと が 、 明確 に 証明 され た の で す 」 と 述べ まし た 。 「 さ ら に この 事実 が より 一 層 大 き な 意 味 を 持つ の は 、 この 結果 が 一 つと し て ワク チン 接種 の 恩恵 に よる も の で は な いと いう こと で す 。 対照 的 に 現在 は 、 複数 の ワ クチ ン が 広く 使用 され て お り 、 私 た ち は き わ め て 上 恵 ま れ た 状況 に いる と 言え ます 。 出場 選手 の 多く は 、 東京 2020 に 向け て すでに 接種 を 済ま せ た か 、 間もなく 接 種 を 受け る 予定 で す 。 開会 式 が 近づく に つれ 、 この 状 況 は さら に 改善 され て いく で し ょ う 」 5 月 12 日 時 点 で 、700 人 以上 の アス リー ト と 6 千 人 以上 の 関係 者 が 日 本 で 開催 され た テス ト 大 会 に 参 加 し まし た 。 その 中 に は 2 か 国 か ら 60 人 の 選手 ( う ち 海外 か ら の 選手 は 28 人 )、19 人 の 海外 チー ム 関 係 者 、1100 人 の 運営 スタ ッ フ が 参加 し た バレ ー ボ ー ル 日 本 代表 国際 親善 試合 東京 チャ レン ジ 2021 < が 含ま れ ま す 。 東 京 2020 オ リン ピッ ク 競 技 大 会 の 最終 選考 会 と な る FINA 飛 込 ワ ー ル ドカ ッ プ 2021 に は 46 の 国 と 地域 か ら 225 人 の 選手 (うち 海外 か ら の 選手 は 212 人 )、 159 人 の 海外 チー ム 関 係 者 、 410 人 の 運営 スタ ッ フ が 参加 し まし た 。 北 海道 ・ 札 幌 マ ラ ソン フェ ステ ィ バ ル 2021 に は 5 か 国 か ら 94 人 の 選 手 (うち 海外 か ら の 選手 は 6 人 ) と 2700 人 の 運営 ス タッ フ が 参加 し まし た 。READY STEADY TOKYO ー 陸 上 競技 に は 、 七 つ の 国 と 地域 か ら 350 人 の 選手 (うち 海外 か ら の 選手 は 9 人 )、 3 人 の チー ム 関 係 者 、 1620 人 の 運営 スタ ッ フ が 参加 し まし た 。 そし て 開会 式 を 1 か 月 後に 控え た 現在 、 東 京 2020 に 向け た 準備 は 最終 段階 に 突入 し まし た 。 し か し 、 18 本 会 長 は すでに その ずっ と 先 を 見 据え て いま す 。 「 こ の 未 堂 有 の 条件 下 で 開催 され る 東京 2020 大 会 の 経験 を いか に 将来 の オリ ン ピ ッ ク ・ パ ラリ ン ピ ッ クム ー ブ メ ント の 推進 に 活か し て いく か は 日 本 の 使命 だ と 考え て お り ま す 。 今日 に 至る まで の 日 本 の 取り 組 み で ある 『 東 京 モ デル 』 は 、 必 ず や オリ ン ピ ッ ク ・ パ ラ リン ピッ ク の 将来 の 開催 指針 と な っ て 末永 レガシー と な っ て いく こと と 確信 し て いま す 」 と 述べ て いま す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:726px;left:225px;height:20px;width:278px;\">\n        <a href=\"https://olympics.com/tokyo-2020/ja/fanzone/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top: 776px; left: 246px; height: 39px; width: 115px;\">\n        <a href=\"https://play.google.com/store/apps/details?id=org.olympic.app.mobile\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"    top: 776px; left: 383px; height: 39px; width: 103px;\">\n        <a href=\"https://apps.apple.com/us/app/olympics/id808794344\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": "PLAY TOGETHER FOR OLYMPIC PRIZES ON FANZONE AVAILABLE ON OLYMPICS.COM/TOKYO-2020 AND IN THE TOKYO 2020 MOBILE APP Prize promotion open to residents of certain countries only. Age restrictions apply. No purchase necessary. See detailed terms and conditions for how to enter and rules on eligibility."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 48-title\" style=\"top:147px;left:43px\" src=\"/tokyo2020/static/_content/48-title-1.png\">\n        <img class=\"halfScale 48-title\" style=\"top:300px;left:43px\" src=\"/tokyo2020/static/_content/48-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n        }\n        ",
    "searchText": " 東京 2020 プレ ビュ ー 東京 で 出会う と き TOKYO's time av Ney に 「 オ リン ピッ クレ ビュ ー」 が 、 東京 2020 オ リン ピッ ク 競 技 大 会 開催 中 に 会 場 で 実施 され る 339 の 競技 の 中 か ら 、 33 の 種目 を ビ ピックアップ し て ご 紹介 し ます 。 水泳 競技 東京 アク アテ ィ ク ス セ ンタ ー、 お 台場 海浜 公園 、 東京 辰 量 国 際 水 泳 場 7 月 24 日 一 8 月 8 日 決勝 数 : 49 オリ ン ピ ッ ク 史 上 初め て 、 男 女 が 4x100m 混合 メド レー リレー 種目 で 対戦 し ます 。 男子 800m 自 由 形 、 女 子 1500m 自 由 形 も また 、 東京 2020 で 初め て 加わ っ た 種目 で す 。 その 他 、 マ ラ ソ ンス イミ ング 、 ア ー テ ィ ス ティ ッ ク ング 飛 込 、 水 球 が 水泳 競技 に 含ま れ ま す 。 アー チェ リー 夢の島 公園 アー チェ リー 場 7 月 23 日 一 31 日 決勝 数 :5 アー チェ リー プロ グラ ム で は 、 男 女 別 個人 お よび 団体 種目 に 加え 、 新 た に 男女 混合 種目 が 行わ れ ます 。 個人 競技 に 出場 する 選手 が 矢 を 放つ 距離 は 70m で 、 予 選 で は 1 位 か ら 64 位 が 決定 され ます 。 予選 を 通過 し た 選手 は 得点 で 勝敗 が 決ま る 勝ち 抜き 戦 に 進み 、 最終 戦 で は メダ ル 争 い が 繰 り 広 げ ら れ ま す 。 陸上 競技 オリ ン ピ ッ クス タ ジ ア ム 、 札 幌 大 通 公園 7 月 30 日 一 8 月 8 日 決勝 数 : 48 東京 の オリ ン ピ ッ クス タ ジ ア ム で は トラ ッ ク 、 フィ ー ル ド 競 技 、 混 成 競 技 、 札 幌 大 通 公園 で は マラ ソン と 競歩 が 開催 され ます 。 今回 新しく プロ グラ ム に 加わ っ た 男女 混合 4x400m リ レー は 、 競 技 の 第 1 日 目 と 2 日 目 に 行わ れ 、 手 に 汗 握る 見 せ 場 を 展開 する こと で し ょ う 。 バド ミン トン 武蔵 野 の 森 総合 スポ ー ツ プラ ザ 7 月 24 日 8 月 2 日 決勝 数 :5 バル セロ ナ 1992 競技 大 会 で 正式 競技 と な っ た バド ミン トン で は 、 男 女 シ ング ルス 、 男 女 ダ ブル ス 、 混合 ダブ ルス の 試合 が 行わ れ ま す 。 各 試合 は 2 ゲー ム 先 取 の 3 ゲー ム マ ッ チ と な っ て お り 、 試合 に 勝つ に は 21 点 を 獲得 する 必要 が あり ます 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " Olympic Review Issue 116 49 バス ケッ ト ボ ー ル さい た ま ス ー パ ー ア リー ナ 、 青海 アー バン スポ ー ツ パー ク 7 月 24 日 ご 8 月 8 日 決勝 数 :4 世界 で 世界 で も 非常 に 高い 人 気 を 誇る 競技 で ある バス ケッ ト ボ ー ル は 、 攻 守 の 切り 替え が 早い こと が 特徴 で す 。 今回 の 競技 大 会 に は 、 男 女 12 チ ー ム に よる 従来 の トー ナメ ント に 加え 、 通 常 の 半分 の スペ ー ス に ー つ の ネッ ト を 設置 し た コー ト で 行わ れる 、 短 縮 版 の エキ サイ ティ ング な 3x3 バ スケ ッ ト ボ ー ル が 新た に 加わ り ま す 。 この 種目 は ユー ス オ リ ン ピ ッ ク 競技 大 会 で すでに 実施 され て いま す 。 ボク シン グ 国技 館 7 月 24 日 一 8 月 8 日 決勝 数 :13 今年 の ボク シン グ プ ロ グラ ム は 、 体 重 別 で 男子 8 階級 、 女 子 5 階級 で 競 わ れ ま す 。 リオ 2016 オリ ン ピ ッ ク 競 技 大 会 より 、 女子 に 2 階級 が 追加 され まし た 。 準決勝 出場 の 選手 は 、 最 低 で も 銅メダル を 獲得 する こと が 保証 され ます 。 カヌ ー カメ ヌー・ ス ラロ ー ム セン ター、 海 の 森 水 上 競技 場 7 月 25 日 ご 8 月 7 日 決勝 数 :16 カヌ ー の スラ ロー ム は 男女 別 の カヌ ー お よび カヤ ッ ク 種 目 に 分 か れ て 行わ れ 、 250m に 及ぶ 急流 の コー ス に 設定 され た 最大 25 の ゲー ト を 通過 し ます 。 プロ グラ ム で は 、 男 子 カ ナディ アン ペア に 代わ っ て 女子 カナ ディ アン シン グル が 加わ り ま し た 。 競技 大 会 の 2 週 目 に 行わ れる カヌ ー の スプ リン ト は 、 長 さ 200m か ら 1.000m ま で の 距離 の コー ス で 、 静 水域 に お いて スピ ー ド を 競い 合い ます 。 こち ら も カヌ ー と カヤ ッ ク の 両方 の 種目 が 行わ れ ま す 。 び 自転 車 競技 有明 アー バン スポ ー ツ パー ク 、 伊 豆 MTB コー ス 、 武蔵 野 の 森 公園 、 富 士 ス ピー ドウ ェ イ 、 伊豆 ベロ ドロ ー ム 7 月 24 日 ご 8 月 8 日 決勝 数 : 22 オリ ン ピ ッ ク の 自転 車 競技 プロ グラ ム は BMX、 マウ ン テ ン バイ ク 、 ロー ド 、 ト ラッ ク 種 目 か ら 構 成 され て いま す 。BMX レー シン グ は 、 6 人 の ライ ダー が ジャ ンプ や 急 な ター ン が 必要 と され る トラ ッ ク で 競う 競技 で す 。 BMX フ リー スタ イル は 競技 大 会 に と っ て は 新しい 種目 で 、 選 手 が 1 分 間 の 滑走 で 披露 する トリ ッ ク の 表現 力 や 独創 性 が 採点 され ます 。 富士 山 を 一 望 で きる オフ ロー ドコ ー ス で は 、 2.1km の 周回 お よび 最大 150m の 高低 差 で マウ ン テ ン バイ クレ ー ス が 開催 され ます 。 ロー ド 種 目 は 男子 お よび 女子 の ロー ドレ ー ス と タイ ム トラ イア ル で 構成 され 、 ト ラッ ク 種 目 に は 男子 お よび 女子 の ケイ リン 、 オ ム ニ ア ム 、 チ ー ム パシ ュー ト 、 スプ リン ト 、 チ ー ム スプ リン ト 、 そ し て 再び 加わ っ た マデ ィ ソ ン の 六 つ の 競技 が あり ます 。 馬術 馬 事 公 苑 、 海 の 森 ク ロス カン トリ ー コ ー ス 7 月 24 日 一 8 月 7 日 決勝 数 :6 馬術 に は 三 つ の 種目 が あり 、 そ れ ぞ れ 個 人 種目 と チー ム 種 目 が 用 意 さ れ て いま す 。 馬場 馬術 は 馬 と 騎手 が あら か じ め 決 め ら れ た 一 連 の 動き を 演じ る も の で す 。 身体 能力 、 芸 術 性 、 美 し さ が 0 で 10 点 で 採点 され ます 。 障害 馬術 で は 馬 と 騎手 が 、 高 さ 1.65m まで の 障害 物 を で きる 限り 短い 時 間 で クリ ア す る こと が 求め られ ます 。 総合 馬術 は 、 馬場 と 障害 に クロ スカ ント リー 走行 が 加わ っ た 複合 的 な 競技 で す 。 フェ ン シ ン グ 7 月 24 日 8 月 1 日 決勝 数 : 12 すべ て の 近代 オリ ン ピ ッ ク 大 会 で 実施 され る 数 少な い 競 技 の 一 つ で ある フェ ン シ ン グ は フル ー レ 、 エ ペ 、 サ ー ブ ル の 3 種目 か ら 構 成 さ れ て いま す 。 東京 2020 で は 、 い ずれ の 種目 も 男女 の 個人 と 団体 が あり ます 。 対戦 相手 の 剣 と ユニ フォ ー ム は 電気 審判 機 に 接続 され て お り 、 有 効 面 に 突き が 決ま る と 自動 的 に 採点 され ます 。 特集 記事 : 東京 2020 プレ ビュ ー"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " サッ カー 東京 スタ ジア ム 、 札 幌 ド ー ム 、 埼 玉 ス タ ジ ア ム 2002、 宮城 スタ ジア ム 、 横 浜 国際 総合 競技 場 、 茨城 カシ マス タ ジ ア ム 、 オ リン ピッ クス タ ジ ア ム 7 月 21 日 ご 8 月 7 日 決勝 数 :2 競技 会 場 は 7 か 所 に わた り 、 総 当たり グル ー プ リー グ か ら 開 始 し ます 。 男子 サッ カー は 16 チ ー ム 、 女 子 は 12 チ ー ム か ら 成 る トー ナメ ント を 実施 し ます 。 横浜 で は 男子 の 決勝 戦 、 東 京 で は 女子 の 決勝 戦 が 行わ れ ます 。 ゴル フ 霞ヶ関 カン ツリ ー 倶 楽 部 7 月 29 日 一 8 月 7 日 決勝 数 :2 ゴル フ は 1904 年 を 最後 に 競技 種目 か ら 外れ 、 リオ 2016 で 貞 的 な 復活 を 果たし まし た 。 試合 は 4 日 間 に わ た り 、 ス トロ ー ク プレ ー 方 式 に 従っ て 72 ホ ー ル で 行わ れ 、 打 数 が も っ と も 少な い ゴル ファ ー が 金メダル を 獲得 し ます 。 体操 有明 体操 競技 場 7 月 24 日 一 8 月 8 日 決勝 数 :18 体操 は 体操 競技 、 新 体操 、 ト ラン ポリ ン の 3 種目 か ら 構成 され て いま す 。 男子 と 女子 と も に 、 種目 別 跳馬 と 種目 別 め か が あり 、 さ ら に 男子 に は 種目 別 鉄棒 、 種 目 別 あん 馬 、 種 目 別 平行 棒 、 種目 別 つ り 輪 が 、 女 子 に は 種目 別段 違い 平行 棒 と 種目 別 平均 台 の 競技 が あり ます 。 新 体操 で は 選手 が 音楽 に 合わ せ て 芸術 性 を 競い ます 。 トラ ン ポ リン 競技 で は 選手 が 規定 と 自由 の 演技 を それ ぞ れ 1 回 ずつ 行い 、 出 来 栄 えと 難易 度 が 採点 され ます 。 ハン ド ボ ー ル 国立 代々 木 競 技 場 7 月 24 日 ご 8 月 8 日 決勝 数 :2 ハン ド ボ ー ル の 試合 は 40x20m の コー ト で 行わ れ 、 ー チ ー ム に つき 7 人 の 選手 で 競い 合い ます 。 選手 は 最高 3 秒間 ボー ル を 持つ こと と が で き 、 最大 で 3 歩 動く こと が 許さ れ て いま す 。 男女 それ ぞ れ 12 チーム が 競技 に 出場 し ます 。 ホッ ケー 大 井 ホ ッ ケー 競技 坦 7 月 24 日 8 月 6 日 決勝 数 :2 アム ステ ルダム 1928 以降 常に オリ ン ピ ッ ク 競技 で ある ホッ ケー は 、 男 子 お よび 女子 の 12 チ ー ム が それ ぞ れ 五 つの グル ー プ に 分 か れ て 試合 を 行い 、 上 位 4 チーム が 大 井 ホ ッ ケ ー 競 技 場 で の 勝ち 抜き 戦 に 進出 し ます 。 柔道 日 本 武道 館 7 月 24 日 一 31 日 決勝 数 :15 東京 1964 で オリ ン ピ ッ ク 競 技 と な っ て 以来 、 世界 中 で 大 き な 人 気 を 集め て いる 和 柔道 。 当時 と 同じ 競技 会 場 の 日 本 武道 館 で 行わ れる 試合 に 期待 が 高まっ て いま す 。 男女 各 7 階 級 14 の 体重 別個 人 種目 に 加え 、 新 た に 加わ る 混合 団体 戦 に は 男女 それ ぞ れ 3 人 の 選手 が 参加 し ます 。 近代 五 種 武蔵 野 の 森 総合 スポ ー ツ プラ ザ 、 東京 スタ ジア ム 8 月 5 日 7 日 決勝 数 :2 も っ と も バラ エ テ ィ に 富ん だ オリ ン ピ ッ ク 競 技 の ー つ と いえ る 近代 五 種 は フェ ン シ ン グ 、 水泳 (200m 自 由 形 )、 馬 術 (障害 馬術 )、 レー ザー ラン (ラン ニン グ 、 射撃 ) に 挑む 合 競技 で す 。 レー ザー ラン で 最初 に ゴー ル し た 選手 が 金メダル を 獲得 し ます 。 ポ ボート 海 の 森 水上 競技 場 7 月 23 日 一 30 日 決勝 数 : 14 東京 湾 で 開催 され る ボー ト 競 技 で は 競技 大 会 史上 初め て 、 潮 ぎ 手 の 数 も 競技 の 数 も 男女 等 し く な り 、 完 全 な ジェ ンダ ー 平 等 が 実現 し ます 。 今回 の 日 本 で の 大 会 で は 、 男 子 の 軽量 級 和 能 手 な し フォ ア に 代わ っ て 女子 能 手 な し フォ ア が 登場 し 、 男女 の 種目 数 が 同じ 7 種目 ずつ に な り ま す 。 スウ ィ ー プ で は 溝 ぎ 手 が 使う オー ル は 1 本 の み で す が 、 ス カル で は 2 本 使い ます 。  "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " Olympic Review Issue 116 QLP 51 ⑯ | 7 人 制 ラグ ビー iP? テコ ンド ー Ue | axzse7n Ve 幕張 メッ セ fp 7 月 26 日 一 31 日 7 月 24 日 ご 27 日 決勝 数 :2 決勝 数 :8 ラグ ビー は 7 人 制 と いう 新た な か た ち で 、 2016 年 に オリ ン ピ ッ ク 競 技 と し て 復活 を 果たし まし た 。 男女 と も 、 12 チ ー ム が グル ー プ リー グ に 挑み 、 前 半 後 半 7 分 ずつ 計 14 分 間 の 手 に 汗 握る 試合 を 繰り 広げ ます 。 チ ー ム は 4 チー ム か ら 成 る 三 つ の グル ー プ リー グ に 分 けら れ 、 各 チー ム と 1 回 ずつ 対戦 し ます 。 各 ブー ル の 上 位 2 チー ム お よび 、 各 ブー ル 3 位 の な か で 上 位 2 チー ム が 決勝 トー ナメ ント に 進み ます 。 セー リン グ 江の島 ヨッ ト ハ ー バ ー 7 月 25 日 一 8 月 4 日 決勝 数 :10 東京 2020 の セー リン グ は 六 つ の 異な る 階級 で 構成 され て いま す 。 いずれ の 種目 も フィ ニッ シュ の 順位 の 高い チー ム ほ ど 低 い 点数 が つく スラ イド 制 で 、 優勝 者 は 1 ポイ ント が 与え られ ます 。 つま り 、 累 計 ス コア が も っ と も 低い ボー ト が 金メダル を 獲得 し ます 。 射撃 陸上 自衛 隊 朝 霞 訓練 場 7 月 24 日 一 8 月 2 日 決勝 数 :15 スキ ル と 精神 力 が 問わ れる 射撃 は ライ フル 、 ピス トル 、 シ ョ ッ ト ガ ン (散弾 銃 ) の グル ー プ に 分 類 さ れ ま す 。 ライ フル と ピス トル は 静止 状態 の 標的 を 、 シ ョ ッ ト ガ ン 競 技 で は 、 動 く 標的 、 クレ ー を 狙い ます 。 ジェ ンダ ー 平 等 を 推進 する 目的 で 、 東 京 2020 に は 10m エア ライ フル 、 10m エ アピ スト ル 、 ト ラッ プ と いう 三 つ の 新しい 混合 種目 が 加わ り ま す 。 卓球 東京 体育 館  7 月 24 日 一 8 月 6 日  決勝 数 :5  東京 2020 で は 男女 シン グル ス と ダブ ルス に 加え 、 初め て 男女 混合 ダブ ルス が 加わ り ま す 。  計 五 つの トー ナメ ント は 負け た ら 敗 退 す る  勝ち 抜き 方 式 で 行わ れ 、 準 決勝 の 敗者 同士 が 銅メダル 獲得 を 目指 し て 対戦 し ます 。  aon  試合 は 各 2 分 の ラウ ンド を 3 回 行い 、 ラ ウン ド の 間 に は 60 秒 の 休憩 時 間 が 設け られ ます 。 男女 と も 重量 別に 4 階級 が あり 、 防 具 に 装着 され た 電子 セン サー が 、 有 効 な 蹴り や 打撃 を 加点 し ます 。 デ テニス 有明 テニ ス の 森 7 月 24 日 一 8 月 1 日 決勝 数 :5 今回 の 競技 大 会 で 16 回 目 を 数 える テニ ス 競 技 で は 男子 お よび 女子 の シン グル ス と ダブ ルス に 加え 、 3 大 会 連続 と な る 混合 ダブ ルス が 行わ れ ま す 。 すべ て の シン グル ス の 試合 は 2 セッ ト 先 取 の 3 セッ ト マッ チ 方 式 を 採用 し て いま す が 、 ダ ブル ス の 試合 で は 最終 セッ ト の 代わ り に 10 ポ イン ト 先 取 の タイ ブレ ー ク で 勝敗 が 決ま り ま す 。 トラ イア スロ ン お 台場 海浜 公園 7 月 26 日 一 31 日 決勝 数 :3 男性 選手 と 女性 選手 が 2 人 ずつ 出場 する 混合 リレー が トラ イア スロ ン の 新種 目 と し て 加わ り 、 競技 を 盛り 上 げ ま す 。 二 つ の 個人 レー ス は 1.5km の スイ ム (水泳 )、40km の バイ ク (自転 車 ロ ー ド レー ス ) 、 10km の ラン ( 長 距 離 走 ) で 、 混 合 レ ー ス は 各 選 手 が ショ ー ト コー ス の トラ イア スロ ン (スイ ム 300m、 バイ ク 7.4km、 ラ ン 2km) を こなし ます 。 予選 も 休憩 も な く 、 最 初 に ゴー ル に 到達 し た 選手 が 金メダル を 獲得 し ます 。 バレ ー ボ ー ル 競技 有明 アリ ー ナ 、 潮 風 公園 7 月 24 日 一 8 月 8 日 決勝 数 :4 1 チー ム 各 6 人 の 選手 か ら 成 る 2 チー ム が 18x9 m の 室内 コー ト で 対戦 する バレ ー ボ ー ル で は 、 ボー ル の スピ ー ド が 時 速 130km を 超え る こと も あり ます 。 や や 小さ め の コ ー ト で の ビー チバ レー ボー ル で は 1 チー ム 2 人 編成 で 、 マ ッ チ を 勝ち 取る に は 2 セッ ト を 先取 する 必要 が あり ます 。 この 競技 は 潮風 公園 に 設置 され る 仮設 の 会 場 で 行わ れ ます 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 52-title\" style=\"top:348px;left:44px\" src=\"/tokyo2020/static/_content/52-title-1.png\">\n        <img class=\"halfScale 52-title\" style=\"top:399px;left:43px\" src=\"/tokyo2020/static/_content/52-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax();\n          pg52Anim.staggerFromTo(cOf(\"52-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop();\n        }\n        ",
    "searchText": " 52 特集 記事 : 東京 2020 プレ ビュ ー A) ウェ イト リフ ティ ング 東京 国際 フォ ー ラ ム 7 月 24 日 一 8 月 4 日 決勝 数 :14 世界 で も 非常 に 長い 歴史 を 誇る 競技 、 ウエ イト リフ ティ ング 。 東京 2020 で は 、 初 め て 男女 平等 に 各 7 階 級 が 設け られ まし た 。 選手 は スナ ッ チ と 2 段階 動作 の クリ ー ン & ジャ ー ク の 最高 重量 の 合計 を 競い ます 。 東京 2020 新 競技 New in Tokyo 東京 2020 で は 新た に 5 つの 競技 が 加わ り ま し た 。 野球 プ ソ フト ボー ル 横浜 スタ ジア ム 、 福 島 あ づま 球場 7 月 21 日 ご 8 月 7 日 決勝 数 :2 男子 野球 と 女子 ソフ ト ボ ー ル が 2008 年 以来 の 復活 を 果たし まし た 。 競技 は 横浜 と 福島 で 行わ れ 、 それ ぞ れ 6 か 国 が 参加 し ます 。 試合 は グラ ウン ド 上 で ピッ チャ ー と バッ ター を 中 心 に 展開 し ます 。 ソフ ト ボ ー ル の ボー ル は 野球 で 使わ れる ボー ル よ り も や や 大 きい こと が 特徴 で す 。 空手 日 本 武道 館 8 月 5 日 一 7 日 決勝 数 :8 その 歴史 を 古代 に まで 遡る 空手 は 、 東京 2020 で 初め て 競技 と し て 加わ り ま し た 。 つの 種目 か ら 成 り 、 男 女 そ れ ぞ れ 四 つの 決勝 が あり ます 。「 組 手 」 は 3 分 の 間 に 有 効 な 蹴り や 突き で ポイ ント を 稼ぐ 格闘 技 で す 。 1 人 で 行う 「 形 」 は 指定 され た 演武 を 行い 、 審査 員 に よっ て 採点 され ます 。 NA めげ し レス リン グ AikXyt 8 月 1 日 7 日 決勝 数 :18 世界 最 古 の 競技 と みな され て いる レス リン グ は 直径 9 メー トル の 円 形 マ ッ ト の 上 で 行わ れ ま す 。 フリ ー ス タイ ルレ スリ ング は 、 対 戦 相 手 の 両 肩 を 床 に 1 秒間 フォ ー ル する の が 狙い で す 。 その 際 体 の どの 部 分 を 使っ て も 構い ませ ん 。 一 方 、 グレ コロ ー マ ン スタ イル で は 、 上 半身 の み を 使っ て 対戦 相手 を フォ ー ル し ます 。 スケ ー ト ボー ド 有明 アー パン スポ ー ツ パー ク 7 月 25 日 一 8 月 5 日 決勝 数 :4 スト リー トス ケー ト ボ ー ド の コー ス に は 階段 、 ハン ドレ ー ル 、 緑 石 、 ベ ンチ 、 壁 が 設置 され 、 選手 が 披露 する トリ ッ ク は 難易 度 、 高 さ 、、 ス ピー ド 、 オリ ジ ナ リティ な どの 面 で 採点 され ます 。 パー クス ケー ト ボ ー ド は 両 サ イド に 角度 の 付い た 窪地 状 の コー ス で 行わ れる た め 、 空 中 で の エア ・ ト リッ ク が 披露 され ます 。 スポ ー ツ クラ イミ ング 青海 アー バン スポ ー ツ パー ク 8 月 3 日 一 6 日 決勝 数 :2 選手 は スピ ー ド 、 ボ ル ダ リ ング 、 リー ド の 3 種目 混合 で 競い ます 。 ス ピー ド で は 高 さ 15m の 壁 を 垂直 に 登り 、 スピ ー ド を 競い ます 。 ボル ダリ ング は 、 ロ ー プ を 使わ ず に 4m の 壁 に 設置 され た 一 連 の ルー ト を 登り ます 。 リー ド で は ロー プ を 使っ て 高 さ 15m の 壁 を 6 分 以内 で 登り ます 。 も っ と も 優秀 な 総合 成績 を 達成 し た 選手 が 金メダル を 獲得 し ます 。 サー フィ ン 釣 ヶ 崎 海岸 サー フィ ン ビ ピーチ 7 月 25 日 8 月 1 日 決勝 数 :2 5 人 の ジャ ッ ジ が 、 難 易 度 や 演技 の バリ エー ショ ン に 基づい て 各 選 手 の ラ イデ ィング を 採点 し ます 。 各 ヒ ー ト は 最長 35 分 で す 。 点数 の 高い 2 本 の 合計 点 が その 試合 の 結果 と な り ま す 。 今回 、 オ リン ピッ ク 競 技 大 会 に 加わ っ た スケ ー ト ボー ド の 競技 は 、 有明 アー バン スポ ー ツ パー ク に て 開催 され ます"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 54-title\" style=\"top:127px;left:43px\" src=\"/tokyo2020/static/_content/54-title-1.png\">\n        <img class=\"halfScale 54-title\" style=\"top:272px;left:44px\" src=\"/tokyo2020/static/_content/54-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg54Anim = new TimelineMax();\n          pg54Anim.staggerFromTo(cOf(\"54-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg54Anim.stop();\n        }\n        ",
    "searchText": " 54 特集 記事 : 東京 2020 プレ ビュ ー jewel in the East 東京 2020 オ リン ピッ ク 競 技 大 会 で は 、 ほ と ん どの 競技 が 華やか な 都市 景観 に 囲ま れ た 日 本 の 首都 、 東 京 と その 周辺 の ニニ つ の エリ ア で 実施 され ます 。 ヘリ テッ ジ ゾ ソーン この ソーン に は 、 東京 1964 オ リン ピッ ク 競 技 大 会 の た め に 建設 され 、 今 な お レガ シー と し て 現存 する 5 会 場 を 含む 、 主 要 な 10 の 競技 会 場 が あり ます 。 オリ ン ピ ッ クス タ ジ ア ム 明治 神宮 外苑 地区 に 位置 し 、 東京 2020 オ リン ピッ ク 競 技 大 会 の 中 心 的 役割 を 果たす この スタ ジア ム は 、 東京 1964 で メイ ン 競 技 場 と し て 利用 され 、 国民 か ら 親 し まれ て いた 国立 競技 場 を 建て 替え た も の で す 。 ス タ ジ ア ム で は 開会 式 や 閉会 式 に 加え 、 陸上 競技 、 サッ カー 競技 が 開催 され 、 競技 大 会 後に は スポ ー ツ と 文化 の 拠点 と し て 機能 し ます 。 屋根 の 一 部 に は 、 日 本 の 全 47 都 道府県 か ら 調達 され た スギ と カラ マツ が 使わ れ て いま す 。 東京 体育 館 本 来 1954 年 に 世界 レス リン グ 選 手 権 を 開催 する た め に 建設 され た 東京 体育 館 は 、 東 京 1964 で 体 操 と 水球 の 競技 会 場 と し て 再 利用 され まし た 。 東京 2020 開 催 期間 中 は 卓球 の 競技 会 場 と か り ます 。 国立 代々 木 競 技 場 吊り 屋根 構造 で 有名 な 国立 代々 木 競 技 場 は 、1964 年 の 大 会 時 に 水泳 や バス ケット ボー ル の 競技 会 場 と し て 利用 する た め に 建設 され まし た 。 以来 、 この 競技 場 は 各種 スポ ー ツ の 会 場 と し て 利用 され て お り 、 東 京 2020 で は ハン ド ボ ー ル の 試合 会 場 と な り ま す 。 日 本 武道 館 日 本 に お ける 武道 精神 の 拠り 所 と し て 知ら れる 日 本 武道 館 は 、1964 年 の 競技 大 会 で 、 初め て 正式 競技 に 採用 され た 柔道 の 競技 会 場 と な り ま し た 。 そし て 今年 も 、 柔 道 に 加え て 空手 の 競技 が ここ で 開催 され ます 。15 世 紀 に 江戸 城 が あっ た 敷地 に 建設 され 、 A 代 の 寺 と 富士 山 か ら 着 起 し て デザ イン され まし た 。 東京 国際 フォ ー ラ ム 東京 の 金融 街 の 中 心地 に 位置 し 、 目 を 見 張る よう な ガ ラス の ファ サー ド を 誇る 多目的 コン ベン ショ ン & ア ー ト セン ター で 、 年 間 何 百 万 人 も の 来場 者 を 集め て いま す 。 1996 年 に 完成 し た この 会 場 で は 、 今年 の 競技 大 会 で ウエ イト リフ ティ ング 競技 が 開催 され ます 。 SIC ARF ASOD REIC RS 東京 アク アテ ィ ク ス セ ンタ ー 1964 年 の 東京 オリ ン ピ ッ ク 競 技 大 会 で 使用 され た "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " Olympic Review Issue 116 55 国技 館 本 来 、 国 技 館 は 相撲 と 深い 関わ り の が あり ます が 、 2021 年 に は ボク シン グ 競 技 が 開催 され ます 。 建物 の 内 部 は すり 鉢 状 に 設計 され て お り 、 観客 は どこ の 席 か ら も 、 視 界 を 遊 ら れる こと な く 観 戦 で きま す 。 BEAR 馬 事 公 苑 は 東京 1964 で は 馬術 の 競技 会 場 で し た 。 そし て 57 年 を 経た 今年 、 再 び 馬 場 馬 術 、 oes : 害 馬 術 の 競技 が 開催 され ます 。2019 年 に 改装 た この 会 場 は 、 競技 大 会 終了 後に oamenieie よっ て 運営 され ます 。 武蔵 野 の 森 総合 スポ ー ツ プラ ザ 東京 2020 大 会 に 先駆 け て 建設 され た 初 の 常設 施設 で ある この 会 場 は 、 バド ミン トン と 近代 五 種 の 競技 会 場 と な り ま す 。 ス イミ ング ブー ル 、 ジ ム 、 多 目的 の スポ ー ツ 会 場 を 有 し 、 二 つ の フィ ッ ト ネ スス タ ジ オ は 競技 大 会 後に 一 般 に 公開 され 、 利 用 が 可能 に な り ま す 。 東京 スタ ジア ム 競技 大 会 開催 中 、 サッ カー、 近代 五輪 、 ラ グ ビ ー が こ の スタ ジア ム を 盛り 上 げ ま す 。2001 年 に オー プン し た この 会 場 は 、 サ ッ カ ー の FC 東京 の 拠点 と な っ て お り 、 2019 年 ラグ ビー ワー ルド カッ プ の 開会 式 が 行わ れ た 場所 で も あり ます 。 武蔵 野 の 森 公園 自転 車 競技 の ロー ドレ ー ス の スタ ー ト 地点 と し て 選ば れ た この 公園 は 、 東 京 西部 の 静か な 郊外 に あり 、 敷 地 面積 34 万 平方 m に 及び ます 。 東京 ベイ ゾー ン レイ ン ボ ー ブ リ ッ ジ を 含む 素晴らし い パ ノラ マ 景 観 が 望め る 水辺 の エリ ア 、 東京 ベイ ゾー ン は 、 革新 的 な 都市 開発 の シン ボル と な っ て いま す 。 東京 2020 オ リ ン ピ ッ ク 競 技 大 会 の 14 の 競技 会 場 が 位置 する 他 、 威 風 堂々 と し た 「 東 京 ビッ グ サ イト 」 コ ン ベ ン ショ ン セ ン ター 内 に は 、 国 際 メ ディ アセ ンタ ー が 設置 され ます 。 東京 アク アテ ディクス セ ンタ ー メイ ン ブ ー ル の サイ ズ を 変更 で きる 可動 式 の 床 と 璧 を 備え た 、 この 最 先端 の 施設 は 、 競技 大 会 終了 後に 一 般 利 用 が 可能 に な り ま す 。 大 会 開催 中 、 この 施設 で は 水泳 、 飛 び 込 み 、 ア ー テ ィ ス ティ ックス イミ ング の 競 技 が 行わ れ ます 。 有明 体操 競技 場 東京 有明 地区 の 北部 に 位置 し 、 建築 全体 に 木材 を 使 用 し た 仮設 会 場 で 、 新 体操 、 体操 競技 、 ト ラン ポリ ン 競技 が 開催 され ます 。 競技 大 会 後に は 観客 席 が 撤去 され 、 常 設 の 展示 施設 に 生ま れ 変わ り ま す 。 も う 一 つの 我が家 へ ヘリ テッ ジ ゾ ー ン と 東京 ベイ ゾー ン が 交わ る 晴海 の 臨海 地区 に 位置 する オリ ン ピ ッ ク 村 は 、 物理 的 に も 象徴 的 に も 大 会 の 中 心 に あり ます 。 人 工 島 に そびえ 立つ 美しい 23 棟 の 高層 ビル か ら 成 る 選手 村 で 、 選 手 た ち ( 開催 都市 が 誇る 壮観 な 眺め を 楽し むこ と が で きま す 。 競技 大 会 終了 後に は マン ショ ン と し て 再開 発 さ れ ます 。 有明 アー バン ス ボ ポーツ パ ー ク 選手 村 か ら も 近い 、 美 し い 了 臨海 地域 の 施設 で 、 今 年 初 め て オリ ン ピ ッ ク 競 技 と な る BMX フ リー スタ イル と ス ケー ト ボ ー ド 競技 の 会 場 と な り ま す 。 有明 テニ ス の 森 1983 年 に ゴル フ 場 跡地 に オー プン し た この 公園 は ショ ー コ ー ト 、 屋内 コー ト 、 屋外 コー ト を 有 し 、 競技 大 会 期間 中 に は 9 日 間 に わ た っ て テニ ス 競 技 が 開催 さ れ ま す 。 有明 コロ シア ム と し て 知ら れる 競技 場 の セン ター コー ト に は 、 開 閉 可 能 な 屋根 が 設置 され て いま す 。 有明 アリ ー ナ その 名 を 知ら れる レン ボー ブリ ッ ジ で 、 東京 中 心 部 と つなが れ て いる 人 工 島 「 お 台場 」 に ある この 会 場 で は バレ ー ボ ー ル 競技 が 行わ れ ま す 。 ス タイ リッ シュ で モ ダン な 外観 が 特徴 的 で 、 後に スポ ー ツ 施設 兼 文化 施 設 と し て 利用 され ます 。 青海 アー バン スポ ボー ツ パ ー ク 有明 アー バン スポ ー ツ パー ク 近 くに 位置 し 、 より 大 き な 敷地 面積 を 誇る この 施設 は 、 若者 が 集まる 都会 の 人 人 気 ス ポッ ト で す 。 東京 2020 大 会 で 初め て 採用 さ れ た 3x3 バス ケッ ト ボ ー ル と スポ ー ツ クラ イミ ング の 競技 会 場 と な り ま す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 56 特集 記事 : 東京 2020 プレ ビュ ー 潮風 公園 お 人 台場 の 睡 海 地区 で は 最大 の 公園 で あり 、1 万 3 千本 の 樹木 を 誇る 緑 豊 か な 潮風 公園 で は 、 ビー チバ レー 競技 が 行わ れ ま す 。 海 の 森 クロ スカ ント リー コー ス 東京 激 の すばらし い 眺 め を 楽し むこ と が で きる 会 場 で す 。 総合 馬術 の クロ スカ ント リー 種目 が 開催 され ます 。 お 台場 海浜 公園 高き 12.5m を 誇る 自由 の 女神 像 の レプ リカ が 見 られ る この 素晴らし い 公 園内 で は 、 トラ イア スロ ン と マラ ソン スイ ミン グ の 競技 が 行わ れ ます 。 大 井 ホッ ケー 競技 場 完成 韻 も ない この 会 場 は 、、 三 つの 人 工 グ ラウ ンド を 有 し 、 競技 大 会 後に は 様々 な スポ ー ツ 向け の 施設 と し て 利用 され ます 海 の 森 水 上 競技 場 魅力 あふ れる 了 臨海 地区 に ある この 競技 場 で は 、 カ ヌー の スプ リン ト と ボー ト 上 競技 が 行わ れ ま す 。 コー ス は 全長 2335m、 幅 は 198m あり 、 東 京 2020 大 会 後 に は 国際 的 な レガ ッ タ の 会 場 と な り ま す 。 カメ ヌー・ ス ラロ ー ム セン ター 日 本 初 の 人 工 コ ー ス を 擁する この セン ター で は 、 カ ヌー の スラ ロー ム 競 技 が 開催 され 、 競技 大 会 終了 後 に は 、 様 々 な 水上 競技 や レジ ャ ー の た め の 施 設 と し て 利用 され ます 。 夢の島 公園 アー チェ リー 場 東京 ベイ ゾー ン の 夢の島 に 立つ この アー チェ リー 場 を 含む 複合 施設 は 、 グ ラン ドス タン ド と 弓形 を し た ウォ ー ム ア ッ プ エ リ ア を 備え て いま す 。 貌 技 大 会 後に は 、 地 域 の アー チェ リー クラ ブ の 会 員 に 開放 され ます 。 東京 展 巳 国際 水泳 場 30 年 近く 前 に 東京 の ウォ ー タ ー ス ポー ツ の 拠点 と し て オー プン し た この セン ター は 、 鉄筋 コン クリ ー ト と 銅 鉄 で 建設 され た 優雅 な 建物 で 、 そ の プー ル で は ス ミン グ の 数 々 の 世界 記録 が 樹立 され まし た 。 幕張 メッ セ 東京 の 東側 、 千葉 市 に 位置 する 幕張 メッ セ は 、 エン ター テイ ン メ ント の 拠点 と し て も 機能 する 大 規模 な コ ン ベ ン ショ ン セ ンタ ー で あり 、 大 会 中 に は レス リン グ 、 テコ ンド ー、 フ ェ ン シン グ の 競技 会 場 と な り ま す  ビュ ー テ ィ フ ル ゲ ー ム 競技 大 会 に お ける サッ カー の 試合 は 、 日 本 全国 で 行わ れ 、 計 53 試 合 が 東京 以外 に 散ら ば る 世界 一 級 の 会 場 で 開催 され ます 。 2002 FIFA ワ ー ル ドカ ッ プ の 決勝 が 行わ れ た 横浜 国際 総合 競技 場 、 東 北 の 被災 地 に 位置 する 宮城 スタ ジア ム も これ ら の 会 場 に 含ま れ ま す 。 札幌 ドー ム 札幌 宮城 スタ ジア ム 利府 茨城 カシ マス タ ジ ア ム 鹿島 埼玉 スタ ジア ム 2002 埼玉 横浜 国際 総合 競技 場"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " Issue 116 Olympic Review 57 nee Tr どど デメ RTE TTR ERAnSnOnK SRORBAEOOR に 選ば れ ま じ だ 。 冨士 スピ ビー ドウ ェ イ サイ クリ ング の ロー ド 競 技 の ゴー ル 地 点 で あり 、 個人 タイ ム ト ラ イア ル の 会 場 で も ある この サー キッ ト は 全長 2.8km で 、 過 去 に ば FT1 日 本 グラ ン プリ の 会 場 に も な り ま し た 。 福島 あづま 球場 東京 か ら 北 に 約 217kn 離 れ た 、 東北 地方 に 位 置 す る と の スタ ジア ム は 、 2011 年 に 発生 し た 津波 に よっ て 深刻 な 被害 を 受け まし た 。 被 災 地 に オリ ン ピ ッ ク 精 神 を も た ら そ うと いう 主催 者 の 意図 に より 、 と と で は 野球 と ソフ ト ボ ー ル の 競技 が 開催 され ます 。 横浜 スタ ジア ム 1978 年 に オー プン し た 、 プロ 野球 チー ム の 本 拠 地 で も ある この スタ ジア ム で は 、 野球 と ソフ ト ボ ー ル の 決勝 戦 が 開催 され ます 。 札幌 大通 公園 北海 道 の 札 幌 市 に 位置 する この 公園 は 、 長 辺 が 1.5km の 長方形 を し て いま す 。 東京 より も 気 温 が 低い と と か ら 、 マラ ソン と 競歩 の 競技 の 開 供 場所 に 選ば れ ま し た 。 gS ee ee 1929 年 に オー プン し た 由緒 ある と の ゴル フ 場 、、 は 、 オ リン ピッ ク メ イ ン 会 場 か ら 約 56km 離 れ 。 た 場所 に 位置 し 、 男 子 お よび 女子 の ゴル フ 競 技 . eee eer aE) 釣 ヶ 崎 海岸 サー フィ ン ビ ー チ 東京 か ら 東 に 約 65km 離 れ た 場所 に 位置 する 、 北 太平 洋 を 望む お この ビー チ は 千葉 県 内 に あり 、 今回 初め て オリ ン ピ ッ ク 競 技 と じ て 加 わっ た サー フィ ン の 競技 会 場 で す 。 江の島 ヨッ ト ハ ー バ ー 東京 1964 の セー リン グ 競 技 の 会 場 だ っ た 、 神 奈川 県 相模 湾 の 港 で ある こと の セン ター は 、 今 年 も 同じ 役割 を 果たし ます 。 伊豆 ぶ ロ ドロ ー ム 東京 か ら 南 に 130km の 場所 に 位置 する 、 自転 車 競技 日 本 代表 選手 の トレ ー ニ ング セン ター で ある この 会 場 は 、 2011 年 に オー プン し 、 今 競技 大 会 を 控え て 大 幅 な 改修 が 行わ れ ま し た 。 伊豆 MTB コ ー ス |: 上 UE eo doe の Parle weasel Sera See S| fe ae eae se さい た ま ス ー パ ー ア リー ナ : 東京 の 30km 北 に 位置 する 、 目 本 最大 級 の 多 目的 会 場 の 一 つ で ある と の アリ ー ナ で は 、 パス ケッ ト ボ ー ル の 競技 が 開催 され ます 。 競技 大 会 後 は バス ケッ ト ボ ー ル 、 プロ レス リン グ 、 MMA、 バレ ー ボ ー ル 、 テニ ス 、 アイ スポ ッ ケ ー な どの 様々 な スポ ー ツ の 会 場 と し て 利用 され ます 。 陸上 自衛 隊 朝 霞 訓練 場 東京 2020 の 東京 外 の 会 場 の 中 で 、 都 心 に き わ め て 近い 会 場 の ー つ で ある と の 訓練 場 で は 、 1964 年 に も 射撃 の 競技 が 開催 され まし た 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 58-title\" style=\"top:107px;left:46px\" src=\"/tokyo2020/static/_content/58-title-1.png\">\n        <img class=\"halfScale 58-title\" style=\"top:212px;left:45px\" src=\"/tokyo2020/static/_content/58-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim.staggerFromTo(cOf(\"58-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop();\n        }\n        ",
    "searchText": " 58 特集 記事 : 東京 2020 プレ ビュ ー 大 会 舞台 裏 を 文 える TOP パー トナ ー プ ログ ラム 過去 の オリ ン ピ ッ ク 競 技 大 会 と 同様 、 リ ワー ルド ワイ ド オ リン ピッ ク パ ー ト ナー は 2020 年 東京 オリ ン ピ ッ ク 競 技 大 会 を 安全 安心 、 そ し て 成功 裏 に 行う た め に 中 心 的 な 役割 を 果たし ます 。 の オリ ン ピ ッ ク 競 技 大 会 開催 期間 中 は 、 開 =] 催 地 で ある 東京 に 世界 中 の 注目 が 集まる と 同時 に 、 感動 的 な パフ ォ ー マ ンス を 繰り 広げ る 選手 た ち に 人 々 の 視線 は 釘付け と な る こと で し ょ う 。 一 方 、 競技 の 舞台 裏 で オリ ン ピ ッ ク 競 技 大 会 の 成功 の 鍵 を 握っ て いる の が 、 ワー ルド ワイ ド オ リン ピッ ク パ ー ト ナー と いう 精鋭 集 還 で す 。 TOP パ ー ト ナー プロ グラ ム (The Olympic Partners programme) は 、 オ リン ピッ ク 競 技 大 会 に 関す る 最高 位 の スポ ン サ ー シ ッ ププ ログ ラム で あ り 、 その メン バー は 世界 を けん 引 す る 多国 籍 企業 で す 。 大 会 を より スム ー ズ か つ 効 率 的 に 運営 する た め の 技術 サポ ー ト 、 製 品 、 専 門 知 識 、 資 金 を 提供 する こ と で 、 より 多く の 各国 オリ ン ピ ッ ク 委 員 会 (NOC) の 選手 た ち が 、 この 世界 最大 の スポ ー ツ の 祭典 に 参加 で きる よう に 尽力 し て いま す 。 トー マス ・ バ ッ ハ 1OC 会 長 に よる と 、 ワー ルド ワイ ド オ リン ピッ ク パ ー ト ナー の 重要 性 は 、 特に 新型 コロ ナウ イル ス 感 染 症 葛 延 に よる 影響 か ら の 回 復 途中 に ある スポ ー ツ 界 に と っ て 、 言葉 で 言い 表せ な い ほ ど 大 き な 存 在 で す 。 「 か つて な い 人 危機 の 中 、 ワー ルド ワイ ド オ リン ピッ ク パー トナ ー の 揺るぎない 自信 は 、 過去 に 例 を 見 な い 大 き な 意 味 を 持ち ます 」 と 会 長 は 話し ます 。「 グ ロー バル パー トナ ー に よる 長期 的 な 支援 が ある こと で 、 オ リン ピッ ク ・ ム ー ブ メ ント は 財政 面 で の 安定 性 と 運用 面 で の サポ ー ト を 享受 する こと が 可能 に な り ま す 。 こ れ は 、 過 去 18 か 月 間 に 世界 が 直面 し た よう な 困難 に 打ち 勝つ た め の 原 動力 と な り ま す 。 ま た 、 これ に より 得 ら れ た 収入 の 90% を 再 分 配 す る こと で 、 IOC は 年 間 を 通じ て 世界 中 の 競技 と 選手 を サポ ー ト する こと が で きま す 」 TOP パ ー ト ナー プロ グラ ム は 一 部 の グロ ー バ ル パー トナ ー に 、 各 分 野 に 応じ た 独占 的 な オリ ン ピ ッ ク マー ケティング の 権利 を 付与 する も の で 、1985 年 の プロ グラ ム 開 始 以降 オリ ン ピ ッ ク ・ ム ー ブ メ ント の 主要 な 収入 源 と な っ て いま す 。 この 収入 は 、 世 界 中 の NOC を 含む あら ゆる レベ ル の スポ ー ツ 組織 に 直接 分 配 され 、 各 組織 は 受け 取っ た 資金 を 選手 た ちの 育 成 と サポ ー ト に 充て る こと で 、 オリ ン ピ ッ ク 競 技 大 会 に チー ム を 送り 出す こと が 可能 に な り ま す 。 より 多く の NOC の 選手 が 参加 で きる よう に な っ た こと か ら も 、 TOP パ ー ト ナー プロ グラ ム が 、 オリ ン ピ ッ ク 競 技 会 の 普遍 性 を 高め る こと に 大 きく 貢献 し て いる こ と が 分 か り ま す 。 TOP プ ログ ラム は 金銭 面 の サポ ー ト だ け に と ど まる も の で は あり ませ ん 。 ワー ルド ワイ ド オ リン ピッ ク パ ー ト ナー は また 、 実際 の オリ ン ピ ッ ク 開 催 に お い て も 不可 欠 な 役割 を 果たし ます 。 製品 、 サ ービス 、 専 門 知 識 を 提供 する 他 、 彼ら の グロ ー バ ルオ リン ピッ クマ ー ケ ティ ング キャ ン ペ ー ン は 、 オリ ン ピ ッ ク 競 技 大 会 を 促進 する と 同時 に その 価値 観 を 広め 、 オ リ ン ピ ッ ク 選 手 へ の さら な る 支援 を 呼び 込ん で いま す 。 IOC マ ー ケ ティ ング 委員 長 の イリ ー・ ケ イヴ ァ ル 氏 は 、 この 運営 支援 こそ が 、 オ リンピック お よび オリ ン ピ ッ ク ・ ム ー ブ メ ント 全体 に と っ て 、 非 常に 足音 で ある こと を 指摘 し ます 。 「 ワ ー ル ド ワ イ ド オリ ン ピ ッ ク パ ー ト ナー の サポ ー ト 、 そし て 彼ら の 技術 、 専 門 知識 、 人 材 、 サ ービス 、 製品 、 資金 調達 無く し て 、 オ リン ピッ ク 競 技 大 会 を 開催 する と と は 不可 能 で す 」 と ケイ ヴァ ル 氏 は 語り ます 。「 パ ー トナ ー の サポ ー ト で 、 より 多く の 国 か ら よ り 多 く の 選 手 が オ リン ピッ ク 競 技 大 会 に 参加 する こと が で きま す 。 彼ら は 、 オリ ン ピ ッ ク ・ ム ー ブ メ ント の 原動力 と な る サー ビス と リソー ス を 提供 し て くれ る の で す 」 東京 で は 、 様々 な 場面 で 多岐 に わた る サポ ー ト が 提供 され ます 。 大 会 会 場 で 使わ れる 最 先端 技術 か ら 、 日 々 の 運営 お よび 新型 コロ ナウ イル ス 対 策 に 不可 欠 な 業界 最 先端 の 製品 まで 、 オリ ン ピ ッ ク に お ける 感 動 的 な パフ ォ ー マ ンス と 忘れ られ な い 瞬 間 の 裏側 に は 、 ワー ルド ワイ ド オ リン ピッ ク パ ー ト ナー の 貢献 が 欠か せま せん 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 60-title\" style=\"top:189px;left:96px\" src=\"/tokyo2020/static/_content/60-title-1.png\">\n        <img class=\"halfScale 60-title\" style=\"top:348px;left:184px\" src=\"/tokyo2020/static/_content/60-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg60Anim = new TimelineMax();\n          pg60Anim.staggerFromTo(cOf(\"60-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg60Anim.stop();\n        }\n        ",
    "searchText": " THROUGH THE LENS 60 レン ズ を 通し て (②69 め i} レン ズ を 通し て IHRUUiH 2020 年 3 月 24 日 に 下さ れ た 、 延 期 と いう 歴史 的 な 決定 に 続き 、 オリ ン ピ ッ ク 競 技 大 会 は すべ て の 関係 者 の 取り 組み に より 、 2021 年 の 安全 な 開催 に 向け て 和 能 を 切り まし た 。 選手 た ち は 引 き 続き 人 トレ ー ニ ング を 行い 、 場 合 に よっ て は 出場 資格 を 獲得 する 必要 が あり まし た 。 一 方 で 聖火 リレー を は じ め と する 各種 セレ モニ ー は 、 コ ロナ 宰 と いう | 状況 に 合わ せ て 実施 形態 が 変更 され まし た 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "\n      <a href=\"https://www.youtube.com/watch?v=ui4NKt-Z5Ks\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"width: 35px; height: 35px; left: 387px; top: 517px; overflow: visible;\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n          <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n          <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n        </svg>\n      </a>\n    ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 61  01. 02. 03. 競技 大 会 延期 の 発表 (2020 年 3 月 ) IOC ト ー マ ス ・ バ ッ ハ 会 長 は 2020 年 3 月 24 日 、 当時 日 本 の 総理 大 臣 だ っ た 安倍 晋三 氏 と 東京 オリ ン ピ ッ ク ・ パ ラリ ン ピ ッ ク 競 技 大 会 組織 委員 会 (東京 2020) の メン バー た ちと の 電話 会 議 に 参加 し て オリ ン ピ ッ ク 競 技 大 会 の 開催 時 期 変更 と いう 苦渋 の 決定 を 下 し 、 新た な 開催 日 程 は: 遅く と も 2021 年 の 夏 と する こと に 同意 し まし た 。 その ニュ ー ス が 世界 中 を 駆け 巡る 中 、 オリ ン ピ ッ ク の 五輪 は 東京 を 明る く 照 らし 、 希望 の 象徴 と な り 続 け ま し た 。 自宅 で トレ ー ニ ング に 励む お アス リー ト (2020 年 6 月 ) 新型 コロ ナウ イル ス 感 染 症 の 深刻 度 が より 明らか に な り 、 世 界 中 で ロッ クダ ウン が 広がる 中 、 ア スリ ー ト た ち は 土 壇 場 で トレ ー ニ ング の スケ ジュ ー ル 変更 を 余儀 な くさ れ ま し た 。 アル ゼン チン の ホッ ケー 代表 チー ム で ゴー ル キー パー を 務め る ホアン ・ マ ヌ エ ル ・ ヴィ ヴァ ルディ も 例外 で は あり ませ ん で し た 。 リオ 2016 オ リン ピッ ク 競 技 大 会 で 金メダル を 獲得 し た ヴィ ヴァ ル テ ィ 選 手 は 数 か 月 間 自 宅 に お いて 一 人 で トレ ー ニ ング を 行っ た 後 、 制 限 が 緩和 され た 6 月 に チー ム トレ ー ニ ング ・ セ ッ シ ョ ン に 復帰 し まし た 。 残す と ころ あと 1 年 (2020 年 7 月 ) オリ ン ピ ッ ク 競 技 大 会 の 新た な 開催 日 程 が 決定 し た こと を 受け 、 2020 年 7 月 23 日 に は 東京 の 国立 競技 場 に て 開会 1 年 前 プロ グラ ム が 開催 さ れ ま し た 。 日 本 人 競泳 選手 の 池 江 瑞 花子 が 聖火 を 灯 し た ラン タン を 持ち 、 世 界 中 の 医療 従事 者 の 尽力 に 対し て 謝辞 を 述べ まし た 。 白血病 を 克服 し た 池 江 選 手 は その 後 、 東 京 2020 へ の 出場 資格 を 獲得 し まし た 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 443px;left: 70px;height: 16px;width: 168px;\">\n          <a href=\"https://olympics.com/ja/video/day-1-of-the-tokyo-2020-olympic-torch-relay-in-fukushima\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 612px;left: 70px;height: 16px;width: 156px;\">\n          <a href=\"https://iocnewsroom.com/video/prior-to-100-days-to-go-to-tokyo-2020-ioc-sees-host-as-best-prepared-in-olympic-history/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "レン ズ を 通し て 競技 の 再開 (2021 年 2 月 ) 2020 年 後半 に も な る と 、 選 手 や その 他 の 来場 者 の 安全 を 確保 する た め の 対 策 を 実施 し つつ 、 多 く の 競 技 が 復活 を 遂げ まし た 。 東京 2020 に 向け た 選考 会 や その 他 の イベ ント は その 後 も 不 確 定 な 1 り 、 世界 中 の 競技 会 場 で は 無 観客 で の 開催 と な っ た に も か か わら すず 、 競技 の レベ ル が 下がる こと は あり ませ ん で し た 。 FIBA (国際 バス ケッ ト ボ ー ル 運 盟 ) 欧州 選手 権 「 ユ ー ロ バス ケッ ト 」 の 予選 で は 、 モン テ ネ グ ロ が ポ ド ゴ リツ ァ で ドイ ツ を 迎え 、 ホー ム に て 82 一 75 で 勝利 を 収め あま し た 。 オリ ン ピ ッ ク 聖 火 リ レー (2021 年 3 月 ) 2021 年 3 月 25 日 、 福 島 県 に ある ナシ ョ ナル トレ ー ニ ング セン ター J ヴ ィ レ ッ ジ か ら オリ ン ピ ッ ク 聖 火 リ レー が スタ ー ト し まし た 。 その 後 、 聖 火 は 日 本 各地 を 巡回 し 、 希 望 の 象 微 と いう 役目 を 果たし つつ 、 世 界 遺 産 や その 他 の 有名 な スポ ッ ト を 通過 。 この 写真 は 全国 を 巡る 聖火 リレー 4 日 目 に 、 聖 火 が 遊覧 船 に て 栃木 県 を 横断 する 様子 を 捉え た も の で す 。 開催 まで あと 100 日 (2021 年 4 月 ) 2021 年 4 月 14 日 、 東 京 駅 に て オメ ガ の カウ ント ダウ ン ・ ク ロッ ク が 開会 式 スタ ー ト まで 100 日 を 切っ た 瞬間 を 表示 。 同日 、 高 尾山 で は オリ ン ピ ッ ク 五 輪 が 披露 され 、 東 京 の 下町 で は この イベ ント を 祝福 する た め の セ レモ ニー が 開催 され まし た 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ". デス トイ ベン ト (2021 年 4 月 ) 競技 大 会 が 刻 一 刻 と 人 迫り 、 準 備 が 進め られ る 中 、 各 種 競 技 の テス トイ ベン ト が 行わ れ ま し た 。 国際 競技 運 盟 、 国 内 競技 連盟 、 東 京 2020 は 、 す べ て の 参加 者 に と っ て オリ ン ピ ッ ク 競 技 を 安全 に 実施 し 、 成 功 さ せる こと を 確実 に する た め の リ ハー サル と し て 、 と これら の イベ ント を 企画 。 この よう な トラ ッ ク 競 技 の テス トイ ベン ト が 、 伊豆 さ ロ ドロ ー ム に お ける 木製 の 250m ト ラッ ク で 実施 され まし た 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "  Olympic Review lssue 116 02. 開催 まで あと 50 日 (2021 年 6 月 ) 開会 式 まで 残す と ころ あと 50 日 と な っ た タイ ミン グ を 記念 し て 、 東 京 2020 は 表彰 式 で 使わ れる 表彰 台 、 テ ー マ 音 楽 、 衣装 、 そ し て メダ ルト レイ を お 披露 目 し まし た 。 今夏 に バレ ー ボ ー ル の 競技 会 場 と な る 有明 アリ ー ナ で 催さ れ た Oe OSA Re OLE te ライ ブス トリ ー ミ ング され まし た 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 66-title\" style=\"top:95px;left:44px\" src=\"/tokyo2020/static/_content/66-title-1.png\">\n        <img class=\"halfScale 66-title\" style=\"top:288px;left:48px\" src=\"/tokyo2020/static/_content/66-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.staggerFromTo(cOf(\"66-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg66Anim.stop();\n        }\n        ",
    "searchText": "THE TOKYO POSTPONEMENT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 67-quote\" style=\"top:400px;left:400px\" src=\"/tokyo2020/static/_content/67-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg67Anim = new TimelineMax();\n          pg67Anim.staggerFromTo(cOf(\"67-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg67Anim.stop();\n        }\n        ",
    "searchText": " Olympic Review lssue 116 67 —= = 2020 年 東京 オリ シン ピック に 22 の とき の HG すべ て の オリ ン ピ ッ ク ・ FSP OA eh 8 ee 大 き な 任務 で し た 「 新 型 コ ロナ ウイ ルス 感染 症 が も た らし た 危機 は 、 私 た ちの 世界 を 根底 か ら Oe Oe oe 世界 が か つて の 状況 に 戻る こと は 決し て あり ませ ん 。 この 人 類 の 健康 を 脅かす 危機 を 乗り 越え た と し て も 、 広 範囲 に 及ぶ 社会 的 、 財 政 的 、 経 済 的 、 そ し て 政治 的 な 影響 に 直面 する こと に な る で し ょ う 。 オリ ン ピ ッ ク ・ ム ー ブ メ ント を 牽引 する 者 と し て 、 私 た ち は こ の 新た な 世界 に 備え な けれ ば な り ま せん 」 137 次 IOC 総会 に お いて 発言 し た この 言葉 は 、 世界 を 根底 か ら 牧 し 、 東京 2020 オ リン ピッ ク 競 技 大 会 の 延 期 を 放 儀 な くし た 新型 コロ ナウ イル ス 感 染 症 の 墓 延 に よる 影 響 を 要約 し て いま す 。 同時 に 、1 年 の 延期 か ら 得 られ た 教訓 の 重要 性 、 そ し て それ を いか に 今後 の 競技 大 会 に 生か し て いけ る か を 強調 し た も の で も あり ます 。 コス ト 削 減 の 簡素 化 対 策 に 始ま り 、 サー ビス レベ ル の 縮小 、 クリ エイ ティ ブ な デジ タル エン ゲー ジメント ・ プ ログ ラム に 至 る まで 、 延期 され た 東京 2020 大 会 は 、 今後 の オリ ン ピ ッ ク 競 技 大 会 組織 委員 会 (OCOG) に 向け て 、 新しい 考え 方 の 扉 を 開き まし た 。 2019 年 の 終わ り に 未知 の 新型 ウイ ルス の 症例 が 初め て 判明 し た と き 、 この 伝染 病 が 世界 中 に 墓 延 し 、 日 常 生 活 が い . ー マ ス ・ バ パッ ハ 会 長 が 、2021 年 3 月 21 日 に 開か れ た 第"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 68 東京 2020 オリ ン ピ ッ ク 競 技 大 会 の 延期つ 「 平 常 」 に 戻る の か 予測 で き な い ほど 、 社会 が 根底 か ら 大 きく 変わ っ て し まう と は 、 誰 一 人 予想 で きま せ ん で し た 。 オ リン ピッ ク ・ ム ー ブ メ ント に 関す る 出来 事 と し て は 、2020 年 3 月 、 パ ン デ ミッ ク の 影響 で 東京 2020 を 1 年 延期 する こと が 決定 され まし た 。 こ れ は 124 年 に 及ぶ 近代 オリ ン ピ ッ ク の 歴史 に お いて 初め て の こと で す 。 この 延期 に より 、 IOC、 日 本 の 主催 者 、 国内 オリ ン ピッ ク 委 員 会 (NOC)、 国 際 競 技 連 盟 (IF)、 選手 、 放 送 局 、 ス ポン サー、 そ の 他 の 主要 関係 者 は 、 ロ ジス ティ クス 的 、 財政 的 、 法 的 、 政治 的 に 、 また 競技 に 関 する 面 で 、 あり と あら ゆる 課題 に 直面 し まし た 。 平時 に お ける 地球 上 で の も っ と も 複雑 な イベ ント で ある 競技 大 会 を 延期 する こと は 、 これ まで に な い 重 大 な 任務 と な り ま し た 。 開催 延期 を 受け て 、 バッ ハ 会 長 は 「 オ リン ピッ ク ・ ムー ブ メ ント は 未 曽 有 の 課題 に 直面 し て いま す 」 と 述べ まし た 。「 こ ー 致 団結 し 、 創造 性 、 覚悟 、 柔軟 性 を 持つ こと を 求め られ て いま す 。 誰 も が 犠牲 と 妥協 を 強い られ て いる の で す 。 異例 の 状況 に お いて は 例外 的 な 対策 が 必要 で す 。 この 状況 で は 私 た ち 一 人 ひと り が 自分 の 役割 を 果たさ な けれ ば な ら ず 、 これ は IOC を 含む すべ て の 人 に 当て は まり ます 」 1 オン ライ ン 会 議 で IOC 執 行 委員 会 に 対し て 発言 する 東京 2020 組 織 委員 会 橋本 聖子 会 長 2 2021 年 に 向け て 選手 村 を 含む すべ て の オリ ン ピ ッ ク 会 場 が 再 確保 され た 3③ オンライン 形式 で 開催 され た 2021 年 3 月 の IOC 総 会 で は 複数 の 重要 な 決定 が 下さ れ た の 新た な 状況 に お いて 、 私 た ち は 皆 、オリ ン ピ ッ ク 大 会 の 開催 再 調整 に お ける 優先 事項 は 、 難 題 の 連続 で し た 。 以下 は その 一 例 で す 。 2021 年 に 開催 する 競技 大 会 の 新た な 日 程 に 対す る 同意 世界 の 各 競 技 大 会 の 日 程 変更 選手 村 を 含む すべ て の オリ ン ピ ッ ク 会 場 の 再 確保 33 競 技 の 競技 日 程 の 再 確認 延期 に よっ て 生じ る 追加 コス ト の 決定 と 負担 競技 大 会 の 簡素 化 と コス ト 削 減 措 置 の 画策 と 実施 スタ ッ フ 、 マ ン パ ワー、 ボ ラン ティ ア の 雑 持 すべ て の 関係 者 に と っ て 安心 安全 な 競技 大 会 実施 に 向け た 、 ウ イル ス 軽 減 対 策 の 考案 と 実施 あり と あら ゆる 面 で 、 すべ て を ゼロ か ら 始 め た よう な も の で し た 。「 今 回 の 延期 に は 、 多大 な 労力 、 徹底 的 な 献身 、 綿密 な 計画 と 実施 を 必要 と し まし た 」 と 、 IOC オ リン ピッ ク 競 技 大 会 エグ ゼクティ ブ ・ デ ィ レ ク ター の クリ スト フ ・ デ ュ ビ 氏 は コメ ント し まし た 。 この 1 年 間 に わ た り 、 予測 不可 能 な 状況 の 中 で プ ロジ ェクト を 進め る た め に 、 IOC、 日 本 政府 、 東 京都 庁 、 東京 オリ ン ピ ッ ク ・ パ ラリ ン ピ ッ ク 競 技 大 会 組織 委員 会 (東京 2020) の 間 で 、 完全 な 団結 と 協調 を 必要 と する 一 運 の 重要 な 決定 が 下さ れ ま し た 。 そし て 、 世界 中 で ウイ ルス と 変異 株 が 容赦 な く 猛 威 を 振る っ て いる に も か か わら ず 、 IOC と その パー ト ナー は 12 か 月 後に 開催 され る 競技 大 会 の 断片 を 、 す べ て つなぎ 合わ せる こと に 成功 し た の で す 。 また 、 デュ ビ 氏 は 「 オ リン ピッ ク ・ ム ー ブ メ ント の 観 点 か ら 言 えば 、 素 晴らし い 団 結 、 そ し て 真 の 意味 で の 利害 と 目的 意識 の 合致 が 見 られ まし た 」 と も 発言 し THES, eAMRICREN EDL, TXNTOA が 高い 意識 と 記 を 持っ て 船 の デッキ に 立っ た の で す 。 オリ ン ピ ッ ク ・ ム ー ブ メ ント と は 、 極 め て 強 形 な も の で ある と いう 教訓 が 得 ら れ ま し た 」 パン デミ ッ ク が 墓 延 の 一 途 を た どり 、 世界 の 大 部 分 が ロッ クダ ウン に 追い 込ま れ た こと を 受け 、 競技 大 会 の 延期 と いう 前 代 未 聞 の 決定 が 発表 され た 2020 年 3 月 24 日 か ら 、 仕 切り 直し の 再 調整 が 始ま り ま し た 。 競技 大 会 の 開催 を 1 年 延期 する と いう 決定 は 、 IOC、 日 本 の パー トナ ー、 その 他 の 関係 者 が 「 大 会 中 止 と い う 選 択 肢 は な い 」 と 満場 一 致 で 同意 し た こと を 受け た も の で す 。 「 私 た ちの レベ ル に お いて 中 止 と いう 話 が 浮上 し た と と は 一 度 も あり ませ ん 」 と 、 ジョ ン ・ コ ー ツ IOC 副"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 69-quote\" style=\"top:809px;left:44px\" src=\"/tokyo2020/static/_content/69-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.staggerFromTo(cOf(\"69-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg69Anim.stop();\n        }\n        ",
    "searchText": " SERN RM 2020FU Vey 7H 長 は 、 コメ ント し まし た 。「 私 た ち を 決め て いま し た 」 デュ ビ 氏 は 、 この コロ ナ 危 機 に よっ て 競技 大 会 0 が キ さか た と きい ます Wy 年 の 延期 は 、 あら ゆる 面 で 複雑 を 極め まし た 。 スケ ジュ ー ル 調整 か ら 始ま り 、 選手 の 準備 に 至る まで 、 Hi 技 大 会 は 、 競 技 そ の も の 、 ひい て は シス テム 全体 に 大 き な 影 響 を 及ぼ し ます 。 競技 大 会 は 、 社会 に も 大 き な 影響 を 与え ます 。 日 本 社会 へ の 影響 は も ちろ ん 、 延期 に あたり 多く の 労力 が 必要 と され る こと は 明らか で し た 。 延期 決定 以来 、 国 連 、 G20 の 指導 者 、 G7、 数 多く の 政府 が 、 ス ポー ツ と 東京 2020 オリ ン ピ ッ ク 競 技 大 会 の 、 大 き な 意 味 で の 社会 に 与え る 重要 性 に つい て 言及 し て いま す 。 競技 大 会 は いつ の 時 代 に お いて も 大 切な イベ ント で し た が 、 今 の 時 代 に は さら に 重要 性 を 増し て いま す 」 延期 の 決定 を 受け て 、 すべ て の 関係 者 が 2021 年 の 同じ 時 期 に 競技 大 会 を 開催 する こと に 合意 し 、 こ の RAB ESA は 確固 と し た 覚悟 「 今 回 の 延期 に は 、 多大 な 労力 、 徹底 的 な 献身 、 綿密 な 計画 と 実施 を 必要 と し まし た 」 クリ スト フ ・ デ ュ ビ 氏 決定 に 合わ せ て 、 国際 競技 連盟 も それ に 応じ て スケ ジュ ー ル を 調整 する こと に な り ま し た 。 例 えば 、 ワ ー ル ドア スレ ティ ックス と 国際 水泳 較 盟 は 世界 選手 権 の 開催 を 2021 年 か ら 2022 年 に 変更 する こと に 同意 し まし た 。 その 他 の スポ ー ツ も 日 程 を 調整 し 、 放送 権 を 保有 し て いる 放送 局 (RHBs) は オリ ン ピ ッ ク 競 技 大 会 を 7 月 23 日 か ら 8 月 8 日 、 パ ラリ ン ピ ッ ク 競 技 大 会 を 8 月 24 日 か ら 9 月 5 日 まで と いう 新た な 日 程 の 契約 に 署名 し まし た 。 延期 に 伴う 甚大 な 財政 的 お よび 経済 的 な 負担 は オリ ン ピ ッ ク ・ ム ー ブ メ ント 全域 に 及び 、 競技 大 会 か ら の 収益 に 依存 し て いる 、 と り わ け 小 規模 な 国際 競 技 運 明 に 打撃 を 与え まし た 。 それ に 伴い 、2020 年 5 月 、IOC は 12 か 月 の 延期 に よっ て 発生 し た 費用 増加 を 補填 する 目的 で 最高 8 億 米ドル の 追加 負担 表明 し まし た 。 この 中 に は 、 国 内 オリ ン ピ ッ ク 委 員 会 、 国際 競技 盟 、 そ の 他 の 組 織 が それ ぞ れ の 競技 、 活動 、 選手 へ の 支援 を 継続 で きる よう に する た め の 1 億 5000 万 米ドル の 貸付 と 負担 が 含ま れ て いま す 。 そし て 、 最大 の 難関 が 訪れ まし た 。 そ れ は 、 2020 年 の 競技 大 会 開催 の た め に 用 意 さ れ た 競技 場 や 施 設 を 2021 年 も 利用 可能 と する こと で す 。 東京 大 会 の 主催 者 は 、 7 月 に 開催 され た 第 136 次 IOC 総 会 に お いて 、43 か 所 の 会 場 すべ て に 加え 、 選手 村 、 国際 放送 セン ター (IBC)、 メ イン プレ ス セ ンタ ー (MPC) を 2021 年 の 競技 大 会 の た め に 再 確保 する と いう 劇 的 な 快挙 を 果たし た こと を 発表 し まし た 。 選 手 村 の 物件 販売 を 手掛け て いた 民間 の 開発 業者 は 住民 の 入居 を 1 年 遅らせ る こと に 同意 し な けれ ば な ら ず 、 IBC お よび MPC と し て 使用 され る 東京 ビッ グ サ イト は 2021 年 イベ ント 予約 の 変更 を 強い られ まし た 。 「 こ れ ら の 変更 は すべ て 、 組織 委員 会 と 東京 都庁 に よっ て 、 大 き な 混 乱 を 招く こと な く 達 成 さ れ ま し た 」 と 、 コー ツ 氏 は 述べ まし た 。「 ま さ に 途方 も な い 課 題 で し た 」 同時 に 、 競技 大 会 の 日 程 は 基本 的 に 変わ ら ず 、 運 営 上 の 理由 で 若干 の 調整 が な され た 程度 で し た 。 次 の 大 き な 課 題 は 、 競技 大 会 開催 の 最適 化 と 経 邊 半減 で し た 。 結 果 と し て IOC と 日 本 は 、 競技 大 会 の 「 簡 素 化 」 と 店 営 コス ト の 削減 を 目的 と し た 50 以 上 に 及 対 策 に 同意 し まし た 。 その 中 に は 、 選手 村 で の 歓迎 セレ モニ ー の 中 止 、 関係 者 の 参加 規模 を 10 ~ 15% HBA, 様々 な 団体 の 移動 の 効率 化 、 競技 大 会 開催 前 の 会 議 の 多く を 現地 で 行う 代わ り に オン ライ ン で 開催 、 会 場 の デザ イン や 飾り つけ の 簡素 化 な ど が 含ま れ て いま し た 。 また 、 開会 式 と 閉会 式 に つ いて は 、 選手 に よる パレ ー ド な どの 伝統 的 な 要素 を 維持 し つつ 簡素 化す る こと を 決定 し まし た 。 こと の よう な コス ト 削 減 の 取り 組み に より 、 2 億"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 70-quote\" style=\"top:777px;left:263px\" src=\"/tokyo2020/static/_content/70-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.staggerFromTo(cOf(\"70-quote\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n        }\n        ",
    "searchText": " 70 東京 2020 オリ ン ピ ッ ク 競 技 大 会 の 延期 8000 万 米ドル の 費用 節減 に 成功 し まし た 。 この 節 減 以 前 に 、 前 年 に お ける パン デミ ッ ク 発 生前 の 段階 で 、 オリ ン ピ ッ ク ・ ア ジェ ンダ 2020 と その ニュ ー ノ ー ム に よっ て 43 億 米ドル の 費用 軽減 が すでに 達成 さ れ て いま し た 。 これ は 、 会 場 マ スタ ー プ ラン の 見 直し で 削減 で きた 22 億 米ドル と 、 ニ ュー ノー ム に よっ て 運 営 予算 を 中 心 に 削減 し た 21 億 米ドル の 合計 額 で す 。 コー ツ 氏 は 、 今回 新た に 実施 され た 簡素 化 対策 が 「 今 後 長き に わた り 、 組織 要員 会 に と っ て 有益 な 青 写 真 と な る 『 東 京 モ デル 』 を 生み 出し まし た 」 と 述べ ま し た 。 例え ば 、 会 場 の 確保 を 後回し に し 、 より 短い 期間 で 準備 を 整え た こと も 大 規模 な コス ト 削 減 に つなが り ま し た 。 将 来 的 に は 、 選手 村 の 開村 を 遅く する こと も 検討 され る だ ろう 、 と コー ツ 民 は 話し ます 。 未 冒 有 の 状況 へ の 対処 を 支援 する こと に 加え 、 IOC と 日 本 の 関係 者 は 競技 大 会 に 向け て 健康 管理 の 観点 か ら 、 選手 村 で の 選手 の 滞在 期間 を 最小 限 に と ど め る こと に 同意 し 、 自分 の 競技 が 始ま る 5 日 前 に 到着 し 、 開催 終了 後 最長 2 日 以内 に 退出 し な く て は いけ な いと 決 定 し まし た 。 延期 に 伴う 最後 の 重大 な 決定 事項 は 、 依然 続い て いる コロ ナ 初 の 中 で の 競技 大 会 開催 に 向け た 、 新型 コロ ナウ イル ス 感 案 症 対策 に 関す る も の で し た 。 こ の 中 核 と な っ た の は 、 競技 大 会 に 参加 する すべ て の 人 を 対象 と し た 安全 上 の ルー ル や 手順 を 記載 し た 複 数 の プレ イブ ッ ク で 、 その 中 に は 新型 コロ ナウ イル ス 感染 症 の 定期 的 な 検査 に 関す る 計画 も 含ま れ て い ます 。 1 2021 年 4 月 、 東 京 スタ ジア ム で 開催 され た 7 人 制 ラ グ ビ ー の テス ト 大 会 で 実施 され た 安全 対策 2 IOC 副 会 長 兼 東京 2020 オ リン ピッ ク 競 技 大 会 調整 委員 長 ジョ ン ・ コ ー ツ 氏 日 本 や 世界 各地 で 新型 コロ ナウ イル ス 感 染 症 の 感染 者 が 増加 する 中 、 日 本 政府 は 海外 か ら の 観客 受 け 入 れ を 中 止 する と の 決定 を 今年 の 3 月 に 発表 し ま し た 。 さら に 、IOC は 入場 を 許可 する 関係 者 を 「( 競 技 大 会 に ) 不可 欠 な 人 員 お よび 運営 人 員 」 の み に 限 定 す る こと を 決定 し まし た 。IOC、 国 際 競 技 宰 盟 、 国 内 オリ ン ピ ッ ク 委 員 会 の すべ て が 、 競技 大 会 に 不可 欠 な 活 動 に の み 、 そ の 努力 と プロ グラ ム を 集中 させ て いま す 。 コー ツ 氏 は 、 総合 的 な 優先 事項 は 「 基 本 に 立ち 返 る 」 こ と 、 そし て 「 あ っ た らい いも の 」 を 削減 し 、 必要 不可 欠 な こと に 集中 し て 、 選手 に と っ て 最良 の 環境 を 提供 する こと だ と 述べ まし た 。 「 今 回 の 競技 大 会 は 、 本 来 の 目的 を 果たす 場 に な り ます 。 選手 に と っ て 、 それ は 競技 を 行う こと で す 。 それ は 今 ま で と 変わ り ま せん 。 トッ プク ラス の 選手 に よる 競い 合い や 仲間 意識 と いっ た 、 オリ ン ピ ッ ク 競 技 大 会 の 中 核 を 成す 部 分 に も 、 変 わり は あり ませ ん 」 デュ ビ 氏 は 「 食 べ 物 や 飲み 物 、 車 の 数 、 必要 な ス ペー ス な ども っ と も あり ふれ た も の も 含め て 、 創造 性 を 発 押す れ ば 物事 を 簡素 化 で きる こと を 、 東京 は 実 「 今 回 の 競技 大 会 は 、 本 来 の 目的 を 果たす 場 に な り ま す 。 選手 に と っ て 、 それ は 競技 を 行う こと で す 」 ジョ ン ・ コ ー ツ 氏 証し て くれ まし た 」 と 振り 返り 、 IOC は 東京 に お ける 規模 縮小 の プロ セス か ら 重 要 な 洞察 を 得 た と 言い ま す 。「 今 回 の 経験 は 、 一 度 現実 的 な 解決 案 を 模索 し 始め る と 、 次 々 と 答え が 見 つか っ て いく こと を 示し て い ます 。 東 京 と いう 状況 下 で 私 た ち が 強 いら れ た こと が 、 将来 へ の 扉 を 開く の で す 。 きっ と 、 私 た ち 全 員 が この よう な 姿勢 を 共有 し て いる と 確信 し て いま す 」 も う 一 つ 、 今後 も 未 永く 生か され る 教訓 は 、 東 京 に お ける デジ タル エン ゲー ジメント か ら も た ら さ れる か も し れ ま せん 。 海 外 の 観客 受け 入れ が 中 止 され た こと を 受け 、 IOC と 放映 権 を 保有 し て いる 放送 局 は 、 まる で 世界 中 の 人 々 を スタ ジア ム や 東京 の 街中 に 招 き 入 れ 、 その 場 に いる か の よう に 競技 大 会 を 臨場 感 た っ ぷり に 体験 し て も ら う 方 法 を 計画 し て いま す 。 「 私 た ち は 、 東京 が 提供 する デジ タル サー ビス を 充 実 さ せま し た 」 と 、 デュ ビ 氏 は 言い ます 。「 人 々 は きっ と デジ タル 化 の 流れ に 心 を 躍ら せる で し ょ う 。 これ は 将来 的 に も 定着 する と 思い ます 。 必ず 、 大 規模 な デジ タル エン ゲー ジメント が 実現 する で し ょ う 」 東京 大 会 の 延期 は 、 パン デミ ッ ク ま た は その 他 の 健康 を 脅かす 危機 へ の 対応 と いう 、 も う 一 つの 貴重 な 長期 的 教訓 を 、 IOC と オリ ン ピ ッ ク ・ ム ー ブ メ ント に も た らし まし た 。 デュ ビ 氏 は 「 私 た ち は 将 来 に 備え な けれ ば いけ ま せん 」 と 話し ます 。「 そ れ は 新型 コロ ナウ イル ス 感 染 症 か も し れ な いし 、 別 の も の か も し れ ま せん 。 組織 に は 、 2 種類 の 管理 体制 が 必要 で す 。 基 本 的 な 運営 を 担う 人 々 、 そし て どの よう な 状況 に も 対応 で きる ア ジャ イル 型 チ ー ム も また 、 必 要 と され て いる の で す 」"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:352px;left:164px;height:15px;width:103px;\">\n        <a href=\"https://intel.com/olympics\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          addContentLinks()\n        }\n\n        function onPageLeave() {\n          removeContentLinks()\n        }\n      ",
    "searchText": " Do something wonderful. Intel has raised the bar for wonderful experiences by accelerating the adoption of new technologies like 5G, artificial intelligence, immersive media, drones, esports event integrations, and through our silicon solutions to enhance the Olympic Games. Together with other TOP Partners, Intel is integrating technology into many facets of the Olympic Games from infrastructure and operations to athlete performance enabling new levels of interaction, connectivity, and data-rich experiences. Find out more at intel.com/olympics intel. WORLDWIDE PARTNER"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 72-title\" style=\"top:105px;left:44px\" src=\"/tokyo2020/static/_content/72-title-1.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:208px;left:42px\" src=\"/tokyo2020/static/_content/72-sub-1.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:266px;left:68px\" src=\"/tokyo2020/static/_content/72-sub-2.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:391px;left:133px\" src=\"/tokyo2020/static/_content/72-sub-3.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:455px;left:197px\" src=\"/tokyo2020/static/_content/72-sub-4.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:519px;left:251px\" src=\"/tokyo2020/static/_content/72-sub-5.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:600px;left:314px\" src=\"/tokyo2020/static/_content/72-sub-6.png\">\n        <img class=\"halfScale 72-sub\" style=\"top:730px;left:433px\" src=\"/tokyo2020/static/_content/72-sub-7.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          if(Publish.isDoublePage){\n            pg72Anim = new TimelineMax();\n            pg72Anim.fromTo(cOf(\"72-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .staggerFromTo(cOf(\"72-sub\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, \"-=0.3\")\n            .staggerFromTo(cOf(\"73-sub\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, \"-=0.2\")\n          } else {\n            pg72Anim = new TimelineMax();\n            pg72Anim.fromTo(cOf(\"72-title\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .staggerFromTo(cOf(\"72-sub\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, \"-=0.3\")\n          }\n        }\n\n        function onPageLeave() {\n          pg72Anim.stop();\n        }\n        ",
    "searchText": " fe ee rae ee > ae fete Maa ee aL Deel ized 72 EWA DPA ee Ose (の) 東京 を 目指 し て Towards Tokyo 昨年 の 歴 喝 的 な 延期 後に 発生 し た 重要 な 出来 事 、 そ し て IO0C、 お よび 東京 2020 オ リン ピッ ク ・ パ ラリ ン ピ ッ ク 競 技 大 会 組織 委員 会 が 下 し た 決定 を 「 オ リン ピッ クレ ビュ ー」 が 振り 返り ます 。 Z0UZ0 aye 2 日 東京 2020 オ リン ピッ ク ・ パ ラリ ン ピ ッ ク 競 技 大 会 が 2021 年 に 延期 され る 25 日 延期 に 伴う 諸 問題 へ の 対処 を 目的 に 、 IOC が 「Here we go」 タス ク フ ォ ー ス と 合同 運営 委員 会 を 発足 3 日 新た な 開催 日 程 が 発表 され る 。 東 京 2020 オ リン ピッ ク 競 技 大 会 は 7 月 23 日 8 月 8 日 、 東京 2020 パ ラリ ン ピ ッ ク 競 技 大 会 は 8 月 24 日 ~ 9 月 5 日 に し 1 日 IOC が パン デミ ッ ク の 渦中 に お いて 、 ス ポー ツ 選 手 と 世界 中 の 人 々 を つなぐ デジ タル ・ キ ャ ン ペ ー ン #StayStrong を 立ち 上 げ る り 月 15 上 日 IOC が 延期 に 伴う 追加 費用 と し て 8 億 米ドル の 負担 を 決定 5 23 日 #StayStrong キ ャ ン ペ ー ン の 一 環 と し て 、 #StayStrong、 #StayActive、 #StayHealthy を 呼び か ける 世界 最大 の オン ライ ン ・ ト レー ニン グ 映 像 を 、 オ リン ピッ ク デ ー に 公開 LEIS Glee chro bm の 267 の 6】 還 コア が コー Al shone eo NS CeCe Bye 17 日 東京 2020 が すべ て の オリ ン ピ ッ ク 競 技 会 場 を 確保 し 、 延期 され た 競技 大 会 の 競技 スケ ジュ ー ル を 確認 し た こと を 発表 2 日 日 程 が 変更 され た 競技 大 会 開催 まで 1 年 を 記念 し 、 オ リン ピッ クス タ ジ ア ム で 式典 が 行わ れる 。 IOC は 同日 、 #StrongerTogether キャ ン ペ ー ン を 立ち 上 げ る 25 日!OC お よび 東京 2020 が 競 撤 大 会 を 系 化し 、 経 費 を 削減 する や  に =e の bs に | Ta ser た め の 50 以 上 に お よぶ 対策 に 同意 ‘ - 28 日 東京 2020 が 2021 年 聖火 リレー の 新た な 日 程 を 発表 es トノ シン ty 28 IOC が 選手 お よび チー ム 関係 者 に 向け て 、 第 2 版 と な る プレ イブ ッ ク を 発行 だ 10 ロ トー マス ・ パ ッ ハ 会 長 が IOC 会 長 に 再選 。 2025 年 まで 2 期 目 を 務め る こと に 12 日 !OC 総 会 が 新た な 戦略 的 ロー ド マ ッ プ と な る オリ ン ピ ッ ク ・ ア ジェ ンダ 2020+5 を 満場 一 致 で 採択 5 日 聖火 リレー が 福島 県 で スタ ー ト を 切る Pepe ie ae eI eco WE eNO NILA ON Lap Soest B NOL 限定 する こと を 決定 rae 3 日 !OC は 東京 2020 オ リン ピッ ク 競 技 大 会 に 出席 する 関係 者 に 向け て 、 感染 拡大 防止 対策 を まとめ た 複数 の プレ イブ ッ ク 初 版 を 発行 18 日 橋本 聖子 氏 が 東京 2020 の 新た な 会 長 と し て 任命 され る la Py eRe essa eee ante ea seme: haa ec 本 来 アテ ネ で 3 月 10 日 ~ 12 日 に 予定 され て いた 137 次 IOC 総 会 を パー チャ ル で 開催 する こと を 決定"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 73-sub\" style=\"top:587px;left:52px\" src=\"/tokyo2020/static/_content/73-sub-1.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:678px;left:116px\" src=\"/tokyo2020/static/_content/73-sub-2.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:208px;left:303px\" src=\"/tokyo2020/static/_content/73-sub-3.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:712px;left:358px\" src=\"/tokyo2020/static/_content/73-sub-7.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:579px;left:412px\" src=\"/tokyo2020/static/_content/73-sub-6.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:379px;left:469px\" src=\"/tokyo2020/static/_content/73-sub-5.png\">\n        <img class=\"halfScale 73-sub\" style=\"top:259px;left:546px\" src=\"/tokyo2020/static/_content/73-sub-4.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          if(Publish.isDoublePage){\n          } else {\n            pg73Anim = new TimelineMax();\n            pg73Anim.staggerFromTo(cOf(\"73-sub\"), 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1)\n          }\n        }\n\n        function onPageLeave() {\n          pg73Anim.stop();\n        }\n        ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 74-title\" style=\"top:111px;left:44px\" src=\"/tokyo2020/static/_content/74-title-1.png\">\n        <img class=\"halfScale 74-title\" style=\"top:241px;left:46px\" src=\"/tokyo2020/static/_content/74-sub-1.png\">\n        <img class=\"halfScale 74-title\" style=\"top:308px;left:47px\" src=\"/tokyo2020/static/_content/74-sub-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.staggerFromTo(cOf(\"74-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg74Anim.stop();\n        }\n        ",
    "searchText": "  74 私 が 参加 し た 競技 大 会 : ド ナ ・ デ バ ロ ナ MY GAMES DONNA DE VARONA 私 が 参加 し た 競技 大 会 ドナ ・ デ バ ロ ナ ロー マ 1960 オ リン ピッ ク 競 技 大 会 、 東 京 1964 オ リン ピッ ク 競 技 大 会 東京 1364 オ リン ピッ ク 競 技 大 会 の 水泳 競技 で 2 つの 金メダル を 獲得 し た ドナ ・ デ パロ ナ 。 それ 以来 、 草 分 け 的 な キャ スタ ー と し て 18 に お よ 記 競技 大 会 で キャ スタ ー を 務め 、 エミ ー 賞 も 受賞 し まし た 。 今回 、 自 分 の 人 生 を 変え た オリ ン ピ ッ ク 体 験 と 、 競 泳 選手 引退 後に 大 き な 影響 力 を 及ぼ し た キャ リア に つい て 、 ス ティ ー ブ ン ・ ウ ィ ル ソン に 語り まし た 。 私 の 初め て の 競技 大 会 ロー マ 1960 オ リン ピッ ク 競 技 大 会 で 、 私 は わずか 13 歳 に し て 最 年 少 の 世界 記録 保持 者 と な り ま し た が 、 悲運 に も 、 当時 自己 ベス ト を 達成 し た 種目 (400m 個 人 メド レー) に 女性 が 出場 する こと は で きま せん で し た 。 当時 の 私 は 、 身長 は わずか 5 フィ ー ト 2 イン チ ( 約 157cm)、 体重 は 100 ポ ンド ( 約 35kg) し か な く 、 イタ リア 人 の オリ ン ピ ッ ク 関 係 者 は ずぶ 濡れ の Neer os 鳴り 続け た の で す よ 。「 プ ー ル デッキ か ら 出 て いけ ! オリ ン ピ ッ ク ブ プー ル に コー チ の 女 は 出入 り 禁 止 だ !」 私 は 4x100m フ リー リレー の 予選 に 出場 する こと で 、 アメ リカ 代表 チー ム が 決勝 戦 に 進出 し ライ バル の オー スト ラリ ア 代 表 チ ー ム に 圧勝 する の に 貢献 し まし た 。 で も 、 当時 は 今 と 違っ て 、 予選 に 出場 し た 競泳 選 手 に は 、 金 メダ ル が 授与 され ませ ん で し た 。 オリ ン ピ ッ ク 村 で 過ごし た 時 間 は 魔法 の よう で し た 。 モハ メド ・ ア リ に 改名 する 前 の シャ イ な カシ アス ・ クレ イ に 出会っ た り 、 陸上 界 の 大 御所 ウィ ル マ ・ ル ドル フ と 生涯 の 友情 を 育ん だ り 、 アメ リカ の 陸上 競技 代表"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Olympic Review"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " 76 私 が 参加 し た 競技 大 会 : ド ナ ・ デ バ ロ ナ の メン バー か ら は 「 ツ イス ト 」 ダ ンス を 教え て も ら っ た り ま し た 。 し か し 、 も っ と も 鮮烈 な 記憶 と し て 残っ た の は 開会 式 で の 出来 事 で し ょ う 。 私 は 、 聖火 ラン ナー が スタ ジア ム に 入場 し て 聖火 台 に 火 を 灯す 様子 を 見 よう と 、 自分 より も 件 か に 背 の 高い 選手 た ちの 後ろ で 背 伸 び を し て いま し た 。 その 時 突然 、 後 っ に いた 背 の 高い 男性 が 私 の 体 を 持ち 上 げ 、 肩車 し て くれ た の で す 。 そ れ は バス ケッ ト ボ ー ル の アメ リカ 人 スタ ー 選 手 、 ウ ォ ル ト ・ ベ ラミ ー で し た 。1960 年 当時 、 黒人 男性 が 白人 女性 の 体 に 触れ る こと は 自ら の 命 を 危険 に 晒す 行為 で し た 。 それで も 、 安全 で 多様 性 に 満ち た オリ ン ピ ッ クコ ミュ ニテ ィ に 身 を 置い て いた ウォ ルト は 、 後 先 を 案 ずる こと な く 、 私 に 手 を 差し 伸 べ て くれ た の で す 。 公民 権 運動 が 盛り 上 が っ て いた 1960 年 代 半ば 、 ウォ ルト と 私 は アメ リカ の 貧困 地区 に 住む 若者 た ちの た め の 支援 プロ グラ ム で 一 緒 に 活動 し まし た 。 ロー マ で の 経 験 を 経て 、 私 の 世界 が 大 きく 広がり まし た 。 そ れ 以 来 、 世界 に 対す る も の の 見 方 が 変わ っ た の で す 。 東京 まで の 道のり ロー マ 大 会 の 後 、 400m 個人 メド レー の 世界 記録 保持 者 で あっ た 私 は 、 ライ バル た ち に 差 を つけ る た め 、 常に 努力 し 続け な けれ ば な り ま せん で し た 。 私 の サク セス スト ー リ ー が 、ABC ネッ トワ ー ク の 番組 「 ワ イド ワー ルド ・ オ ブ ・ ス ポー ツ 」 で 特集 され て か ら 、 周囲 か ら の 期待 が ます ます 高まり まし た 。 14 歳 で 初め て 「 ス ポー ツ ・ イ ラス トレ ー テ ッ ド 」 の 表紙 を 飾っ た こと で 、 私 は 皆 の 注目 の 的 と な り ま し た 。 1961 年 、10 代 の 小さ な 水泳 代表 団 が 、 東 京 1964 オリ ン ピ ッ ク 競 技 大 会 の キャ ン ペ ー ン ツア ー の た め に 日 本 に 招 か れ ま し た 。 日 本 全国 を 旅 し な が ら 、 私 た ち は 第 二 次 世 界 大 戦 が 残し た 、 被 害 の 痕跡 と その 影 響 の 大 き さ を 目 に し まし た 。 皇 居 を 近く に 望む お ホテル に チェ ッ ク イ ン す る と 、 ファ サー ド に 残る 複数 の 弾 痕 が 目 に 飛び 込ん で きま し た 。 し か し 、 水田 に 囲ま れ た 25m ブー ル で 行わ れ た 水泳 大 会 に 参加 し て 、 日 本 人 が どれ ほど 水泳 を 愛し て いる か 実感 で きた こと は 、 私 た ち に と っ て 大 き な 喜 び で し た 。 私 は 、 自 分 1 人 対 若い 日 本 人 男子 の チー ム で の 200m の リレー レー ス を 楽 し み ま し た 。 1963 年 、 アメ リカ 代表 チー ム は オリ ン ピ ッ ク 前 の 招 鴨 試合 に 参加 する た め 、 再び 日 本 を 訪れ まし た 。 都 会 も 田舎 も 、 た っ た 2 年 間 で 劇 的 な 変化 を 遂げ て いま し た 。50m ブ プー ル を 有する 大 阪 の 試合 会 場 は 、 満席 で し た 。 私 た ちの チー ム は 花瓶 、 着物 、 高 機能 カメ ラ 、 装飾 用 メ ダル な ど 、 日 本 伝統 の 贈答 品 を 浴び る よう に 贈ら れ ま し た 。 この よう な 惜しみ な い お も て な し は 、 オ リン ピッ ク ・ ム ー ブ メ ント が 称え る 思い や り と 変革 を 喚 起す る 精神 を 体現 する も の で し た 。 金メダル を 獲得 し た 試合 東京 1964 オ リン ピッ ク 競 技 大 会 開催 前 に 、 私 は すでに 18 も の 世界 記録 と 最速 タダ イム を 打ち 立て て い た の で 、 多く の ジャ ー ナ リス ト が 、 私 が その 時 代 を 代 表す る 女性 競泳 選手 に な る だ ろう と 予想 し て いま し た 。 マス コミ か ら の 応援 に 感謝 は し て いた も の の 、 自分 が すでに 達成 し た こと を 他人 の 期待 に よっ て な い が し る に され た く は な いと 思っ て いま し た 。 開 会 式 中 、 自 分 の 中 で 勝利 へ の 意思 が 湧い て くる の を 感じ まし た 。 優 勝 以外 の 選択 肢 は な い 、 と 。 10 月 15 日 、 4x100m フ リー リレー に 2 番 泳者 と し て 参加 し 、 チ ー ム メイ ト だ っ た シャ ロン ・ ス タウ ダー、 リ リア ン ・「 ポ ー キ ー」・ ワ ト ソ ン 、 キャ シー・ エ リス と 共に 最初 の 金メダル を 獲得 し まし た 。 ま た 、 ライ バル の オー スト ラリ ア 代 表 チ ー ム を 破り 、 新 世 界 記録 4 分 03 秒 8) を 樹立 し まし た 。 自己 ベス ト を 更新 し 、 チ ー ム 内 で 2 番目 に 速い タイ ム を 出す こと と が で き て 大 い に 安 心 し ま し た 。 この リレー 種目 で 優勝 し た こと は 、 その 2 日 後 、 自 分 の 得意 種目 で ある 400m 個人 メド レー で スタ ー ティ ング ブロ ッ ク に 呼ば れる の を 待つ と き の 、 大 き な プレ ッ シ ャ ー を 和らげ て くれ まし た 。 レー ス 当日 、 実は 約 38 度 近い 熟 を 出し て いま し た が 、 こ れ は オリ ン ピ ッ ク 村 で 流行 し た イン フル エン ザ の 影響 だ と と 思わ れ ま す 。 それ で も 、 今回 こそ 、 個人 で オリ ン ピ ッ ク 金 メダ ル を 勝ち 取る チャ ンス だ っ た の で す 。 何 も 私 を 止め る こ と は で きま せん で し た 。 レー ス が 始ま る と 、 私 は 水 と 一 体 に な り 、 まさ に 空中 に 浮い て いる よう な 感覚 を 覚 えま し た 。 スタ ー ト 時 点 か ら ト ッ プ の 座 を 保ち 、 チー ム メイ ト に 6 秒 近 い 差 を つけ て ゴー ル し 、 オリ ン ピ ッ ク 記録 を 出し まし た 。 私 、 シ ャ ロン ・ フ ィ ネ ラン 、 マー サ ・ ラン ドー ル の 3 人 は 、 こう し て 金メダル を 独占 し た の で す 。 観客 司 を 見 上 げた 時 に 母 (マー サ ) と 父 (デヴィ ッ ド ) の 姿 を 見 つけ た こと は 、 この 勝利 を より 一 層 特 別 な も の に し まし た 。 カ リフ ォ ル ニア 大 学 ボ ー ト 部 に 所 属し 、 エイ ト 競 技 で 優勝 経験 の ある 父親 は 、1940 年 に 東京 で 予定 され て いた オリ ン ピ ッ ク 競 技 大 会 が 、 戦争 の た め に 中 止 に は えな ら な けれ ば 、 お そら く 同 大 会 に 参加 し て いた で し ょ う 。 父 は 後に 赤十字 に 勤務 し 、 戦闘 中 に 複数 回 パラ シュ ー ト 部 隊 と 一 緒 に 落下 し た 唯一 の 現場 皿 督 で し た 。 そし て 24 年 が 経ち 、 父 は か つて 敵 の 領土 だ っ た 日 本 で 温か い ホ スト ファ ミリ ー 宅 に ゲス ト と し て 滞在 し 、 娘 が オリ ン ピ ッ ク 金 メダ ル を 勝ち 取る 様子 を 目の当たり に し た の で す 。 こ れ ら 2 つ の 家族 を 結び つけ られ る の は 、 オ リン ピッ ク 競 技 大 会 以外 存在 し ませ ん 。 1 1984 年 ロサ ン ゼ ルス オリ ン ピ ッ ク 競 技 大 会 で 400m バー ドル 種 朋 に 出場 し た 米国 人 選手 エド ウィ ン ・ モ ー ゼ ス 選手 に イン タビ ュー する ドナ ・ デ バ ロ ナ 氏 2 デバ ロナ 氏 は 、 長 年 に わた っ て IOC ウィ メン ・ イ ン ・ ス ポー ツ 要員 会 の メン バー も 務め た"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 77-quote\" style=\"top:779px;left:44px\" src=\"/tokyo2020/static/_content/77-quote-1.png\">\n        <h1 id=\"77-no\" class=\"abs 77-no ohr\" style=\"left: 617px; top: 307px; font-size: 4.5em; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 2 }'></h1>\n        <h1 id=\"77-no\" class=\"abs 77-no ohr\" style=\"left: 583px; top: 529px; font-size: 4.5em; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 13 }'></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg77Anim = new TimelineMax();\n          pg77Anim.staggerFromTo(cOf(\"77-quote\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"77-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"77-no\")[0]);}}, 1.3)\n          .fromTo(cOf(\"77-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"77-no\")[1]);}}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg77Anim.stop();\n          resetNumbers(\"77-no\");\n        }\n        ",
    "searchText": " Olympic Review Issue 116 オリ ン ピ ッ ク 後 の キャ リア 東京 で の 最後 の 競技 を 終え た 帰り 道 、 歩き な が ら 考え て いた こと を 今 で も 覚え て いま す 。「 夢 を 叶え る こと が で きた 。 で も 、 次 に 何 を する の か ?」 大 学 に 進学 する と すれ ば 、 引 退 し な けれ ば いけ な いこ と は わか っ て いま し た 。 私 が 現役 だ っ た 時 代 、 スポ ー ツ 奨 学 金 は 女性 に は 提供 され て お ら ず 、 人 気 の あ る 女性 オリ ン ピ ア ン に 大 き な 収 入 を も た ら す 広告 契約 も 存在 し ませ ん で し た 。 幸運 な こと に 、 東 京 1964 オ リン ピッ ク 競 技 大 会 開催 の 半年 後 、ABC で プロ デュ ー サ ー を 務め て い た チャ ッ ク ・ ハ ワー ド に 「 引 退 と いう 試練 を 乗り 越 えら れる 唯一 の 道 は 、 水泳 の 専門 家 と し て ABC に 雇っ て も ら う こと 」 と 伝え た と ころ 、 快 語 し て も ら え た の で す 。 その 数 週間 後 、17 歳 の 私 は 就労 の 許可 を 得 て 、 史上 最 年 少 で ある だ け で は な く 、 最 初期 の 女性 キャ スタ ー の 一 人 と し て 全国 ネッ ト の 「 ワ イド ワー ルド ・ オ ブ ・ ス ポー ツ 」 に 登場 し 、 男 子 国内 選手 権 の キャ スタ ー を 務め 、 デ ビュ ー を 飾っ た の で す 。 キャ スタ ー と し て 活躍 し て いた 期間 、 私 は 自分 が 携わる 媒体 を 生か し て 、 スポ ー ツ 界 に お ける 女性 た ちの 地位 向上 を 目指 し まし た 。 1960 年 代 半 ば 、 ヒュ ー バ ー ト ・ ハ ン フ リー 米国 副 大 統領 は 、 平和 部 隊 の 設立 を 要請 する 私 の 提案 書 に 応え て くれ まし た 。 その 結果 、「 オ ペレ ーション ・ チ ャ ンプ 」 が 設立 され た の で す 。 アメ リカ 全土 で 公民 権 還 動 が 盛ん に な っ て 情 替 が 不安 定 だ っ た 時 代 、 プロ の スポ ボー ツ 選 手 と オリ ン ピ ッ ク 選 手 が 2 年 か け て 全国 を 回 り 、 貧 困 地 区 に 住む 若者 た ちの た め に や る 気 を 反 き 立て る 講演 や セミ ナー を 実施 し た の で す 。 この プロ グラ ム の 資金 提供 を 要請 する た め に 、 し ば し ば 議 会 に 招 嶋 され て 証言 し な が ら 、 私 は 教育 スポ ー ツ 、 健康 に 関連 する その 他 の 法律 の 発議 に も 取り 組 み 続 け ま し た 。 また 米国 上 院 コ ン サ ル タ ン ト と し て 、 1972 年 に 制定 され た 「 タ イト ル ・ ナ イン (教育 改 正法 第 9 編 )」 の 支援 と 保護 に 貢献 し まし た 。 これ は 、 女 性 が 高校 や 大 学 で スポ ー ツ に 参加 し 、 奨 学 金 を 得る こと を 可能 に し た 法律 で す 。 フォ ー ド 大 統領 の 任命 者 と し て は 、1978 年 オリ ン ピ ッ ク ・ ア マチ ュ アス ポー ツ 法 の 制定 を 通じ て 米国 の オリ ン ピ ッ クコ ミュ ニテ ィ を 再編 し た 委員 会 に 参加 し まし た 。 ク リ ント ン 大 統領 の 任命 者 と し て は 、 世界 アン チ ・ ド ー 「 ロ ー マ で の 経験 を 経て 、 私 の 世界 が 大 きく 広がり まし た 。 それ 以来 、 世 界 に 対す る も の の 見 方 が 変わ っ た の で す 。」 ドナ ・ デ バ ロ ナ ピン グ 機 構 (WADA) と 米国 アン チ ・ ド ー ピ ング 機構 (USADA) の 設立 に 協力 し まし た 。 し か し 、 も っ と も 大 き な や り が い を 感じ た 経験 は 、 アメ リカ で 1999 年 に 開催 され た FIFA 女 子 ワ ー ル ドカ ッ プ 大 会 を 成功 させ た こと で し ょ う 。 1974 年 に は 女性 スポ ー ツ 財団 が 設立 され まし た 。 私 は 初代 議長 と し て 、 男 性 優位 の スポ ー ツ 団体 の 世界 で 、 当 時 も それ 以降 も 正当 な 扱い を 受け て いな い 女 性 スポ ー ツ 選手 た ちの た め に 、 影響 力 の ある 居場所 を 設立 すべ く 春 走 し まし た 。 IOC 女 性 スポ ー ツ 委員 会 で は 数 十 年 に わた っ て 活 動 し まし た 。 現在 は IOC コ ミュ ニケ ーション 委員 会 の メン バー を 務め て お り 、 最近 、 アメリカ ・ オ リン ピッ ク ・ パラ リン ピッ ク 委 員 会 (USOPC) の 一 員 と し て 選出 さ れ ま し た 。 まさ か 、 自分 の 全 人 生 を 通じ て スポ ー ツ 界 に 深く 根 を 下ろ す と は 夢 に も 思い ませ ん で し た 。 2021 年 に 開催 され る 東京 2020 大 会 今年 の 夏 は 、 延 期 さ れ た オリ ン ピ ッ ク 競 技 大 会 の た め に ぜひ 東京 に 戻り た いと 思っ て いま し た 。 来場 で き な い 大 勢 の 方 々 と 同じ よう に 、 私 も 残念 に 思っ て いま す が 、 新型 コロ ナウ イル ス 感 染 症 の 感染 拡大 が 継続 し て いる 以上 、 日 本 人 と 競技 大 会 の 安全 と 安心 を 確 保 す る こと は 必要 不可 欠 で す 。 日 本 も 、 そ し て 世界 も 、 競技 大 会 の 開催 を 必要 と し て いる と 私 は 信じ て いま す 。200 以 上 の 国々 が オリ ン ピ ッ ク ・ ム ー ブ メ ント の 信念 を 共に 分 か ち 合 うと き 、 私 た ち は 今 一 度 、 自分 た ちの 可能 性 の 大 き さ を 只 現 化す る こと で し ょ う 。 そし て 夢 を 持ち 続け よう と 必死 に 努力 し て きた 選手 た ち が 、 再び 世界 に 気づき と 希望 を も た ら す の で す 。 ファ クト ファ イル 代表 選手 と し て の 戦歴 tatty ase * x aa 金メダル 45 個 400m 個 人 メド レー (東京 1964 オ リン ピッ ク 競 技 大 会 ) 4x100m フ リー リレー (東京 1964 オ リン ピッ ク 競 技 大 会 ) オリ ン ピ ッ ク 競 技 大 会 で デビ ュー を 飾っ た と き の 年 齢 606 IOC オ リン ピッ ク ・ オ ー ダ ー Biba 2020 年 、USOPC 理 事 に 選出 され る "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 78-title\" style=\"top:118px;left:45px\" src=\"/tokyo2020/static/_content/78-title-1.png\">\n        <img class=\"halfScale 78-title\" style=\"top:184px;left:45px\" src=\"/tokyo2020/static/_content/78-sub-1.png\">\n\n        <div class=\"addContentLink\" style=\"top: 299px;left: 41px;height: 133px;width: 89px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/210614/japan-through-the-lens-of-the-tokyo-olympics-ed-by-barbara-holthus-et-al\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 299px;left: 260px;height: 133px;width: 117px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/211018/the-history-of-the-olympic-games-faster-higher-stronger-an-official-publication-of-the-olympic-found\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 299px;left: 479px;height: 133px;width: 97px;\">\n          <a href=\"https://library.olympics.com/Default/doc/SYRACUSE/207018/sport-values-in-every-classroom-teaching-respect-equity-and-inclusion-to-8-12-year-old-students-unes\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top: 828px;left: 384px;height:13px;width: 108px;\">\n          <a href=\"https://www.olympics.com/ioc/olympic-studies-centre\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 828px;left: 234px;height: 13px;width: 148px;\">\n          <a href=\"mailto:studies.centre@olympic.org\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 842px;left: 247px;height:13px;width: 119px;\">\n          <a href=\"https://www.facebook.com/olympicstudiescentre\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top: 841px;left: 368px;height: 13px;width: 114px;\">\n          <a href=\"https://library.olympics.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.staggerFromTo(cOf(\"78-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks()\n        }\n        ",
    "searchText": " 78 オリ ン ピ ッ ク ・ ス タデ ィ ー ズ オリ ン ピ ッ ク ・ ス タデ ィ ー ズ OLYMPIC STUDIES オリ ン ピ ッ ク に つい て の 知識 を 提供 する 1OC オ リン ピッ ク ・ スタ ディ ー ズ ・ セ ンタ ー ※ タ イト ル は すべ て 原題 で す 。 JAPAN THROUGH THE LENS OF THE TOKYO OLYMPICS 東京 2020 オ リン ピッ ク 競 技 大 会 は 、1 年 延期 さ れ た に も か か わら や 現代 日 本 が 抱 え る 諸 間 題 を 見 つめ 直す きっ か け を も た らし 、 すでに 日 本 に 大 き な レ ガ シ ー を 残し まし た 。 日 本 の スポ ー ツ お よび 社会 に 関す る 専門 家 ら が 拉 筆 し た 、 こ の オー プン アク セス の 学術 書 は 、 競技 大 会 、 そ し て 開 催 国 全 体 を 知る た め の 手 が か り と な る 、 興味 深 い 一 冊 で す 。 多岐 に わた る トピ ッ ク を 網羅 し た 内 容 は 、 競技 大 会 に 対す る 知ら れ ざ る 洞察 や 新た 人 様々 な 側面 を 考慮 する こ に より 、 本 書 は オリ ン ピ ッ ク 競 技 大 会 を 控え る 本 いか に 東京 2020 を 形成 する と 同時 に 、 それ に より いか に 形成 され た か を 概観 し ます 。 著者 : バーバラ ・ ホ ルト ス 、 ア イザ ッ ク ・ ガ ー ニ エ 、 ヴ ォ ル フラ ム ・ マ ン ツ ェ ン ライ ター、 フ ラン ツ ・ ヴ ァ ル デン ベル ガー 出版 社 : ラ ウト レッ ジ 、 2020 年 、 ISBN 9780367469573、 143 頁 、 英 語 に よる 最新 の ブッ クレ ビュ ー。 ーーーー ヒー ニー  THE HISTORY OF THE OLYMPIC GAMES: FASTER, HIGHER, STRONGER IOC の 協力 に よっ て 出版 され た 『The History of the Olympic Games: Faster, Higher, Stronger』 は 、 オ リン ピッ ク 競 技 大 会 で 繰り 広 げ ら れ た 栄光 の 歴史 を 生き 生き と 再現 し て いま す 。 古代 ギリ シャ か ら 現 代 に 至る まで 、 これ まで 開催 され た すべ て の 競技 大 EMME T SA Bld オリ ン ピ ッ クシ ー ン を 飾っ た 数 々 の 栄光 を 紹介 し て いま す 。200 点 以上 の 写真 に 加え 、 オ リン ピッ クミ ュー ジア ム に 所 蔵 さ れ て いる 稀少 な 資料 や 歴史 的 アイ テム を 収録 。 こ の 書籍 は 、 スポーツ 史 に 残る 多く の 偉業 を 振り 返る こと で 、 興味 の 尽き る こと の な い 賞 賛 す べき オリ ン ピ ッ ク の 歴史 を HIBRLES. 閉 者: 国際 オリ ン ピ ッ ク 委 員 会 出版 社 : ウ ェ ル ベッ ク 出 版 グ ルー ズ 2021 年 、 ISBN 9781787394049、 160 頁 、 英 語 BULL WETS INJEMERY; CLASSROOM TUX He] ee gy tems oo SPORT VALUES IN EVERY CLASSROOM: TEACHING RESPECT, EQUITY AND INCLUSION TO 8-12-YEAR-OLD STUDENTS IOC が 世界 中 の 8…12 歳 の 児童 の た め に 製作 し た 無料 の ツー ルキ ッ ト 。: っ Be 本 と し アク ティ ビ テ ィ を 奨励 し な が ら 、 尊 重 、 公 平 性 、 協 調 な ど 、 スポ ー ツ の 代名詞 と も いえ る 基礎 的 な 価値 観 を 指導 する こと が で きま す 。 この ツー ルキ ッ ト は 教 師 の 専門 教科 を 問わ ず 、 児童 に か か わり を 持つ 人 な ら 誰 で も 使う こと が で きま す 。 英 語 版 、 フ ラン スズ 語 版 、 ス ペイ ン 語 版 が あり ます 。 著者 : ユネ スコ 、 オ リン ピッ ク 文 化 遺 産 財 団 、 ア ギ ト ス 財団 、 WADA、 国 際 ス ポー ツ 科 学 ・ 体 育 協議 会 、 国際 フェ アプ レー 委員 会 出版 社 : ユネ スコ 、 OFCH、 ア ギ ト ス 財団 、 ICSSPE/CIEPSS、 CIFP、 2019 年 、 ISBN 9789231003516, 1865, 2828 WADA, 歴史 的 研究 、 事 実 調査 、 学 術 的 研究 、 図 書館 資源 、 書 籍 貸与 に 関す る 詳細 は 、 オ リン ピッ ク ・ ワ ー ル ド ・ ラ イブ ラリ ー、 詳細 は こち ら また は 以下 まで お 問い 合わ せく だ さい 。 & studies.centre@olympic.org @ olympic.org/studies f OlympicStudiesCentre 人 library.olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " Delivering the excitement to the world A Better Life, A Better World Panasonic became the Worldwide Olympic Partner in 1988, and the Worldwide Paralympic Partner in 2014. Panasonic Worldwide Worldwide Olympic Partner Paralympic Partner QO | Qo"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 80-title\" style=\"top:101px;left:46px\" src=\"/tokyo2020/static/_content/80-title-1.png\">\n        <img class=\"halfScale 80-title\" style=\"top:163px;left:44px\" src=\"/tokyo2020/static/_content/80-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.staggerFromTo(cOf(\"80-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n        }\n        ",
    "searchText": " 80 sh 8 OBITUARIES ah 3 CHRANKEAVVEPT VY RBELOAV VEYA h-T Av ble Hdok AZ CRMORERLETS. ルン アル ん と タイ リト 10C 名 状 委 員 で あり 1981 年 に 2 人 選出 され た 初 の 女性 I0C 委 員 の 一 人 と し て 歴史 に 名 を 残し た 先 肛 者 オリ ン ピ ッ ク ・ ム ー ブ メ ント に お ける ジェ ンダ ー 平 等 に 取り 組み 、 女性 の 進出 を 牽 引 し た フロ ー ル ・ イ サヴァ ・ フ ォ ン セカ 氏 が 99 歳 で 逝 夫 し まし た 。 フォ ン セ カ 氏 は 、 1981 年 に 2 人 選出 され た 初 の 女性 IOC 委員 の 一 人 で あり 、 また 1990 年 か ら 1994 年 まで は 初 の 女性 IOC 理 事 会 委員 も 務め まし た 。 フォ ン セ カ 氏 は オリ ン ピ ア ン で も あり 、1956 年 の 大 会 に ベネ ズ エ ラ 代 表 と し て 馬術 競技 に 出場 し て いま す 。 ギュ ン ツ ァ ー ル ・ ヘ イン ツ 氏 IOC 名 誉 委員 の ギュ ン ツ ァ ー ル ・ ヘ イン ツ 氏 が 97 歳 で 逝去 し まし た 。IOC 委 員 と し て 熱心 に 職務 に 従事 し た ヘイ ン ツ 氏 は 、1990 年 の ドイ ツ 再 統一 後 、 自ら 辞任 を 申し 出る こと と で 、 ドイ ツ に お ける スポ ー ツ の 再 編成 に 向け て 道 を 切り 開き まし た 。 政治 学 の 学位 を 持 ち 、 公 職 に あっ た ヘイ ン ツ 氏 は と り わ け バ スケ ッ ト ボ ー ル に 深く 関 り 、1952 年 か ら 1956 年 まで 国際 バス ケッ ト ボ ー ル 連盟 の 審判 を 始め た ほか 、 スポ ー ツ ・ ア ドミ ニス トレ ーション の 分 野 で 数 多く の 功績 を 残し まし た 。 1992 年 に は IOC 名 誉 委員 と な り ま し た 。 李 健 弁 ( イ ・ ゴ ン ヒ ) 氏 1987 年 か ら 2020 年 まで サム スン グル ー プ の 会 長 を 務め た 李 健 昭 氏 が 78 歳 で 逝去 し まし た 。 李 氏 は 、 大 韓 民国 の 一 国内 企業 で あっ た サム スン を 、 デ ク ノロ ジー の 分 野 で 世界 を 率 引 する 存在 に 、 そし て ワー ルド ワイ ド オ リン ピッ ク パ ー ト ナー へ と 成長 させ た 功 労 者 で す 。 自身 もし スリ ング を た し な ん で いた 座 氏 は 、 1996 年 に IOC 委 員 と し て 選出 され 、1997 年 に は 文 化 委 員 会 、1998 年 か ら 1999 年 まで は 財務 委員 会 に 参加 し まし た 。 そ し て 2017 年 に IO 名誉 委員 に 就任 し 、 1991 年 に は オリ ン ピ ッ ク ・ オ ー ダ ー を 受 癌 し まし た 。 ダビ ト ・ ド ッシュ マン 氏 フェ ン シ ン グ の 伝説 的 な コー チ で あり 、 アウ シュ ビッ ツ 強 制 収容 所 を 解放 し た 部 隊 の 隊員 で 、 唯一 の 存命 者 で も あっ た ダビ ト ・ ド ゥ シュ マン 氏 が 98 歳 で 逝去 し まし た 。 ドゥ シュ マン 氏 は ロシア の エリ ー ト クラ ブ で ある スパ ル タ ク モス クワ の コー チ に 就任 し 、 1952 年 か ら 1988 年 まで 旧 ソ 連 代 表 女 子 チ ー ム の コー チ を 務め 、 数 多く の オリ ン ピ ッ クチ ャ ン ピ オ ン を 育て 上 げ ま し た 。 同氏 が ミュ ン ヘ ン に 所 有する クラ ブ で は 、94 歳 に な る まで ぼぼ 毎日 フェ ン シ ン グ 選 手 の 指導 に 当たっ て いま し た 。 ドゥ シュ マン 氏 は 、 第 二 次 世界 大 戦 当 時 ロシア 軍 の 少佐 を 務め 、1945 年 1 月 27 日 に アウ シュ ビッ ツ 強 制 収 容 所 の 収容 者 の 解放 に 携わり まし た 。 ウォ ルツ ァ ー・ ト リョ ガー 氏 IOC 名 誉 委員 の ウォ ルツ ァ ー・ ト リョ ガー 氏 が 91 歳 で 逝去 し まし た 。 スポ ー ツ ・ ア ドミ ニス トレ ー タ ー と し て の トリ ョ ガー 氏 の 素晴らし い 功 績 は 、 数 十 年 に 渡っ て ドイ ツ に お ける スポ ー ツ の 発展 に 尽力 し た こと に 象徴 され ます 。 1970 年 か ら 1992 年 まで は ドイ ツ 国 内 オリ ン ピ ッ ク 委 員 会 の 専務 理事 を 、 そ し て 2002 年 まで の 10 年 間 は 会 長 を 歴任 。 ま た 、1976 年 と 2002 年 に は オリ ン ピ ッ ク 冬 季 競 技 大 会 で 統括 喜 任 者 を 務め た ほか 、 ミュ ン ヘ ン 1972 オ リン ピッ ク 競 技 大 会 で は オリ ン ピッ ク 選 手 村 村 長 の 立場 に あっ た こと か ら 、 人 質 と し て 捕らえ られ た イス ラ エル 人 選手 の 解放 を 求め る 交 渉 に も 関わ り ま し た 。 その 後 、1983 年 か ら 1990 年 まで IOC ス ポー ツ デ ィ レ クタ ー と し て 活躍 し 、1989 年 に IOC の 委員 、 そ し て 2010 年 に は 名 誉 委員 と な り まし た 。 フェ ルナ ンド ・ リ マ ・ ベ ロ 氏 オリ ン ピ ア ン で あり 、 また スポ ー ツ ・ ア ドミ ニス ト レー ター の フェ ルナ ンド ・ リ マ ・ ベ ロ 氏 が 89 歳 で 逝 去 し まし た 。1968 年 の メキ シコ シディ 大 会 と 1972 年 の ミュ ン ヘ ン 大 会 で は 、 ポ ルト ガル 代表 選手 と し て セー リン グ 競 技 に 出場 し まし た 。 その 後 、 ポル ト ガ ルオ リン ピッ ク 委 員 会 の 委員 長 と な り 、1989 年 か ら 2010 年 まで は IOC 委 員 を 歴任 。2010 年 に IOC 名 誉 委員 と な り ま し た 。 と の ペー ジ に 掲載 され て いる 方 々 を は じ め 、 昨年 無く な られ た 方 々 の ご 遺族 や 身近 な 方 々 に 対し て 、 IOC は 心 よ り お 悔やみ を 申し 上 げ ま す 。"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " Olympic Review Issue 116 81 に に ae バル セロ ナ 1992 大 会 に お ける 男子 71 kg 級 種 目 で 金メダル を 獲得 し た 日 本 人 柔道 家 で 、 引 退 後 は 熱心 な コー チ と し て 活躍 し まし た 。 柔道 で 3 度 の オリ ン ピ ッ ク 競 技 大 会 出場 を 果 た し 、 オリ ン ピ ッ ク メ ダ ル を 2 の 個 獲得 し た 古人 賀 入 彦氏 が 、 53 歳 で 逝去 し まし た 。2 度 目 の 出場 と な p た バル セロ ナ 1992 大 会 で ほ 男 子 71kg 級 の 種目 で 金メダル を 、 4 年 後 の アト ラン タダ 大 会 で は 78 の eee, ウル スラ ・ ハ ッ ペ 氏 メル ボル ン 1956 オ リン ピッ ク 競 技 大 会 、 女子 200m 平泳ぎ の 種目 で 金メダル を 獲得 し た ウル スラ ・ ハッ ペ 氏 が 94 歳 で 逝去 し まし た 。 過去 の 功績 が 認め られ て 1954 年 と 1956 年 に ドイ ツ の 最 優秀 女性 ス ポー ツ 選 手 に 選出 され た ほぼ ほか 、 ドイ ツ の スポ ー ツ 界 で 最高 の 栄誉 で ある シル バー ロー レル リリ ー フ ( 銀 の 月 桂樹 資 ) を 受賞 し まし た 。 ハー コン ・ ブ ルス ベー ン 氏 ノル ウェ ー 人 クロ スカ ント リー スキ ー 選 手 の ハ ー コ ン ・ ブ ルス ペー ン 氏 が 93 歳 で 逝去 し まし た 。 ブ ルス ベー ン 氏 は オリ ン ピ ッ ク 競 技 大 会 に 2 度 出 場 、 ス コー バ レー1960 冬季 オリ ン ピ ッ ク 競 技 大 会 の クロ スカ ント リー スキ ー 男 子 15km 種目 で 金メダル を 獲得 し 、 男子 4x10km リ レー で も 銀メダル を 獲得 。 後 に ノル ウェ ー の 放送 局 NNRK で スポ ー ツ コメ ン デ ー タ ー と し て 活躍 し まし た 。 し まし た 。 また 、1989 年 か ら 1995 年 の 間 、 世 界 柔 道 選手 権 で 3 度 の 優勝 を 成し遂げ まし た 。 2000 年 に 引退 後 は 全日 本 柔道 加 較 女子 只 他 計 員 を 務め 、 アテ ネ 2004 大 会 で 教え 子 の 谷 BERET ERS WEST SO MLE し た 。 リー・ エ バン ス 氏 オリ ン ピ ッ ク 競 技 大 会 に お いて 、2 種目 で 金メダル を 獲得 し た アメ リカ 人 陸上 競技 選手 、 リ ー・ エ バン ス 氏 が 74 歳 で 逝去 し まし た 。 エ バン ス 氏 は 、 メキ シコ シテ ィ ー 1968 大 会 に お いて 400m と 4x400m リ レー に 出場 。 両 種目 で 世界 記録 を 塗り 替え る と 共に ニニ つ の 金メダル を 獲得 し まし た 。 競技 引退 後 は 国連 で 勤務 する か た わら 、 コー チ と し て ナイ ジェ リア と サ ウジ アラ ビア の 代表 チー ム の 指導 に 尽力 し まし た 。 ジョ ン ・ コ ン ラ ッ ズ 氏 オリ ン ピ ッ ク 金 メダ リス ト の オー スト ラリ ア 人 氷 泳 選手 、 ジ ョ ン ・ コ ン ラ ッ ズ 氏 が 78 歳 で 近 去 し まし た 。 コン ラッ ズ 氏 は ロー マ 1960 大 会 に お いて 、 男子 1500m 自 由 形 で の 金メダル を 含む 三 つ の メダ ル を 獲 得 し まし た 。 引 退 後 は 水泳 コー チ と し て 活躍 し 、 そ の 後 シド ニー 2000 大 会 で は 希 致 活動 に 頁 献 。 スポ ー ツ オー スト ラリ ア 典 堂 入り も 果たし まし た 。 コン ・ フ ィ ン ド レー 氏 オリ ン ピ ッ ク 競 技 大 会 に 4 度 出場 し 、 ボ ー ト と セー リ ング で メダ ル を 獲得 し た 実績 を 持つ ココ ン ・ フ ィ ン ド レー 氏 が 90 歳 で 逝去 し まし た 。 メル ボル ン 1956 大 会 と 東京 1964 大 会 で は ボー ト 競 技 の 男子 能 手 付き ペア 種目 で 金メダル を 、 ロー マ 1960 大 会 で は 同種 目 で 銅メダル を それ ぞ れ 獲得 し ま し た 。 その 後 12 年 間 の ブラ ンク を 経て 出場 し た モン ト リオ ー ル 1976 大 会 で は 、 セー リン グ の 男子 デン ペ ス ト 級 種目 で 銅メダル を 獲得 し て 見 事 カ ム バ ッ ク を 果 た し まし た 。 ディ アナ ・ イ ガリ 氏 ハン ガリ ー 人 クレ ー 射 撃 選 手 で 2 度 の オリ ン ピ ッ ク メ ダ リス ト に 輝い た ディ アナ ・ イ ガリ 氏 が 56 歳 で 逝去 し まし た 。 イ ガリ 氏 は シド ニー 2000 オ リン ピッ ク 競 技 大 会 の スキ ー ト 種目 で 銅メダル 、4 年 後 の アテ ネ 大 会 で は 金メダル を それ ぞ れ 獲得 し まし た 。 また 、 世界 選手 権 で は 4 回 、 ヨー ロッ パ 選 手 権 で 6 回 の 優勝 を 飾り まし た 。 "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 82-title\" style=\"top: 101px;left: 43px;\" src=\"/tokyo2020/static/_content/82-title-1.png\">\n        <img class=\"halfScale 82-sub-1\" style=\"top: 104px;left: 309px;\" src=\"/tokyo2020/static/_content/82-sub-1.png\">\n\n        <img class=\"halfScale 82-sub-2\" style=\"top: 202px;left: 59px;\" src=\"/tokyo2020/static/_content/82-sub-2.png\">\n        <img class=\"halfScaleC 82-icon-1\" style=\"top: 202px;left: 59px;\" src=\"/tokyo2020/static/_content/82-icon-1.png\">\n        <img class=\"halfScale 82-sub-3\" style=\"top: 321px;left: 51px;\" src=\"/tokyo2020/static/_content/82-sub-3.png\">\n        <img class=\"halfScaleC 82-icon-2\" style=\"top: 315px;left: 30px;\" src=\"/tokyo2020/static/_content/82-icon-2.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 115px;top: 406px;font-size: 1.4em;font-weight: 400;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 58, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-4\" style=\"top: 475px;left: 45px;\" src=\"/tokyo2020/static/_content/82-sub-4.png\">\n        <img class=\"halfScaleC 82-icon-3\" style=\"top: 499px;left: 59px;\" src=\"/tokyo2020/static/_content/82-icon-3.png\">\n        <img class=\"halfScale 82-sub-5\" style=\"top: 612px;left: 60px;\" src=\"/tokyo2020/static/_content/82-sub-5.png\">\n\n        <img class=\"halfScale 82-line-1\" style=\"top: 261px;left: 228px;\" src=\"/tokyo2020/static/_content/82-line-1.png\">\n        <img class=\"halfScaleC 82-green-1\" style=\"top: 32px;left: 27px;\" src=\"/tokyo2020/static/_content/82-green-1.png\">\n\n        <img class=\"halfScale 82-sub-6\" style=\"top: 213px;left: 267px;\" src=\"/tokyo2020/static/_content/82-sub-6.png\">\n        <img class=\"halfScale 82-sub-7\" style=\"top: 232px;left: 268px;\" src=\"/tokyo2020/static/_content/82-sub-7.png\">\n        <img class=\"halfScaleC 82-icon-4\" style=\"top: 202px;left: 211px;\" src=\"/tokyo2020/static/_content/82-icon-4.png\">\n        <img class=\"halfScale 82-line-2\" style=\"top: 313px;left: 387px;\" src=\"/tokyo2020/static/_content/82-line-2.png\">\n        <img class=\"halfScale 82-sub-8\" style=\"top: 225px;left: 431px;\" src=\"/tokyo2020/static/_content/82-sub-8.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 451px;top: 276px;font-size: 1.3em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 5000, \"comma\": true}'></h1>\n        <p class=\"82-no-append abs\" style=\"left: 493px;top: 283px;font-size: 0.7em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\">\u500B</p>\n        <img class=\"halfScaleC 82-icon-5\" style=\"top: 277px;left: 426px;\" src=\"/tokyo2020/static/_content/82-icon-5.png\">\n        <img class=\"halfScale 82-line-3\" style=\"top: 313px;left: 516px;\" src=\"/tokyo2020/static/_content/82-line-3.png\">\n        <img class=\"halfScaleC 82-icon-6\" style=\"top: 216px;left: 539px;\" src=\"/tokyo2020/static/_content/82-icon-6.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 581px;top: 366px;font-size: 1.3em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 24.5, \"decimals\": 1}'></h1>\n        <p class=\"82-no-append abs\" style=\"left: 610px;top: 373px;font-size: 0.8em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\">\u30C8\u30F3</p>\n        <img class=\"halfScale 82-sub-9\" style=\"top: 314px;left: 552px;\" src=\"/tokyo2020/static/_content/82-sub-9.png\">\n        <img class=\"halfScale 82-line-4\" style=\"top: 412px;left: 266px;\" src=\"/tokyo2020/static/_content/82-line-4.png\">\n        <img class=\"halfScaleC 82-icon-7\" style=\"top: 386px;left: 235px;\" src=\"/tokyo2020/static/_content/82-icon-7.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 290px;top: 451px;font-size: 1.9em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 99, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-10\" style=\"top: 458px;left: 357px;\" src=\"/tokyo2020/static/_content/82-sub-10.png\">\n        <img class=\"halfScaleC 82-icon-8\" style=\"top: 391px;left: 429px;\" src=\"/tokyo2020/static/_content/82-icon-8.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 553px;top: 431px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 65, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-11\" style=\"top: 458px;left: 555px;\" src=\"/tokyo2020/static/_content/82-sub-11.png\">\n        \n        <img class=\"halfScale 82-sub-12\" style=\"top: 551px;left: 252px;\" src=\"/tokyo2020/static/_content/82-sub-12.png\">\n        <img class=\"halfScaleC 82-icon-9\" style=\"top: 567px;left: 225px;\" src=\"/tokyo2020/static/_content/82-icon-9.png\">\n        <img class=\"halfScale 82-sub-13\" style=\"top: 584px;left: 341px;\" src=\"/tokyo2020/static/_content/82-sub-13.png\">\n        <img class=\"halfScaleC 82-icon-10\" style=\"top: 554px;left: 466px;\" src=\"/tokyo2020/static/_content/82-icon-10.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 581px;top: 582px;font-size: 1.3em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 26000, \"comma\": true }'></h1>\n        <p class=\"82-no-append abs\" style=\"left: 632px;top: 590px;font-size: 0.7em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\">\u53F0</p>\n        <img class=\"halfScale 82-sub-14\" style=\"top: 611px;left: 582px;\" src=\"/tokyo2020/static/_content/82-sub-14.png\">\n        \n        <img class=\"halfScale 82-line-5\" style=\"top: 655px;left: 44px;\" src=\"/tokyo2020/static/_content/82-line-5.png\">\n        \n        <img class=\"halfScale 82-sub-15\" style=\"top: 673px;left: 45px;\" src=\"/tokyo2020/static/_content/82-sub-15.png\">\n        <img class=\"halfScaleC 82-icon-11\" style=\"top: 678px;left: 29px;\" src=\"/tokyo2020/static/_content/82-icon-11.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 82px;top: 792px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 30, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-16\" style=\"top: 820px;left: 54px;\" src=\"/tokyo2020/static/_content/82-sub-16.png\">\n        <img class=\"halfScale 82-line-6\" style=\"top: 748px;left: 142px;\" src=\"/tokyo2020/static/_content/82-line-6.png\">\n        <img class=\"halfScaleC 82-icon-12\" style=\"top: 620px;left: 171px;\" src=\"/tokyo2020/static/_content/82-icon-12.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 268px;top: 816px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 25, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-17\" style=\"top: 844px;left: 213px;\" src=\"/tokyo2020/static/_content/82-sub-17.png\">\n        <img class=\"halfScale 82-line-7\" style=\"top: 747px;left: 351px;\" src=\"/tokyo2020/static/_content/82-line-7.png\">\n        <img class=\"halfScaleC 82-icon-13\" style=\"top: 621px;left: 334px;\" src=\"/tokyo2020/static/_content/82-icon-13.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 431px;top: 815px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 27, \"append\": \"%\" }'></h1>\n        <img class=\"halfScale 82-sub-18\" style=\"top: 844px;left: 389px;\" src=\"/tokyo2020/static/_content/82-sub-18.png\">\n        <img class=\"halfScale 82-line-8\" style=\"top: 683px;left: 507px;\" src=\"/tokyo2020/static/_content/82-line-8.png\">\n        <img class=\"halfScaleC 82-icon-14\" style=\"top: 621px;left: 494px;\" src=\"/tokyo2020/static/_content/82-icon-14.png\">\n        <img class=\"halfScale 82-sub-19\" style=\"top: 810px;left: 546px;\" src=\"/tokyo2020/static/_content/82-sub-19.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no ohr\" style=\"left: 640px;top: 806px;font-size: 1.4em;color: #231F20;padding: 0px;margin: 0px;opacity: 1;\" data-number='{\"to\": 30, \"append\": \"%\" }'></h1>\n      \n        <div class=\"addContentLink\" style=\"top: 200px;left: 60px;height: 22px;width: 135px;\">\n          <a href=\"https://www.youtube.com/watch?v=674_AuH_jkw\" target=\"_blank\"></a>\n        </div>\n\n        ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.fromTo(cOf(\"82-title\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"82-sub-1\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-2\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-1\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-3\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-2\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-4\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-3\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-5\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-1\"), 0.3, {opacity:0, y:60}, {opacity:1, y:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-green-1\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-sub-6\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-7\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-4\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-2\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-8\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[1]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-5\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-3\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-6\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[2]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-no-append\")[0], 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-9\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-4\"), 0.3, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-7\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[3]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-no-append\")[1], 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-10\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-8\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[4]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-11\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-12\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-9\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-13\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-10\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[5]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-14\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-5\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-15\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-11\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[6]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-no-append\")[2], 0.6, {opacity:0, x:30}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-16\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-6\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-12\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[7]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-17\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-7\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-13\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[8]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-18\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-line-8\"), 0.3, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-14\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\")\n          .fromTo(cOf(\"82-sub-19\"), 0.6, {opacity:0, x:60}, {opacity:1, x:0, ease: Power4.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[9]);addContentLinks();}}, \"-=0.4\")\n          \n        }\n\n        function onPageLeave() {\n          pg82Anim.stop();\n          resetNumbers(\"82-no\");\n          removeContentLinks();\n        }\n      ",
    "searchText": " 82 ファ スト ファ クト QP すべ て の 参加 者 に 安全 な 環境 を 提供 し つつ 、 持続 可能 な 方 法 で 第 32 回 オリ ン ピ ッ ク 競 技 大 会 (2020 ン 東京 ) を 開催 する た め の 基本 事項 と デー タ を ご 紹介 し ます 。 ファ スト ファ クト より クリ ー ン な 競技 大 会 リサ イク ル 家電 製品 を 再生 利用 し て これ まで に 日 本 国内 か ら 寄 付 され た 物資 : か っ 2 製作 し た オリ ン ピ ッ ク メ ダ ル お よび パラ リン ピッ ク メダ ル の 数 B 5,000 a Rn 聖火 台 と オリ ン ピ ッ ク 聖 火 リ レー の オリ ン ピ ッ ク オリ ン ピ ッ ク と パラ リン ピッ ク の 人 ーー N / 98 の 表彰 台 夫 製作 する た め に トー チ の 点火 に ゼロ エミ ッ シ ョ ン の 水素 を 利用 RS ん 合い て ©) プラ スチ ッ ク の 量 24.5 ト ン 0 58% 0 55% 99% 調達 物資 の うち 、 リ サイ クル 東京 2020 で 競技 大 会 東京 2020 で 使用 され る 設備 の 589% に 0 また は 再 利用 し た 比率 開催 中 に 発生 し た 廃棄 物 の うち 、 既存 また は 仮設 の 施設 を 利用 し 、 建 設 を 景 小 限 に 再 利用 また は リサイ クル され る 抑え る こと に よっ て コス ト と 排出 ガス を 削減 比率 (予定 ) © オリ ン ピ ッ ク 選 手 村 ( = BA TSEAIT RD OI RGN ICA 26,0004 en a 使っ て 、 選 手 村 ビ レッ ジ プ ラ ザ を 建設 。 会 場 は バイ オマ ス や 太陽 府 か ら 発電 し た ( ( 一 = 競技 大 会 開催 後 は 、 解 体 さ れ た 木材 を の ベッ ド は 、 ほ ぼ す べ て 再生 可能 電気 を 利用 公共 施設 用 の 建築 材 と し て 再 利用 リサ イク ル ダ ン ボー ル か ら 製 作 放送 © {| »®.. 8 | 30% リオ 2016 開催 時 と 比べ て 、 25% 27% 縮小 し た 放送 拠点 の 比率 国際 放送 セン ター の 規模 を 縮小 し た 比率 報道 キャ スタ ー 数 を 削減 し た 比率 その 一 方 で 、 制 作 さ れる 0 コン テン ツ が 増加 し た 比率 9 0 6"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": " e-Palette On-Demand, Customizable, Self-Driving Platform of the Future IF YOU CAN DREAM IT, IT CAN BE IT. START YOUR IMPOSSIBLE TOYOTA Olympic Partner Paralympic Partner Toyota prototypes shown. Not available fer sale. ©2020 Toyota Motor Corporation. All rights reserved. i"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THOUSANDS COMPETE MILLIONS PLAY BILLIONS INSPIRED  Thanks to our Worldwide Olympic Partners  Aycirbnb €2- Aman⑩ AtoS Lb  BRIDGESTONE  ra oer <S> intel. OMEGA  Panasonic © SAMSUNG TOYOTA VISA  #Strongerlogether "
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-199016370-6',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5b41c140b06e9440c9da.js